var map = {
	"./__now_routes_g4t5bY.json": [
		"IPM1",
		19
	],
	"./camera.json": [
		"5juQ",
		20
	],
	"./chunk-map.json": [
		"X0Uj",
		21
	],
	"./contacts_rHKivRGhCUjtyGBXJrQP.json": [
		"jaW9",
		22
	],
	"./icon.json": [
		"0jOl",
		6
	],
	"./jobs.json": [
		"HZAm",
		23
	],
	"./manifest.json": [
		"TZne",
		24
	],
	"./page-data/404.html/page-data.json": [
		"ndhA",
		25
	],
	"./page-data/404/page-data.json": [
		"oWGd",
		26
	],
	"./page-data/app-data.json": [
		"uzhO",
		27
	],
	"./page-data/dev-404-page/page-data.json": [
		"R2Kx",
		28
	],
	"./page-data/en/2-4ghz-ulp-ban-radio/page-data.json": [
		"E2bW",
		29
	],
	"./page-data/en/2-4ghz-ulp-pan-radio/page-data.json": [
		"O+HJ",
		30
	],
	"./page-data/en/200mm-GaN-on-Si-technology/page-data.json": [
		"Ea6q",
		31
	],
	"./page-data/en/2035/page-data.json": [
		"8m/P",
		32
	],
	"./page-data/en/3D-system-integration/page-data.json": [
		"A39s",
		33
	],
	"./page-data/en/3D-thin-film-battery/page-data.json": [
		"2e0e",
		34
	],
	"./page-data/en/404/page-data.json": [
		"PA5f",
		35
	],
	"./page-data/en/5G-and-wireless-iot-communication/high-speed-analog-rf/page-data.json": [
		"XBBf",
		36
	],
	"./page-data/en/5G-and-wireless-iot-communication/page-data.json": [
		"YNJF",
		37
	],
	"./page-data/en/5G-and-wireless-iot-communication/ultra-wide-band-uwb-technology/page-data.json": [
		"ygu2",
		38
	],
	"./page-data/en/79GHz-140GHz-radar-automotive-applications/page-data.json": [
		"X0aY",
		39
	],
	"./page-data/en/79GHz-140GHz-radar-systems/page-data.json": [
		"5UkD",
		40
	],
	"./page-data/en/79GHz-140GHz-radar-systems/sensor-data-fusion/page-data.json": [
		"+SCt",
		41
	],
	"./page-data/en/79GHz-and-140GHz-radar-solutions/8-GHz-radar-for-smart-buildings/page-data.json": [
		"xyRG",
		42
	],
	"./page-data/en/79GHz-and-140GHz-radar-solutions/harrad/page-data.json": [
		"DAym",
		43
	],
	"./page-data/en/79GHz-and-140GHz-radar-solutions/page-data.json": [
		"my+8",
		44
	],
	"./page-data/en/79GHz-and-140GHz-radar-solutions/sign-up-for-your-free-white-paper-enabling-connected-cars-and-smart-highways/page-data.json": [
		"B+gz",
		45
	],
	"./page-data/en/79GHz-and-140GHz-radar-solutions/sign-up-for-your-free-white-paper-ensuring-a-secure-and-comfortable-driving-experience/page-data.json": [
		"aWe/",
		46
	],
	"./page-data/en/79GHz-and-140GHz-radar-solutions/sign-up-for-your-free-white-paper-unlocking-the-full-power-of-adas/page-data.json": [
		"dl3S",
		47
	],
	"./page-data/en/79GHz-and-140GHz-radar-solutions/whitepaper-imec-automotive-series/page-data.json": [
		"/Xs3",
		48
	],
	"./page-data/en/8-channel-EEG-readout-ASIC-for-Dry-Electrodes/page-data.json": [
		"TOA2",
		49
	],
	"./page-data/en/Analog-Mixed-Signal-IP-Analog-Front-Ends-for-wearable-health-applications/page-data.json": [
		"7Kj4",
		50
	],
	"./page-data/en/Biomedical-AFE/page-data.json": [
		"Rbeu",
		51
	],
	"./page-data/en/CREW-for-a-more-efficient-use-of-the-wireless-spectrum/page-data.json": [
		"gybR",
		52
	],
	"./page-data/en/Delta-Sigma-modulator/page-data.json": [
		"wQDX",
		53
	],
	"./page-data/en/Digital-Core-IP-Communication-Error-Correction-Detection/page-data.json": [
		"DG2k",
		54
	],
	"./page-data/en/Digital-Core-IP-Processor-VLIW/page-data.json": [
		"1ddu",
		55
	],
	"./page-data/en/IDRad/page-data.json": [
		"Gifw",
		56
	],
	"./page-data/en/Imec-Ultra-Low-Power-IoT-and-5G-Wireless/page-data.json": [
		"hOCN",
		57
	],
	"./page-data/en/MUSEIC1.1/page-data.json": [
		"wAka",
		58
	],
	"./page-data/en/O&O/eu-funded-research/eu-funded-research-smart-cities/page-data.json": [
		"nwhU",
		59
	],
	"./page-data/en/O&O/eu-funded-research/eu-funded-research-smart-education/page-data.json": [
		"Bep5",
		60
	],
	"./page-data/en/O&O/eu-funded-research/eu-funded-research-smart-energy/page-data.json": [
		"UL2W",
		61
	],
	"./page-data/en/O&O/eu-funded-research/eu-funded-research-smart-health/page-data.json": [
		"RPIF",
		62
	],
	"./page-data/en/O&O/eu-funded-research/eu-funded-research-smart-industries/page-data.json": [
		"0ohY",
		63
	],
	"./page-data/en/O&O/eu-funded-research/eu-funded-research-smart-mobility/page-data.json": [
		"C6uO",
		64
	],
	"./page-data/en/O&O/eu-funded-research/page-data.json": [
		"dpZp",
		65
	],
	"./page-data/en/O&O/page-data.json": [
		"AUTQ",
		66
	],
	"./page-data/en/R&D-for-life-sciences-applications/page-data.json": [
		"Thde",
		67
	],
	"./page-data/en/about-us/call-for-exhibitors-at-futuresummits-2020-belgium-demo-area/page-data.json": [
		"itOT",
		68
	],
	"./page-data/en/about-us/discover-imec/page-data.json": [
		"NJvx",
		69
	],
	"./page-data/en/about-us/imec-magazine/contact-form-imec-magazine/page-data.json": [
		"Pi6O",
		70
	],
	"./page-data/en/about-us/page-data.json": [
		"+aOG",
		71
	],
	"./page-data/en/academy/9th-international-rram-mram-workshop/page-data.json": [
		"uFd7",
		72
	],
	"./page-data/en/academy/page-data.json": [
		"lygg",
		73
	],
	"./page-data/en/academy/the-7th-imec-stanford-international-workshop-on-resistive-memories/page-data.json": [
		"tv3M",
		74
	],
	"./page-data/en/adc-11-bit/page-data.json": [
		"XQAO",
		75
	],
	"./page-data/en/adc-11-enob/page-data.json": [
		"+UJp",
		76
	],
	"./page-data/en/adc-11bit-410ms/page-data.json": [
		"tfxj",
		77
	],
	"./page-data/en/adc-14bit-200ms/page-data.json": [
		"kk0N",
		78
	],
	"./page-data/en/adc-6bit/page-data.json": [
		"bHdX",
		79
	],
	"./page-data/en/advanced-nano-interconnects/page-data.json": [
		"pyGU",
		80
	],
	"./page-data/en/advanced-patterning-and-key-process-steps/page-data.json": [
		"mz5i",
		81
	],
	"./page-data/en/advisory-board-meeting-2019/page-data.json": [
		"hxp9",
		82
	],
	"./page-data/en/agenda/11th-europractice-photonic-integrated-circuit-training/page-data.json": [
		"78fy",
		83
	],
	"./page-data/en/agenda/4s-symposium/page-data.json": [
		"/5M9",
		84
	],
	"./page-data/en/agenda/Founders-Anonymous-leadership-stress-and-conflicts/page-data.json": [
		"6LT1",
		85
	],
	"./page-data/en/agenda/advanced-engineering_4/page-data.json": [
		"X5v7",
		86
	],
	"./page-data/en/agenda/and/page-data.json": [
		"WY9Y",
		87
	],
	"./page-data/en/agenda/applied-power-electronics-conference-2020/page-data.json": [
		"necN",
		88
	],
	"./page-data/en/agenda/autosens-bxl/page-data.json": [
		"MEPc",
		89
	],
	"./page-data/en/agenda/autosens-us/page-data.json": [
		"HhqE",
		90
	],
	"./page-data/en/agenda/bio-us_2/page-data.json": [
		"Jucw",
		91
	],
	"./page-data/en/agenda/bioprocess-international-conference/page-data.json": [
		"enjW",
		92
	],
	"./page-data/en/agenda/business-healthcare-strategies/page-data.json": [
		"inh3",
		93
	],
	"./page-data/en/agenda/business-meets-ai/page-data.json": [
		"HTmZ",
		94
	],
	"./page-data/en/agenda/cell-therapy-and-manufacturing-asia/page-data.json": [
		"bTAz",
		95
	],
	"./page-data/en/agenda/chipex2018/page-data.json": [
		"VDwx",
		96
	],
	"./page-data/en/agenda/cleo_2/page-data.json": [
		"Ug8j",
		97
	],
	"./page-data/en/agenda/defects-workshop-2020/page-data.json": [
		"g0SR",
		98
	],
	"./page-data/en/agenda/design-of-medical-devices-conf/page-data.json": [
		"obxn",
		99
	],
	"./page-data/en/agenda/digital-medicine-congress/page-data.json": [
		"DLd+",
		100
	],
	"./page-data/en/agenda/ecoc2020/page-data.json": [
		"a3oH",
		101
	],
	"./page-data/en/agenda/edm-forum-electronic-product-development/page-data.json": [
		"Ds+6",
		102
	],
	"./page-data/en/agenda/essential-verification-with-systemverilog/page-data.json": [
		"wGhW",
		103
	],
	"./page-data/en/agenda/from-virtual-to-indistinguishable/page-data.json": [
		"wu75",
		104
	],
	"./page-data/en/agenda/future-summits/page-data.json": [
		"229o",
		105
	],
	"./page-data/en/agenda/hardware-efficient-machine-learning-designing-across-the-algorithm-architecture-circuit-stack/page-data.json": [
		"jvX7",
		106
	],
	"./page-data/en/agenda/healthcare-sensor-innovations-2020/page-data.json": [
		"sU3T",
		107
	],
	"./page-data/en/agenda/human-robot-interaction/page-data.json": [
		"sgxp",
		108
	],
	"./page-data/en/agenda/imaps-uk-microtech-2020-advanced-packaging/page-data.json": [
		"OdC7",
		109
	],
	"./page-data/en/agenda/imec-leti-workshop-iedm-on-site/page-data.json": [
		"qwTV",
		110
	],
	"./page-data/en/agenda/info-session-on-the-imec-icon-program-call/page-data.json": [
		"PZxJ",
		111
	],
	"./page-data/en/agenda/inspire-conference-2020/page-data.json": [
		"zlIh",
		112
	],
	"./page-data/en/agenda/international-microwave-symposium/page-data.json": [
		"rOU0",
		113
	],
	"./page-data/en/agenda/internet-of-things-convention_4/page-data.json": [
		"XSqj",
		114
	],
	"./page-data/en/agenda/intersolar_3/page-data.json": [
		"ZrzW",
		115
	],
	"./page-data/en/agenda/introduction-to-nanoscale-cmos-technology-process-flow-and-process-modules/page-data.json": [
		"rRor",
		116
	],
	"./page-data/en/agenda/investors-day/page-data.json": [
		"O9ZA",
		117
	],
	"./page-data/en/agenda/iss-europe-2021/page-data.json": [
		"xIBE",
		118
	],
	"./page-data/en/agenda/isscc/page-data.json": [
		"8Gah",
		119
	],
	"./page-data/en/agenda/itf-japan_4/page-data.json": [
		"iBsA",
		120
	],
	"./page-data/en/agenda/itf-photonics-2020/page-data.json": [
		"8G5D",
		121
	],
	"./page-data/en/agenda/itf-usa_2/page-data.json": [
		"bxuh",
		122
	],
	"./page-data/en/agenda/iwa-world-water-congress-exhibition/page-data.json": [
		"2moJ",
		123
	],
	"./page-data/en/agenda/knowledge-for-growth_4/page-data.json": [
		"/0N4",
		124
	],
	"./page-data/en/agenda/life-on-chip-conference/page-data.json": [
		"oibf",
		125
	],
	"./page-data/en/agenda/page-data.json": [
		"KMgO",
		126
	],
	"./page-data/en/agenda/remote-vital-sign-monitoring-technologies-for-the-new-standard-of-care/page-data.json": [
		"3rBh",
		127
	],
	"./page-data/en/agenda/secure-proximity-key-to-driver-comfort-and-safety/page-data.json": [
		"L0qu",
		128
	],
	"./page-data/en/agenda/semi-virtual-healthtech-summit/page-data.json": [
		"KnDz",
		129
	],
	"./page-data/en/agenda/semicon-china/page-data.json": [
		"SxoB",
		130
	],
	"./page-data/en/agenda/semicon-europa_4/page-data.json": [
		"3/d/",
		131
	],
	"./page-data/en/agenda/sensors-expo-conference/page-data.json": [
		"wHcL",
		132
	],
	"./page-data/en/agenda/sensors-solutions-international-conference/page-data.json": [
		"7VEE",
		133
	],
	"./page-data/en/agenda/sid-display-week-2020/page-data.json": [
		"vH30",
		134
	],
	"./page-data/en/agenda/smart-city-expo-world-congress/page-data.json": [
		"8ChE",
		135
	],
	"./page-data/en/agenda/solidify-kick-off-meeting/page-data.json": [
		"gLH2",
		136
	],
	"./page-data/en/agenda/spie-bios_3/page-data.json": [
		"D6Nd",
		137
	],
	"./page-data/en/agenda/spie-defense-commercial-sensing_2/page-data.json": [
		"kDv9",
		138
	],
	"./page-data/en/agenda/spie-photonex-2020/page-data.json": [
		"u4Et",
		139
	],
	"./page-data/en/agenda/spie-photonics-europe/page-data.json": [
		"OdTx",
		140
	],
	"./page-data/en/agenda/spie-photonics-west_6/page-data.json": [
		"uMYA",
		141
	],
	"./page-data/en/agenda/supernova-2020/page-data.json": [
		"bVDO",
		142
	],
	"./page-data/en/agenda/supernova/for-curious-citizens/page-data.json": [
		"zKMq",
		143
	],
	"./page-data/en/agenda/supernova/for-industry/page-data.json": [
		"4OVJ",
		144
	],
	"./page-data/en/agenda/supernova/for-smart-cities/page-data.json": [
		"NUmX",
		145
	],
	"./page-data/en/agenda/supernova/for-start-ups-scale-ups-investors/page-data.json": [
		"2waW",
		146
	],
	"./page-data/en/agenda/supernova/page-data.json": [
		"G2Ju",
		147
	],
	"./page-data/en/agenda/the-invisible-future-of-respiratory-monitoring/page-data.json": [
		"/4vV",
		148
	],
	"./page-data/en/agenda/the-medtech-conference/page-data.json": [
		"O7Ll",
		149
	],
	"./page-data/en/agenda/the-rto-innovation-summit_2/page-data.json": [
		"zTEc",
		150
	],
	"./page-data/en/agenda/tsmc-symposium_3/page-data.json": [
		"EvD/",
		151
	],
	"./page-data/en/agenda/using-in-cabin-radar-to-improve-driver-comfort-and-safety/page-data.json": [
		"00dw",
		152
	],
	"./page-data/en/agenda/virtual-semicon-west/page-data.json": [
		"6Zvj",
		153
	],
	"./page-data/en/agenda/vision_2/page-data.json": [
		"pIax",
		154
	],
	"./page-data/en/agenda/visionary-seminar-on-technology-acceptance-in-industry/page-data.json": [
		"DXTl",
		155
	],
	"./page-data/en/agenda/webinar-perovskites-the-energy-mainstream-of-the-thirties-coming-out-of-the-lab-soon/page-data.json": [
		"dqfH",
		156
	],
	"./page-data/en/agenda/whispers_3/page-data.json": [
		"dTzs",
		157
	],
	"./page-data/en/agenda/wireless-technologies-for-iot-connectivity-where-are-we-today/page-data.json": [
		"6U1L",
		158
	],
	"./page-data/en/agenda/world-city-summit/page-data.json": [
		"/PS7",
		159
	],
	"./page-data/en/amicsa-2018-registration/page-data.json": [
		"qVY0",
		160
	],
	"./page-data/en/application-for-admission-imec-phd-programme/page-data.json": [
		"Cppj",
		161
	],
	"./page-data/en/articles/12-technical-highlights-for-2019/page-data.json": [
		"4NOx",
		162
	],
	"./page-data/en/articles/200-million-follow-up-funding-85-start-ups-that-survive-and-a-battery-of-successful-scale-ups-this-flemish-accelerator-takes-part-in-the-world-top/page-data.json": [
		"9m3g",
		163
	],
	"./page-data/en/articles/2d-based-single-photon-emitters-integrated-with-cmos-compatible-silicon-nitride-waveguides/page-data.json": [
		"ohN/",
		164
	],
	"./page-data/en/articles/50-of-video-overlay-ads-on-free-live-streaming-flis-websites-prove-to-be-malicious/page-data.json": [
		"9FEc",
		165
	],
	"./page-data/en/articles/New-imec-istart-fund-strengthens-offer-for-Flemish-tech-start-ups/page-data.json": [
		"Ohh2",
		166
	],
	"./page-data/en/articles/Six-new-start-ups-join-imec-istart-program/page-data.json": [
		"Njj+",
		167
	],
	"./page-data/en/articles/a-60-ghz-phased-array-front-end-chip-for-multi-gb-s-5g-and-small-cell-backhaul-applications/page-data.json": [
		"3Y9F",
		168
	],
	"./page-data/en/articles/a-miniature-microfluidics-heat-sink-for-high-performance-chip-cooling/page-data.json": [
		"k6zi",
		169
	],
	"./page-data/en/articles/a-sige-bicmos-based-100gbaud-analog-time-interleaver-for-datacenters/page-data.json": [
		"RYql",
		170
	],
	"./page-data/en/articles/a-smart-radar-system-for-gesture-recognition-and-non-contact-vital-signs-monitoring/page-data.json": [
		"C6VO",
		171
	],
	"./page-data/en/articles/aloxy-raises-2m-to-launch-its-iot-solution-for-the-chemical-industry/page-data.json": [
		"gpl0",
		172
	],
	"./page-data/en/articles/antwerp-blockchain-pilot-pioneers-with-secure-and-efficient-document-workflow/page-data.json": [
		"PP1O",
		173
	],
	"./page-data/en/articles/antwerpen-bouwt-een-capital-of-things-uit/page-data.json": [
		"X385",
		174
	],
	"./page-data/en/articles/ascent-delivered-access-to-2-billion-of-state-of-the-art-facilities-for-100-global-research-projects/page-data.json": [
		"7k/q",
		175
	],
	"./page-data/en/articles/asics-allow-cost-effective-ip-protection-for-technology-inventions/page-data.json": [
		"QXH7",
		176
	],
	"./page-data/en/articles/audi-brussels-introduces-cobot-walt-a-new-generation-of-robot-in-its-production-line/page-data.json": [
		"J+sB",
		177
	],
	"./page-data/en/articles/battery-day-2020-shifting-gears-to-solid-state-battery-technology/page-data.json": [
		"45SY",
		178
	],
	"./page-data/en/articles/belgian-team-secures-million-dollar-funding-from-chan-zuckerberg-initiative/page-data.json": [
		"BROM",
		179
	],
	"./page-data/en/articles/beyond-belgium-imec-s-media-start-ups-explore-the-german-market/page-data.json": [
		"ZYUg",
		180
	],
	"./page-data/en/articles/boosting-personal-marketability-and-professional-development/page-data.json": [
		"eRYh",
		181
	],
	"./page-data/en/articles/breakthrough-thin-film-solar-cells-generate-as-much-energy-as-traditional-solar-cells-for-the-first-time/page-data.json": [
		"6ktU",
		182
	],
	"./page-data/en/articles/bringing-european-parallel-programming-technology-to-the-exascale-era/page-data.json": [
		"gJlY",
		183
	],
	"./page-data/en/articles/building-patterns-from-the-bottom-a-complementary-approach-to-lithography/page-data.json": [
		"DQFI",
		184
	],
	"./page-data/en/articles/cartamundi-imec-and-holst-centre-win-best-product-award-at-printed-electronics-europe/page-data.json": [
		"zKxI",
		185
	],
	"./page-data/en/articles/ceo-luc-van-den-hove-it-is-our-duty-to-start-preparing-for-the-post-corona-era/page-data.json": [
		"/UQD",
		186
	],
	"./page-data/en/articles/chestnote-the-slow-messaging-app-breaking-the-barriers-of-time-and-space/page-data.json": [
		"ytsr",
		187
	],
	"./page-data/en/articles/chip-technology-and-photonics-enable-smaller-faster-and-cheaper-medical-devices/page-data.json": [
		"K0iW",
		188
	],
	"./page-data/en/articles/circusol-solar-power-business-models-towards-a-circular-economy-in-europe/page-data.json": [
		"b2gM",
		189
	],
	"./page-data/en/articles/city-of-antwerp-flanders-and-imec-building-a-smart-city-living-lab-together/page-data.json": [
		"uz4Z",
		190
	],
	"./page-data/en/articles/combining-large-corporations-market-reach-with-start-ups-innovation-power/page-data.json": [
		"/nQW",
		191
	],
	"./page-data/en/articles/cpt-and-imec-holst-centre-demonstrate-1250-ppi-fmm-free-multicolor-oled-displays-with-photolithography/page-data.json": [
		"5zlZ",
		192
	],
	"./page-data/en/articles/cw-wdm-msa-group-forms-to-drive-new-industry-standard-for-optical-laser-sources/page-data.json": [
		"ttO9",
		193
	],
	"./page-data/en/articles/cyient-acquires-semiconductor-firm-ansem-n-v/page-data.json": [
		"0tQt",
		194
	],
	"./page-data/en/articles/de-krook-openingsweekend/page-data.json": [
		"st5s",
		195
	],
	"./page-data/en/articles/deknudt-mirrors-and-group-de-keyzer-turn-to-imec-to-develop-innovative-new-mirror-with-simultaneous-front-and-rear-views/page-data.json": [
		"J2b0",
		196
	],
	"./page-data/en/articles/deltaray-enables-zero-defect-product-manufacturing/page-data.json": [
		"J6F4",
		197
	],
	"./page-data/en/articles/develop-your-application-with-imec-s-compact-lens-free-microscope-demo-kit/page-data.json": [
		"1kbd",
		198
	],
	"./page-data/en/articles/dialysecentra-az-sint-lucas-gent-volledig-papierloos-dankzij-innovatieve-mobiele-applicatie/page-data.json": [
		"nXpu",
		199
	],
	"./page-data/en/articles/digitrans-spin-off-of-uantwerpen-and-imec-provides-data-driven-logistics-solution-for-the-transport-sector/page-data.json": [
		"+ARm",
		200
	],
	"./page-data/en/articles/ectosense-completes-seed-financing-with-saffelberg-investments/page-data.json": [
		"nfy7",
		201
	],
	"./page-data/en/articles/eeg-headset-for-emotion-detection-and-world-s-largest-multisensor-dataset-on-stress-detection-presented-at-ces-2018/page-data.json": [
		"IkQv",
		202
	],
	"./page-data/en/articles/enables-a-new-european-initiative-enabling-sustainable-energy-solutions-for-iot-applications/page-data.json": [
		"iQT2",
		203
	],
	"./page-data/en/articles/energyville-opens-new-research-building-and-proposes-multi-energy-system-of-the-future/page-data.json": [
		"IiDU",
		204
	],
	"./page-data/en/articles/engie-and-energyville-collaborate-on-future-smart-energy-systems/page-data.json": [
		"cEv5",
		205
	],
	"./page-data/en/articles/ensuring-new-classroom-apps-will-get-good-grades-from-users/page-data.json": [
		"0tDU",
		206
	],
	"./page-data/en/articles/epigan-welcomes-fpim-as-5th-investor-to-globally-execute-its-market-strategy/page-data.json": [
		"PHxg",
		207
	],
	"./page-data/en/articles/epilog-launches-automated-preoperative-eeg-analysis-tool-epilog-preop/page-data.json": [
		"CZga",
		208
	],
	"./page-data/en/articles/epilog-technology-improves-diagnosis-of-epilepsy-using-automated-eeg-analysis/page-data.json": [
		"iSHH",
		209
	],
	"./page-data/en/articles/erc-starting-grant-to-revolutionize-the-efficiency-cost-and-stability-of-thin-film-solar-cells/page-data.json": [
		"Gw1d",
		210
	],
	"./page-data/en/articles/espresso-an-ambitious-eu-funded-collaboration-to-make-perovskite-solar-cells-a-market-reality/page-data.json": [
		"d/xi",
		211
	],
	"./page-data/en/articles/eu-industrial-leadership-gets-boost-through-launch-of-three-advanced-pilot-lines-in-photonics/page-data.json": [
		"94hM",
		212
	],
	"./page-data/en/articles/eu-project-caladan-set-to-reduce-manufacturing-cost-of-terabit-s-capable-optical-transceivers/page-data.json": [
		"iwyo",
		213
	],
	"./page-data/en/articles/eu-project-launches-2-4m-competition-to-create-ethical-and-sustainable-wearable-technologies-and-smart-textiles/page-data.json": [
		"Ku30",
		214
	],
	"./page-data/en/articles/eu-project-qameleon-to-develop-the-next-generation-of-photonics-and-electronics-technology-that-will-enable-128-gbaud-optical-data-flow-generation-reception-and-switching-over-an-sdn-platform/page-data.json": [
		"wqOl",
		215
	],
	"./page-data/en/articles/eu-research-project-ultimategan-energy-saving-chips-made-from-new-material-as-a-turbo-for-renewable-energy-e-mobility-and-co2-savings/page-data.json": [
		"Yl3A",
		216
	],
	"./page-data/en/articles/europe-invests-50-million-in-secure-and-safe-automated-systems/page-data.json": [
		"aaI4",
		217
	],
	"./page-data/en/articles/europe-secures-europractice-services-to-european-academia-and-industry-until-end-2021/page-data.json": [
		"6F8t",
		218
	],
	"./page-data/en/articles/european-nanoelectronics-infrastructure-now-open-for-access/page-data.json": [
		"6wIH",
		219
	],
	"./page-data/en/articles/european-powerbase-to-explore-the-next-generation-power-devices/page-data.json": [
		"WBod",
		220
	],
	"./page-data/en/articles/european-research-institutes-and-industry-partners-join-forces-to-develop-high-performance-solar-panels-with-improved-environmental-profiles/page-data.json": [
		"QMrV",
		221
	],
	"./page-data/en/articles/eutelsat-konnect-satellite-built-by-thales-alenia-space-now-in-orbit/page-data.json": [
		"6f5U",
		222
	],
	"./page-data/en/articles/everything-gets-smart-and-imec-can-give-a-helping-hand/page-data.json": [
		"n+B3",
		223
	],
	"./page-data/en/articles/evonetix-collaborate-with-imec-to-scale-up-chip-based-technology-production-for-third-generation-dna-synthesis-platform/page-data.json": [
		"aoqI",
		224
	],
	"./page-data/en/articles/eyeco-eyeco-een-spin-off-van-imec-en-de-universiteit-gent-ontwikkelt-een-digitale-bril/page-data.json": [
		"YcsX",
		225
	],
	"./page-data/en/articles/fashion-designer-jasna-rok-showcases-collection-based-on-smart-plastics-and-smart-textiles/page-data.json": [
		"re1u",
		226
	],
	"./page-data/en/articles/first-millimeter-scale-wireless-transceiver-for-electronic-pills/page-data.json": [
		"D/1P",
		227
	],
	"./page-data/en/articles/first-of-a-kind-tunable-balance-network-for-electrical-balance-duplexers-supporting-all-lte-bands-from-0-7-1ghz/page-data.json": [
		"+56H",
		228
	],
	"./page-data/en/articles/first-time-demonstration-of-a-plastic-12-bit-rfid-tag-and-read-out-system-with-screen-printed-antenna/page-data.json": [
		"TSK+",
		229
	],
	"./page-data/en/articles/flemish-government-increases-financial-support-of-imec/page-data.json": [
		"p98G",
		230
	],
	"./page-data/en/articles/flexible-fingerprint-sensors-promise-embedded-secure-access-control/page-data.json": [
		"vVBT",
		231
	],
	"./page-data/en/articles/flexible-rfid-tags-for-a-smarter-interconnected-world/page-data.json": [
		"B827",
		232
	],
	"./page-data/en/articles/floods-you-ll-soon-be-able-to-see-them-coming-well-in-advance/page-data.json": [
		"hHKN",
		233
	],
	"./page-data/en/articles/freedom-trust-and-commitment/page-data.json": [
		"6BQf",
		234
	],
	"./page-data/en/articles/from-innovative-idea-to-market-ready-product-imec-services-helps-companies-worldwide/page-data.json": [
		"Eu91",
		235
	],
	"./page-data/en/articles/groot-potentieel-voor-digitale-tools-in-vlaamse-gezondheidszorg/page-data.json": [
		"x7FV",
		236
	],
	"./page-data/en/articles/grow-your-talent-at-our-academy/page-data.json": [
		"C9nr",
		237
	],
	"./page-data/en/articles/growing-a-mobile-microeconomy/page-data.json": [
		"qGin",
		238
	],
	"./page-data/en/articles/heterogeneous-iii-v-cmos-technologies-for-beyond-5g-rf-front-end-modules/page-data.json": [
		"8HON",
		239
	],
	"./page-data/en/articles/holst-centre-demos-world-s-most-transparent-large-area-optical-fingerprint-sensor/page-data.json": [
		"FmBl",
		240
	],
	"./page-data/en/articles/homeflow-van-antwerpse-start-up-minze-maakt-het-urologen-mogelijk-om-patinten-thuis-te-diagnosticeren-en-op-te-volgen/page-data.json": [
		"y2xj",
		241
	],
	"./page-data/en/articles/how-do-you-lead-in-innovation-follow-the-user/page-data.json": [
		"4/6v",
		242
	],
	"./page-data/en/articles/how-nanoelectronics-is-set-to-change-your-water-quality-monitoring-system-join-the-water-eco-system-revolution/page-data.json": [
		"pgIH",
		243
	],
	"./page-data/en/articles/how-our-imec-istart-ventures-doubled-their-follow-up-funding-in-only-1-5-years/page-data.json": [
		"yW91",
		244
	],
	"./page-data/en/articles/how-the-web-failed-its-own-inventor/page-data.json": [
		"PFxS",
		245
	],
	"./page-data/en/articles/how-to-get-a-server-rack-in-your-back-pocket/page-data.json": [
		"MzIc",
		246
	],
	"./page-data/en/articles/how-we-hire-our-talent/page-data.json": [
		"vq0k",
		247
	],
	"./page-data/en/articles/icolung-for-chest-ct-in-covid-19-receives-ce-marking/page-data.json": [
		"dX2m",
		248
	],
	"./page-data/en/articles/idronect-connecting-users-and-authorities-for-easier-and-safer-drone-flights/page-data.json": [
		"lcKQ",
		249
	],
	"./page-data/en/articles/imec-achieves-record-low-contact-resistivity-on-ga-doped-ge-source-drain-contacts-for-pmos-transistors/page-data.json": [
		"yO0s",
		250
	],
	"./page-data/en/articles/imec-achieves-record-low-source-drain-contact-resistivity-for-pmos-transistors/page-data.json": [
		"safd",
		251
	],
	"./page-data/en/articles/imec-adds-uv-sensing-capabilities-to-its-portfolio-of-ccd-in-cmos-based-time-delay-integration-imagers/page-data.json": [
		"WBSV",
		252
	],
	"./page-data/en/articles/imec-advances-200mm-gan-on-si-technology-closer-to-manufacturing/page-data.json": [
		"2u/H",
		253
	],
	"./page-data/en/articles/imec-advances-drive-current-in-vertical-3d-nand-memory-devices/page-data.json": [
		"cGHh",
		254
	],
	"./page-data/en/articles/imec-and-analog-devices-sign-strategic-research-partnership-for-development-of-next-generation-iot-devices/page-data.json": [
		"LA0y",
		255
	],
	"./page-data/en/articles/imec-and-arm-collaborate-on-design-technology-co-optimization-for-7nm-technology-and-beyond/page-data.json": [
		"Y4mw",
		256
	],
	"./page-data/en/articles/imec-and-asml-enter-next-stage-of-euv-lithography-collaboration/page-data.json": [
		"5GCU",
		257
	],
	"./page-data/en/articles/imec-and-besi-demonstrate-long-term-reliability-of-ni-cu-ag-plated-solar-modules/page-data.json": [
		"r2N1",
		258
	],
	"./page-data/en/articles/imec-and-besi-successfully-demonstrate-long-term-reliability-of-pv-module-based-on-ni-cu-ag-plated-solar-cells/page-data.json": [
		"t2o7",
		259
	],
	"./page-data/en/articles/imec-and-bloomlife-showcase-prototype-of-world-s-first-wearable-5-channel-ecg-chip-to-monitor-fetal-heart-rate-and-mobility/page-data.json": [
		"YbAR",
		260
	],
	"./page-data/en/articles/imec-and-cadence-tape-out-industry-s-first-3nm-test-chip/page-data.json": [
		"MiA2",
		261
	],
	"./page-data/en/articles/imec-and-cardis-partners-develop-unique-photonic-based-medical-device-for-the-screening/page-data.json": [
		"2LBP",
		262
	],
	"./page-data/en/articles/imec-and-cascade-microtech-develop-first-automatic-probe-system-for-advanced-3d-chips/page-data.json": [
		"7VC2",
		263
	],
	"./page-data/en/articles/imec-and-cea-leti-join-forces-on-artificial-intelligence-and-quantum-computing/page-data.json": [
		"x4x7",
		264
	],
	"./page-data/en/articles/imec-and-cloudtag-collaborate-on-high-quality-frictionless-wearables-for-lifestyle-coaching/page-data.json": [
		"hYu8",
		265
	],
	"./page-data/en/articles/imec-and-crystal-solar-demonstrate-22-5-percent-npert-si-solar-cells-on-kerfless-epitaxial-wafers/page-data.json": [
		"UlFi",
		266
	],
	"./page-data/en/articles/imec-and-cst-global-collaborate-to-extend-silicon-photonics-portfolio-with-hybrid-integrated-inp-light-sources/page-data.json": [
		"satq",
		267
	],
	"./page-data/en/articles/imec-and-energyville-present-unique-simulation-framework-to-Accurately-Determine-Energy-Yield/page-data.json": [
		"CodM",
		268
	],
	"./page-data/en/articles/imec-and-evg-demonstrate-for-the-first-time-1-8um-pitch-overlay-accuracy-for-wafer-bonding/page-data.json": [
		"fJQF",
		269
	],
	"./page-data/en/articles/imec-and-genalyte-report-disposable-silicon-photonics-biosensor-chips/page-data.json": [
		"JRUY",
		270
	],
	"./page-data/en/articles/imec-and-holst-centre-demonstrate-versatile-single-chip-sensor-for-ion-detection-in-fluids/page-data.json": [
		"CP8C",
		271
	],
	"./page-data/en/articles/imec-and-holst-centre-introduce-eeg-headset-for-emotion-detection/page-data.json": [
		"rJNL",
		272
	],
	"./page-data/en/articles/imec-and-holst-centre-introduce-world-s-first-solid-state-multi-ion-sensor-for-internet-of-things-applications-2/page-data.json": [
		"ovOE",
		273
	],
	"./page-data/en/articles/imec-and-holst-centre-present-a-digital-receiver-excelling-in-energy-efficiency-and-small-size-for-bluetooth-5-and-beyond/page-data.json": [
		"JET8",
		274
	],
	"./page-data/en/articles/imec-and-holst-centre-present-multi-standard-low-power-wide-area-radio-chip/page-data.json": [
		"25Re",
		275
	],
	"./page-data/en/articles/imec-and-holst-centre-present-solution-for-precise-low-cost-eye-movement-detection/page-data.json": [
		"c06G",
		276
	],
	"./page-data/en/articles/imec-and-holst-centre-present-the-world-s-most-energy-efficient-biomedical-sensor-hub-for-wearable-health-applications/page-data.json": [
		"W0nk",
		277
	],
	"./page-data/en/articles/imec-and-holst-centre-present-wi-fi-halow-low-power-fully-digital-polar-transmitter-for-iot-applications/page-data.json": [
		"nlMe",
		278
	],
	"./page-data/en/articles/imec-and-iminds-to-merge-and-create-high-tech-research-center-driving-the-digital-economy_2/page-data.json": [
		"fAYm",
		279
	],
	"./page-data/en/articles/imec-and-infineon-cooperate-on-79-ghz-cmos-radar-sensor-chips-for-the-automotive-industry/page-data.json": [
		"6jiP",
		280
	],
	"./page-data/en/articles/imec-and-its-solliance-partners-present-first-semi-transparent-perovskite-modules/page-data.json": [
		"z17w",
		281
	],
	"./page-data/en/articles/imec-and-jolywood-achieve-a-record-of-23-2-percent-with-bifacial-n-pert-solar-cells/page-data.json": [
		"cpWB",
		282
	],
	"./page-data/en/articles/imec-and-nus-to-collaborate-on-chip-based-quantum-cryptography-technology/page-data.json": [
		"XNdj",
		283
	],
	"./page-data/en/articles/imec-and-panasonic-introduce-innovative-nanocomposite-electrolyte-for-next-generation-batteries/page-data.json": [
		"J1xn",
		284
	],
	"./page-data/en/articles/imec-and-partners-report-major-breakthroughs-for-spintronic-logic-devices-in-two-different-implementations/page-data.json": [
		"xIUB",
		285
	],
	"./page-data/en/articles/imec-and-partners-uncover-path-to-unlock-2d-materials-based-field-effect-transistors-fets-for-high-performance-logic/page-data.json": [
		"6meW",
		286
	],
	"./page-data/en/articles/imec-and-qromis-present-high-performance-p-gan-hemts-on-200mm-cte-matched-substrates/page-data.json": [
		"P/3t",
		287
	],
	"./page-data/en/articles/imec-and-rutgers-university-compete-to-solve-network-traffic-jams-and-win-2-million/page-data.json": [
		"GCj/",
		288
	],
	"./page-data/en/articles/imec-and-soitec-demonstrate-sequential-3d-planar-device-achieving-high-reliability-at-low-temperature/page-data.json": [
		"SMtn",
		289
	],
	"./page-data/en/articles/imec-and-solliance-s-perovskite-pv-modules-achieve-12-4/page-data.json": [
		"1uQl",
		290
	],
	"./page-data/en/articles/imec-and-synopsys-collaborate-on-interconnect-resistivity-model-to-enable-early-screening-of-interconnect-technology-options-at-advanced-nodes/page-data.json": [
		"81ek",
		291
	],
	"./page-data/en/articles/imec-and-tno-launch-comfortable-disposable-health-patch-with-long-battery-life-to-measure-vital-signs/page-data.json": [
		"kBQD",
		292
	],
	"./page-data/en/articles/imec-and-tno-launch-digital-twin-of-the-city-of-antwerp/page-data.json": [
		"+MwJ",
		293
	],
	"./page-data/en/articles/imec-and-unisantis-unveil-ultra-scaled-euv-enabled-surrounding-gate-transistor-sram-cell/page-data.json": [
		"8L9W",
		294
	],
	"./page-data/en/articles/imec-and-vrije-universiteit-brussel-present-breakthrough-towards-compact-saw-less-transmitter-for-3g-4g-and-beyond/page-data.json": [
		"F9UM",
		295
	],
	"./page-data/en/articles/imec-and-vrije-universiteit-brussel-present-small-low-cost-and-low-power-chip-for-multi-gigabit-60ghz-communication/page-data.json": [
		"ShVJ",
		296
	],
	"./page-data/en/articles/imec-awarded-a-grant-from-nasa-to-advance-space-health-diagnostics/page-data.json": [
		"Dre6",
		297
	],
	"./page-data/en/articles/imec-beats-silicon-pv-with-27-1-percent-perovskite-silicon-tandem/page-data.json": [
		"GI/D",
		298
	],
	"./page-data/en/articles/imec-boosts-performance-of-beyond-silicon-devices/page-data.json": [
		"yFkL",
		299
	],
	"./page-data/en/articles/imec-builds-world-s-first-spiking-neural-network-based-chip-for-radar-signal-processing/page-data.json": [
		"MLnG",
		300
	],
	"./page-data/en/articles/imec-collaborates-with-city-of-antwerp-and-flanders-to-establish-smart-city-living-lab/page-data.json": [
		"sveK",
		301
	],
	"./page-data/en/articles/imec-collaborates-with-google-to-offer-cloud-access-to-flemish-startups/page-data.json": [
		"Lsh/",
		302
	],
	"./page-data/en/articles/imec-collaborates-with-janssen-to-advance-precision-medicine-to-treat-and-eliminate-disease/page-data.json": [
		"M9Px",
		303
	],
	"./page-data/en/articles/imec-combines-advanced-machine-learning-algorithms-and-innovations-in-chip-design-to-achieve-cm-accuracy-and-low-power-ultra-wideband-localization/page-data.json": [
		"ZEjc",
		304
	],
	"./page-data/en/articles/imec-coventor-expand-collaboration-to-optimize-7-nm-semiconductor-manufacturing-processes/page-data.json": [
		"6x3S",
		305
	],
	"./page-data/en/articles/imec-delivers-uest-s-first-generation-zembro-bracelet-smart-watch/page-data.json": [
		"Z8BF",
		306
	],
	"./page-data/en/articles/imec-demonstrates-24nm-pitch-lines-with-single-exposure-euv-lithography-on-asml-s-nxe-3400b-scanner/page-data.json": [
		"gv2P",
		307
	],
	"./page-data/en/articles/imec-demonstrates-896gb-s-silicon-photonics-transceiver/page-data.json": [
		"NU6K",
		308
	],
	"./page-data/en/articles/imec-demonstrates-breakthrough-in-cmos-compatible-ferroelectric-memory/page-data.json": [
		"RcMG",
		309
	],
	"./page-data/en/articles/imec-demonstrates-compact-low-power-140ghz-cmos-radar-with-on-chip-antennas/page-data.json": [
		"fITg",
		310
	],
	"./page-data/en/articles/imec-demonstrates-compatibility-of-state-of-the-art-0-8v-transceiver-with-industry-standard-arm-cordio-ip-for-ble-5/page-data.json": [
		"evVf",
		311
	],
	"./page-data/en/articles/imec-demonstrates-direct-optical-reading-of-single-molecule-dna-bases-in-modified-nanopores/page-data.json": [
		"sYtm",
		312
	],
	"./page-data/en/articles/imec-demonstrates-efficient-cost-effective-cooling-solution-for-high-performance-chips/page-data.json": [
		"a8CN",
		313
	],
	"./page-data/en/articles/imec-demonstrates-electrically-functional-5nm-solution-for-back-end-of-line/page-data.json": [
		"xodi",
		314
	],
	"./page-data/en/articles/imec-demonstrates-excellent-performance-of-si-finfet-cmos-devices-with-integrated-tungsten-buried-power-rails/page-data.json": [
		"mjEY",
		315
	],
	"./page-data/en/articles/imec-demonstrates-first-secure-passive-keyless-entry-solution-for-automotive-using-bluetooth-low-energy/page-data.json": [
		"24OY",
		316
	],
	"./page-data/en/articles/imec-demonstrates-for-the-first-time-functional-ring-oscillators-based-on-stacked-gate-all-around-silicon-nanowire-transistors/page-data.json": [
		"A7vq",
		317
	],
	"./page-data/en/articles/imec-demonstrates-for-the-first-time-sub-10nm-germanium-gate-all-around-devices/page-data.json": [
		"uASG",
		318
	],
	"./page-data/en/articles/imec-demonstrates-gate-all-around-mosfets-with-lateral-silicon-nanowires-at-scaled-dimensions/page-data.json": [
		"PO0J",
		319
	],
	"./page-data/en/articles/imec-demonstrates-highly-efficient-bifacial-solar-cells-with-near-100-bifaciality/page-data.json": [
		"by2I",
		320
	],
	"./page-data/en/articles/imec-demonstrates-hybrid-finfet-silicon-photonics-technology-for-ultra-low-power-optical-i-o/page-data.json": [
		"/l0Z",
		321
	],
	"./page-data/en/articles/imec-demonstrates-junction-less-gate-all-around-lateral-and-vertical-nanowire-fet-devices/page-data.json": [
		"6jWA",
		322
	],
	"./page-data/en/articles/imec-demonstrates-manufacturability-of-state-of-the-art-spin-orbit-torque-mram-devices-on-300mm-si-wafers/page-data.json": [
		"lvI0",
		323
	],
	"./page-data/en/articles/imec-demonstrates-optimized-process-flows-for-high-performance-ge-based-devices/page-data.json": [
		"VbMq",
		324
	],
	"./page-data/en/articles/imec-demonstrates-power-performance-area-cost-benefit-of-heterogeneous-sequential-3d-integration-for-advanced-cmos-nodes/page-data.json": [
		"6fId",
		325
	],
	"./page-data/en/articles/imec-demonstrates-record-tunneling-magnetoresistance-for-one-of-the-world-s-smallest-perpendicular-magnetic-tunnel-junctions/page-data.json": [
		"Tx4k",
		326
	],
	"./page-data/en/articles/imec-demonstrates-revolutionary-hyperspectral-imaging-cameras-at-spie-photonics-west-2018/page-data.json": [
		"mviV",
		327
	],
	"./page-data/en/articles/imec-demonstrates-scalable-iii-v-and-iii-n-devices-on-si-targeting-beyond-5g-rf-front-end-modules/page-data.json": [
		"AAMg",
		328
	],
	"./page-data/en/articles/imec-demonstrates-self-learning-neuromorphic-chip-that-composes-music/page-data.json": [
		"Qioy",
		329
	],
	"./page-data/en/articles/imec-demonstrates-shortwave-infrared-swir-range-hyperspectral-imaging-camera/page-data.json": [
		"kcMR",
		330
	],
	"./page-data/en/articles/imec-demonstrates-the-feasibility-of-introducing-sst-mram-as-a-last-level-cache/page-data.json": [
		"wJCO",
		331
	],
	"./page-data/en/articles/imec-demonstrates-world-s-first-multispectral-time-delay-integration-image-sensor-based-on-ccd-in-cmos-technology/page-data.json": [
		"2uqD",
		332
	],
	"./page-data/en/articles/imec-demonstrates-world-s-first-vertically-stacked-gate-all-around-si-nanowire-cmos-transistors/page-data.json": [
		"Jfbz",
		333
	],
	"./page-data/en/articles/imec-designs-and-fabricates-world-first-miniature-neural-probe-for-simultaneous-recording-of-multiple-brain-regions-at-neuronal-resolution/page-data.json": [
		"rK8X",
		334
	],
	"./page-data/en/articles/imec-designs-breakthrough-sub-mw-radar-for-presence-detection-in-smart-buildings/page-data.json": [
		"+tK/",
		335
	],
	"./page-data/en/articles/imec-developed-wireless-eeg-headset-for-emergency-room-and-intensive-care-unit-patients-with-nihon-kohden/page-data.json": [
		"z6Fk",
		336
	],
	"./page-data/en/articles/imec-develops-3d-compatible-germanium-nmos-gate-stack-with-high-mobility-and-superior-reliability/page-data.json": [
		"gB59",
		337
	],
	"./page-data/en/articles/imec-develops-bifacial-n-pert-solar-cell-with-a-record-22-8-percent-front-side-efficiency/page-data.json": [
		"u3Rm",
		338
	],
	"./page-data/en/articles/imec-develops-industry-compatible-screen-printing-process-for-highly-efficient-n-pert-solar-cells/page-data.json": [
		"K62K",
		339
	],
	"./page-data/en/articles/imec-enables-food-industry-to-sample-hyperspectral-technology/page-data.json": [
		"myCZ",
		340
	],
	"./page-data/en/articles/imec-enhances-its-silicon-photonics-platform-to-support-50gb-s-non-return-to-zero-optical-lane-rates/page-data.json": [
		"ysnO",
		341
	],
	"./page-data/en/articles/imec-enters-the-race-to-unleash-quantum-computing-with-silicon-qubits/page-data.json": [
		"5d5z",
		342
	],
	"./page-data/en/articles/imec-expands-its-silicon-platform-for-quantum-computing-applications/page-data.json": [
		"34vq",
		343
	],
	"./page-data/en/articles/imec-expands-strategic-partnership-with-western-digital/page-data.json": [
		"tYAb",
		344
	],
	"./page-data/en/articles/imec-extends-collaboration-with-total-on-next-generation-silicon-solar-cells/page-data.json": [
		"IoPp",
		345
	],
	"./page-data/en/articles/imec-extends-damascene-metallization-towards-the-3nm-technology-node/page-data.json": [
		"+VkM",
		346
	],
	"./page-data/en/articles/imec-extends-its-global-r-d-innovation-footprint-with-opening-of-imec-florida/page-data.json": [
		"UQra",
		347
	],
	"./page-data/en/articles/imec-extends-silicon-photonics-portfolio-targeting-next-generation-data-center-interconnects/page-data.json": [
		"RIZ1",
		348
	],
	"./page-data/en/articles/imec-first-to-stack-finfets-with-45nm-fin-pitch-using-sequential-3d-integration/page-data.json": [
		"RwOC",
		349
	],
	"./page-data/en/articles/imec-furthers-high-mobility-nanowire-fets-for-nodes-beyond-5nm/page-data.json": [
		"YTyr",
		350
	],
	"./page-data/en/articles/imec-ghent-university-and-seed-demonstrate-electronics-in-hydrogel-based-soft-lenses/page-data.json": [
		"loxN",
		351
	],
	"./page-data/en/articles/imec-helpt-gentse-start-up-sensolus-bij-optimalisatie-van-gps-tracker-voor-internet-of-things-toepassingen/page-data.json": [
		"FUDy",
		352
	],
	"./page-data/en/articles/imec-holst-centre-and-barco-silex-collaborate-on-data-security-for-wearables-and-internet-of-things-networks/page-data.json": [
		"5Rfk",
		353
	],
	"./page-data/en/articles/imec-holst-centre-and-cartamundi-introduce-plastic-near-field-communication-tag-communicating-with-smartphones_2/page-data.json": [
		"RYeJ",
		354
	],
	"./page-data/en/articles/imec-holst-centre-and-methods2business-develop-complete-low-power-wi-fi-halow-radio-solution-for-internet-of-things-iot-applications/page-data.json": [
		"5p3a",
		355
	],
	"./page-data/en/articles/imec-holst-centre-and-rohm-present-breakthrough-solution-for-ultra-low-power-internet-of-things-radios/page-data.json": [
		"1icr",
		356
	],
	"./page-data/en/articles/imec-honors-dr-gordon-moore-with-lifetime-of-innovation-award/page-data.json": [
		"XvSF",
		357
	],
	"./page-data/en/articles/imec-honors-qualcomm-founder-irwin-m-jacobs-with-lifetime-of-innovation-award/page-data.json": [
		"ojSt",
		358
	],
	"./page-data/en/articles/imec-ic-link-our-answer-to-a-changing-ic-market/page-data.json": [
		"yIoG",
		359
	],
	"./page-data/en/articles/imec-improves-performance-and-reliability-of-deeply-scaled-cmos-logic-devices/page-data.json": [
		"K7ov",
		360
	],
	"./page-data/en/articles/imec-improves-performance-and-understanding-of-stacked-nanowire-gate-all-around-transistors/page-data.json": [
		"sCpO",
		361
	],
	"./page-data/en/articles/imec-independent-research-hub-for-the-world-s-electronics-and-digital-community/page-data.json": [
		"PMKc",
		362
	],
	"./page-data/en/articles/imec-inpria-and-tel-demonstrate-integrated-fab-process-for-metal-oxide-euv-photoresist/page-data.json": [
		"BGMZ",
		363
	],
	"./page-data/en/articles/imec-introduces-broad-spectrum-hyperspectral-imaging-solutions/page-data.json": [
		"VGhZ",
		364
	],
	"./page-data/en/articles/imec-introduces-cmos-chip-with-16-384-micro-electrodes-and-1-024-channels-for-multimodal-cell-interfacing/page-data.json": [
		"pwhG",
		365
	],
	"./page-data/en/articles/imec-introduces-new-snapshot-multispectral-image-sensor-that-combines-color-and-near-infrared-imaging/page-data.json": [
		"jz5X",
		366
	],
	"./page-data/en/articles/imec-introduces-snapscan-the-first-hyperspectral-imaging-camera-that-fuses-the-benefits-of-snapshot-and-linescan-technologies/page-data.json": [
		"fP33",
		367
	],
	"./page-data/en/articles/imec-introduces-three-new-hyperspectral-imaging-systems-outside-the-lab/page-data.json": [
		"8H/Z",
		368
	],
	"./page-data/en/articles/imec-introduces-world-s-first-hin-silicon-implantable-chip-for-high-precision-haptic-prosthetics/page-data.json": [
		"mKYL",
		369
	],
	"./page-data/en/articles/imec-istart-business-accelerator-program-opens-call-for-applicants/page-data.json": [
		"4bfH",
		370
	],
	"./page-data/en/articles/imec-istart-is-ranked-fourth-in-ubi-global-s-university-business-accelerator-ranking/page-data.json": [
		"hhDQ",
		371
	],
	"./page-data/en/articles/imec-istart-program-introduces-special-offer-for-start-ups-in-the-fintech-insurtech-and-cyber-security-domain/page-data.json": [
		"h/WY",
		372
	],
	"./page-data/en/articles/imec-istart-recognized-as-world-s-top-business-accelerator-in-2019/page-data.json": [
		"xya/",
		373
	],
	"./page-data/en/articles/imec-istart-secures-significant-growth-international-recognition/page-data.json": [
		"+dvT",
		374
	],
	"./page-data/en/articles/imec-istart-supports-nine-new-startups-and-goes-international/page-data.json": [
		"pAsb",
		375
	],
	"./page-data/en/articles/imec-ku-leuven-and-nerf-combine-electronics-and-photonics-in-neural-probes/page-data.json": [
		"pSb3",
		376
	],
	"./page-data/en/articles/imec-leverages-the-power-of-silicon-fabrication-to-create-innovative-neural-probe-demonstrator-with-unprecedented-electrode-density/page-data.json": [
		"urbq",
		377
	],
	"./page-data/en/articles/imec-manufactures-high-quality-image-detectors-for-fei-s-scanning-electron-microscopes/page-data.json": [
		"JrXs",
		378
	],
	"./page-data/en/articles/imec-ondersteunt-airobot-bij-de-commercialisatie-van-afstandsmeter-in-drones/page-data.json": [
		"1tLp",
		379
	],
	"./page-data/en/articles/imec-opens-new-cleanroom-serving-the-global-semiconductor-industry-in-its-search-towards-the-ultimate-ic-technology/page-data.json": [
		"1Gaq",
		380
	],
	"./page-data/en/articles/imec-overcomes-fundamental-operation-challenge-for-voltage-controlled-magnetic-random-access-memories-ram/page-data.json": [
		"COG5",
		381
	],
	"./page-data/en/articles/imec-packs-new-fast-eye-tracking-technology-into-ergonomic-design-for-high-quality-ar-vr-experiences/page-data.json": [
		"m3a0",
		382
	],
	"./page-data/en/articles/imec-partner-in-energyville-and-pvcase-co-develop-next-generation-yield-simulation-software-for-solar-parks/page-data.json": [
		"5+lb",
		383
	],
	"./page-data/en/articles/imec-partner-in-energyville-doubles-energy-density-of-its-solid-state-batteries-to-400Wh-liter/page-data.json": [
		"4vP1",
		384
	],
	"./page-data/en/articles/imec-partners-in-european-initiative-to-develop-organs-on-chip/page-data.json": [
		"xD+c",
		385
	],
	"./page-data/en/articles/imec-paves-the-way-to-boosting-gan-performance-and-enabling-true-gan-ic-technology/page-data.json": [
		"iEAq",
		386
	],
	"./page-data/en/articles/imec-presents-a-manufacturable-solution-for-field-free-switching-operation-of-spin-orbit-torque-mram-devices/page-data.json": [
		"i41h",
		387
	],
	"./page-data/en/articles/imec-presents-breakthrough-results-in-memory-and-logic-at-vlsi-symposia/page-data.json": [
		"TkPb",
		388
	],
	"./page-data/en/articles/imec-presents-compact-lens-free-digital-microscope/page-data.json": [
		"U8rQ",
		389
	],
	"./page-data/en/articles/imec-presents-complementary-fet-cfet-as-scaling-contender-for-nodes-beyond-n3/page-data.json": [
		"UXnr",
		390
	],
	"./page-data/en/articles/imec-presents-forksheet-device-as-the-ultimate-solution-to-push-scaling-towards-the-2nm-technology-node/page-data.json": [
		"89Iz",
		391
	],
	"./page-data/en/articles/imec-presents-highly-accurate-model-for-energy-yield-prediction-of-photovoltaic-modules/page-data.json": [
		"/vt4",
		392
	],
	"./page-data/en/articles/imec-presents-ingaas-tfet-with-sub-60-mv-decade-sub-threshold-swing/page-data.json": [
		"ppLk",
		393
	],
	"./page-data/en/articles/imec-presents-lifetime-of-innovation-award-to-asml-president-and-cto-martin-van-den-brink/page-data.json": [
		"+b/+",
		394
	],
	"./page-data/en/articles/imec-presents-novel-organ-on-chip-platform-for-drug-screening/page-data.json": [
		"xSko",
		395
	],
	"./page-data/en/articles/imec-presents-patterning-solutions-for-n5-equivalent-metal-layers/page-data.json": [
		"iKvu",
		396
	],
	"./page-data/en/articles/imec-presents-together-with-renesas-electronics-an-ultra-low-power-transceiver-for-bluetooth-5-and-beyond-with-lowest-supply-voltage-ever-reported/page-data.json": [
		"12q1",
		397
	],
	"./page-data/en/articles/imec-produces-high-quality-euv-sensors-for-asml-s-next-generation-lithography-tools/page-data.json": [
		"ykV4",
		398
	],
	"./page-data/en/articles/imec-proud-to-host-phd-students-from-ncku-taiwan/page-data.json": [
		"qYGx",
		399
	],
	"./page-data/en/articles/imec-pushes-the-limits-of-euv-lithography-single-exposure-for-logic-n5-metal-layers-and-dense-dram-applications/page-data.json": [
		"SGUh",
		400
	],
	"./page-data/en/articles/imec-reaches-milestone-for-next-gen-solid-state-batteries-to-power-future-long-range-electrical-vehicles/page-data.json": [
		"Sl60",
		401
	],
	"./page-data/en/articles/imec-releases-neuropixels-neural-probe-to-the-global-neuroscience-community/page-data.json": [
		"uzjp",
		402
	],
	"./page-data/en/articles/imec-reports-14-percent-growth-in-2015/page-data.json": [
		"Q3JV",
		403
	],
	"./page-data/en/articles/imec-reports-14-percent-growth-in-2015_2/page-data.json": [
		"489i",
		404
	],
	"./page-data/en/articles/imec-reports-breakthrough-in-extending-interconnects-beyond-the-3nm-technology-node/page-data.json": [
		"lzbg",
		405
	],
	"./page-data/en/articles/imec-reports-breakthrough-work-that-advances-path-for-nanoscale-spin-wave-majority-gates/page-data.json": [
		"76VO",
		406
	],
	"./page-data/en/articles/imec-reports-for-the-first-time-direct-growth-of-2d-materials-on-300mm-wafers/page-data.json": [
		"s7qi",
		407
	],
	"./page-data/en/articles/imec-reports-micro-optomechanical-pressure-sensor-advancing-pressure-monitoring-in-biomedical-applications/page-data.json": [
		"3++8",
		408
	],
	"./page-data/en/articles/imec-reports-monolithic-thin-film-image-sensor-for-the-swir-range-with-record-pixel-density/page-data.json": [
		"0oAa",
		409
	],
	"./page-data/en/articles/imec-reports-record-conversion-efficiency-of-23-9-percent-on-a-4cm2-perovskite-silicon-solar-module/page-data.json": [
		"L4u7",
		410
	],
	"./page-data/en/articles/imec-reports-two-record-breaking-ringamp-adcs-for-5g-base-stations-and-mobile-handsets/page-data.json": [
		"S8bS",
		411
	],
	"./page-data/en/articles/imec-reports-world-class-low-power-ip-blocks-for-5g/page-data.json": [
		"qMOk",
		412
	],
	"./page-data/en/articles/imec-researcher-receives-erc-advanced-grant-to-develop-ultra-bright-thin-film-light-sources-and-lasers/page-data.json": [
		"vz62",
		413
	],
	"./page-data/en/articles/imec-reveals-impact-of-dsa-process-variations-on-electrical-performance-of-dsa-formed-vias/page-data.json": [
		"pRlL",
		414
	],
	"./page-data/en/articles/imec-s-200mm-gan-on-si-e-mode-power-devices-withstand-heavy-ion-and-neutron-irradiation/page-data.json": [
		"Ow6H",
		415
	],
	"./page-data/en/articles/imec-s-elprep-software-significantly-speeds-up-genome-sequencing-analysis/page-data.json": [
		"3OTz",
		416
	],
	"./page-data/en/articles/imec-s-high-speed-ultrasonic-snapscan-camera-enables-hyperspectral-imaging-acquisition-in-less-than-one-second/page-data.json": [
		"l3Kr",
		417
	],
	"./page-data/en/articles/imec-s-new-design-center-for-photonics-and-high-speed-electronics/page-data.json": [
		"HrD/",
		418
	],
	"./page-data/en/articles/imec-s-screen-printed-large-area-npert-solar-cells-surpass-23-percent-efficiency/page-data.json": [
		"QmV/",
		419
	],
	"./page-data/en/articles/imec-s-sweet-study-collects-world-s-largest-dataset-on-stress-detection/page-data.json": [
		"mS54",
		420
	],
	"./page-data/en/articles/imec-scientist-awarded-erc-advanced-grant-to-develop-material-stacks-for-video-rate-holography/page-data.json": [
		"8gxx",
		421
	],
	"./page-data/en/articles/imec-scientist-awarded-erc-starting-grant-to-develop-breakthrough-flexible-electronics/page-data.json": [
		"5p7Z",
		422
	],
	"./page-data/en/articles/imec-scientist-awarded-erc-starting-grant-to-develop-ultra-small-microscopes/page-data.json": [
		"vmZ6",
		423
	],
	"./page-data/en/articles/imec-sets-new-benchmark-with-30cm-accurate-and-secure-localization-solution-based-on-bluetooth/page-data.json": [
		"w9Uo",
		424
	],
	"./page-data/en/articles/imec-shows-excellent-performance-in-ultra-scaled-fets-with-2d-material-channel/page-data.json": [
		"MXnc",
		425
	],
	"./page-data/en/articles/imec-taiwan-and-itrc-narlabs-to-collaborate-on-advanced-imaging-and-optics-applications/page-data.json": [
		"A4Iq",
		426
	],
	"./page-data/en/articles/imec-test-nieuwe-generatie-festivalbandjes-en-verbeterde-draadloze-technologie-tijdens-concert-dimitri-vegas-en-like-mike/page-data.json": [
		"2zKL",
		427
	],
	"./page-data/en/articles/imec-the-netherlands-measures-the-air-quality-in-eindhoven-centre-during-dutch-design-week-2018/page-data.json": [
		"Erxd",
		428
	],
	"./page-data/en/articles/imec-the-netherlands-part-of-europe-s-largest-vr-days-event-in-amsterdam/page-data.json": [
		"dRMk",
		429
	],
	"./page-data/en/articles/imec-tno-and-cartamundi-develop-flexible-tags-that-communicate-with-standard-touch-screens/page-data.json": [
		"m7k4",
		430
	],
	"./page-data/en/articles/imec-to-honor-samsung-s-dr-kinam-kim-with-lifetime-of-innovation-award/page-data.json": [
		"5VUv",
		431
	],
	"./page-data/en/articles/imec-to-install-high-na-euv-imaging-and-attosecond-analytical-lab-to-probe-lithography-down-to-8nm-pitch/page-data.json": [
		"PMdf",
		432
	],
	"./page-data/en/articles/imec-toont-de-slimme-toekomst-tijdens-koninklijke-missie-aan-nederland/page-data.json": [
		"mLjd",
		433
	],
	"./page-data/en/articles/imec-uses-hyperspectral-camera-to-decipher-da-vinci-code-in-tongerlo/page-data.json": [
		"tZXS",
		434
	],
	"./page-data/en/articles/imec-welcomes-phd-students-from-fudan-university-china/page-data.json": [
		"KXwX",
		435
	],
	"./page-data/en/articles/imec-world-first-to-demonstrate-2-metal-layer-back-end-of-line-for-the-3nm-technology-node/page-data.json": [
		"k6Ii",
		436
	],
	"./page-data/en/articles/imec-world-first-to-develop-200v-and-650v-dispersion-free-normally-off-e-mode-power-devices-on-200mm-8-inch-si-wafers/page-data.json": [
		"21YH",
		437
	],
	"./page-data/en/articles/imec-xpand-raises-eur-117-million-to-invest-in-innovative-early-stage-ideas-leveraging-imec-s-knowledge-expertise-and-infrastructure/page-data.json": [
		"A1pw",
		438
	],
	"./page-data/en/articles/imecxpand-doet-internet-of-things-bloeien/page-data.json": [
		"gkWe",
		439
	],
	"./page-data/en/articles/immunotherapy-beyond-the-promises/page-data.json": [
		"VrnV",
		440
	],
	"./page-data/en/articles/in-the-smart-zone-things-talk-to-each-other-thanks-to-5g/page-data.json": [
		"0dwf",
		441
	],
	"./page-data/en/articles/indigo-announces-successful-series-a-financing-round/page-data.json": [
		"x1Io",
		442
	],
	"./page-data/en/articles/ingestibles-from-medical-research-tool-to-smart-health-application/page-data.json": [
		"DOYd",
		443
	],
	"./page-data/en/articles/inhale-the-future-bringing-respiratory-monitoring-to-the-21st-century/page-data.json": [
		"6nSh",
		444
	],
	"./page-data/en/articles/innovative-algorithms-make-industrial-ct-scanners-faster-and-more-accurate/page-data.json": [
		"vPiq",
		445
	],
	"./page-data/en/articles/inside-a-european-r-d-project-targeting-mobile-early-stage-cardiovascular-disease-diagnosis-and-monitoring/page-data.json": [
		"VZ8Y",
		446
	],
	"./page-data/en/articles/international-research-project-5g-blueprint-receives-european-grant/page-data.json": [
		"9FhX",
		447
	],
	"./page-data/en/articles/internet-of-water-to-tackle-growing-water-risks/page-data.json": [
		"h5dz",
		448
	],
	"./page-data/en/articles/introducing-dc-technology-in-tomorrow-s-power-system/page-data.json": [
		"GgKh",
		449
	],
	"./page-data/en/articles/investment-company-lrm-invests-in-small-teaser-s-online-publication-tool-for-news-websites-and-digital-magazines/page-data.json": [
		"rYVF",
		450
	],
	"./page-data/en/articles/iqe-joins-imec-s-gallium-nitride-on-silicon-industrial-affiliation-program/page-data.json": [
		"Ijqu",
		451
	],
	"./page-data/en/articles/joint-european-effort-to-unlock-the-potential-of-graphene/page-data.json": [
		"ZPjN",
		452
	],
	"./page-data/en/articles/lam-research-unveils-technology-breakthrough-for-euv-lithography/page-data.json": [
		"dV1M",
		453
	],
	"./page-data/en/articles/launch-of-epki-the-european-perovskite-initiative-for-the-development-of-perovskites-based-solar-technology/page-data.json": [
		"PQWI",
		454
	],
	"./page-data/en/articles/launch-of-key-project-to-support-the-realisation-of-the-pv-implementation-plan-of-the-set-plan-pv-impact/page-data.json": [
		"WsN4",
		455
	],
	"./page-data/en/articles/lindacare-expands-its-operations-to-the-usa/page-data.json": [
		"4kuS",
		456
	],
	"./page-data/en/articles/linked-open-data-can-help-governments-serve-citizens-more-efficiently/page-data.json": [
		"6lAV",
		457
	],
	"./page-data/en/articles/lopos-a-spin-off-of-imec-and-the-ghent-university-presents-the-safedistance-wearable-that-helps-employees-follow-social-distancing-guidelines/page-data.json": [
		"FEES",
		458
	],
	"./page-data/en/articles/luc-van-den-hove-to-receive-semi-sales-and-marketing-excellence-award/page-data.json": [
		"6Dho",
		459
	],
	"./page-data/en/articles/making-perovskite-solar-cells-ready-for-the-market/page-data.json": [
		"Hv96",
		460
	],
	"./page-data/en/articles/mega-mindy-computer-game-helps-paralyzed-children/page-data.json": [
		"MquS",
		461
	],
	"./page-data/en/articles/merger-between-centers-imec-and-iminds-completed/page-data.json": [
		"FZ39",
		462
	],
	"./page-data/en/articles/micledi-microdisplays-an-imec-spin-off-raises-eur-4-5m-from-imec-xpand-pmv-and-fidimec-for-the-development-of-next-generation-displays-for-augmented-reality-ar-glasses/page-data.json": [
		"eHq/",
		463
	],
	"./page-data/en/articles/midiagnostics-closing-in-on-breakthrough-test-for-complete-blood-count/page-data.json": [
		"hJdR",
		464
	],
	"./page-data/en/articles/midiagnostics-raises-14m-to-accelerate-the-commercialization-of-its-disruptive-lab-quality-silicon-chip-diagnostics-platform/page-data.json": [
		"Q6LN",
		465
	],
	"./page-data/en/articles/midiagnostics-to-announce-nicolas-vergauwe-as-ceo-and-rudi-pauwels-as-chairman-of-the-board-of-directors/page-data.json": [
		"lpUU",
		466
	],
	"./page-data/en/articles/midiagnostics/page-data.json": [
		"eKxH",
		467
	],
	"./page-data/en/articles/miniaturization-of-medical-devices-is-crucial-for-space-exploration/page-data.json": [
		"havj",
		468
	],
	"./page-data/en/articles/molecubes-raises-1-9m-euro-to-launch-world-s-smallest-pet-spect-ct-scanner-family-for-3d-imaging-of-small-animals/page-data.json": [
		"IUSU",
		469
	],
	"./page-data/en/articles/move-over-tinder-hiermee-maak-je-je-mobiele-telefoon-echt-spannend/page-data.json": [
		"K0y5",
		470
	],
	"./page-data/en/articles/navigation-and-spatial-memory-new-brain-region-identified-to-be-involved/page-data.json": [
		"sYNn",
		471
	],
	"./page-data/en/articles/nephroflow-an-innovative-solution-for-a-more-efficient-care-of-dialysis-patients/page-data.json": [
		"Mbrd",
		472
	],
	"./page-data/en/articles/new-and-exciting-challenges/page-data.json": [
		"Ok3V",
		473
	],
	"./page-data/en/articles/new-brittle-fracture-test-reveals-importance-of-choosing-the-right-board-finish/page-data.json": [
		"W05b",
		474
	],
	"./page-data/en/articles/new-genome-analytics-platform-makes-clinical-genomics-affordable-for-daily-use-in-hospital/page-data.json": [
		"xuOl",
		475
	],
	"./page-data/en/articles/new-imec-and-uantwerp-spin-off-could-be-a-game-changer-for-online-clothes-shopping/page-data.json": [
		"JFQ5",
		476
	],
	"./page-data/en/articles/new-imec-digimeter-reveals-initial-traces-of-a-possible-digibesitas/page-data.json": [
		"f7JS",
		477
	],
	"./page-data/en/articles/new-imec-digimeter-six-in-ten-flemings-impose-rules-on-themselves-to-control-smartphone-use/page-data.json": [
		"kLOa",
		478
	],
	"./page-data/en/articles/new-insulation-technique-paves-the-way-for-more-powerful-and-smaller-chips/page-data.json": [
		"iqL0",
		479
	],
	"./page-data/en/articles/new-program-to-kick-start-us-and-asian-scale-ups-in-europe/page-data.json": [
		"ZDWD",
		480
	],
	"./page-data/en/articles/new-software-makes-the-diagnosis-of-rare-diseases-less-of-an-odyssey/page-data.json": [
		"lFVh",
		481
	],
	"./page-data/en/articles/new-standard-allows-stacked-dies-in-3d-integrated-circuits-to-connect-with-test-equipment/page-data.json": [
		"zDlc",
		482
	],
	"./page-data/en/articles/new-supercomputer-boasts-unparalleled-computing-power/page-data.json": [
		"z5UM",
		483
	],
	"./page-data/en/articles/new-tinxs-launches-linxs-the-world-s-smartest-mobile-router/page-data.json": [
		"i6Lx",
		484
	],
	"./page-data/en/articles/nova-and-imec-developed-innovative-scatterometry-approach-for-self-aligned-quadruple-patterning-saqp-process-control/page-data.json": [
		"fQMu",
		485
	],
	"./page-data/en/articles/novel-nanomaterial-promises-improvements-in-batteries-and-many-more-sustainable-applications/page-data.json": [
		"vgYK",
		486
	],
	"./page-data/en/articles/novelty-speeds-up-learning-thanks-to-dopamine-activation/page-data.json": [
		"sWAU",
		487
	],
	"./page-data/en/articles/one-man-operated-video-capturing-solution-from-azilpix-captures-live-events-from-all-angles-in-broadcast-quality-and-at-reduced-cost/page-data.json": [
		"KTJ8",
		488
	],
	"./page-data/en/articles/oneplanet-a-new-dutch-innovation-center-for-food-health-and-agricultural-technology/page-data.json": [
		"MuPB",
		489
	],
	"./page-data/en/articles/onera-receives-investment-to-develop-next-generation-sleep-diagnostic-device/page-data.json": [
		"Ta8d",
		490
	],
	"./page-data/en/articles/onitor/page-data.json": [
		"GZYW",
		491
	],
	"./page-data/en/articles/only-7-of-flemish-people-have-no-smart-devices-at-home-new-imec-digimeter-finds/page-data.json": [
		"1Yl/",
		492
	],
	"./page-data/en/articles/orbotech-s-spts-technologies-sigma-fxp-pvd-solution-selected-for-imec-s-3d-system-integration-program/page-data.json": [
		"GSYY",
		493
	],
	"./page-data/en/articles/our-third-media-mission-explores-the-us-market/page-data.json": [
		"NAiE",
		494
	],
	"./page-data/en/articles/pacific-biosciences-and-imec-announce-collaboration-to-develop-advanced-microchips-for-single-molecule-sequencing-applications/page-data.json": [
		"n5M5",
		495
	],
	"./page-data/en/articles/panasonic-joins-solliance-as-an-industrial-partner/page-data.json": [
		"RgMY",
		496
	],
	"./page-data/en/articles/paper-cardboard-and-plastic-products-that-talk/page-data.json": [
		"hSsv",
		497
	],
	"./page-data/en/articles/perclass-mira-integration-with-imec-hsiviewer/page-data.json": [
		"l4xo",
		498
	],
	"./page-data/en/articles/perovskite-cigs-tandem-cell-with-record-efficiency-of-24-6-percent/page-data.json": [
		"Chnr",
		499
	],
	"./page-data/en/articles/pharrowtech-an-imec-spin-off-closes-6m-seed-investment-round-with-imec-xpand-bloc-ventures-and-kbc-focus-fund/page-data.json": [
		"haAe",
		500
	],
	"./page-data/en/articles/pharrowtech-boosts-millimeter-wave-fixed-wireless-access-coverage/page-data.json": [
		"sBey",
		501
	],
	"./page-data/en/articles/photolithography-a-key-technology-for-next-generation-high-resolution-amoled-displays/page-data.json": [
		"vpyB",
		502
	],
	"./page-data/en/articles/pop-the-champagne-the-imec-istart-companies-have-hit-the-100m-milestone/page-data.json": [
		"baGp",
		503
	],
	"./page-data/en/articles/prestigious-european-erc-consolidator-grant-awarded-to-imec-s-clement-merckling-for-developing-fault-tolerant-qubits/page-data.json": [
		"D6Z7",
		504
	],
	"./page-data/en/articles/primeur-sympl-lanceert-eerste-talentbot-om-te-solliciteren-via-facebook/page-data.json": [
		"xVdk",
		505
	],
	"./page-data/en/articles/protective-clothing-with-built-in-sensors-warns-firefighters-of-too-much-heat/page-data.json": [
		"9xwz",
		506
	],
	"./page-data/en/articles/pulsify-medical-a-joint-imec-and-ku-leuven-spin-off-closes-first-round-funding-led-by-imec-xpand/page-data.json": [
		"giuN",
		507
	],
	"./page-data/en/articles/pycsel-a-new-thermal-fingerprint-sensor-winner-of-the-best-publicly-funded-project-demonstrator-award-in-the-oe-a-competition-will-participate-in-the-eab-conference/page-data.json": [
		"gvEb",
		508
	],
	"./page-data/en/articles/raman-on-chip-for-high-throughput/page-data.json": [
		"cTxD",
		509
	],
	"./page-data/en/articles/research-on-largest-network-of-cortical-neurons-to-date-profiled-in-nature/page-data.json": [
		"GEp0",
		510
	],
	"./page-data/en/articles/revealing-the-brain-circuitry/page-data.json": [
		"y1y4",
		511
	],
	"./page-data/en/articles/rewind-therapeutics-to-lead-2-9-million-r-d-collaboration-to-discover-and-develop-novel-drug-candidates-for-myelin-related-neurological-diseases/page-data.json": [
		"+Lh/",
		512
	],
	"./page-data/en/articles/roswell-biotechnologies-and-imec-to-develop-first-molecular-electronics-biosensor-chips-for-infectious-disease-surveillance-precision-medicine-and-dna-storage/page-data.json": [
		"ToVE",
		513
	],
	"./page-data/en/articles/samen-sterk-voor-meer-ondernemerschap-en-innovatie-in4care-kondigt-partnership-met-bluehealth-innovation-center-en-imec-istart-aan/page-data.json": [
		"sPqU",
		514
	],
	"./page-data/en/articles/sat5g-project-demonstrates-5g-over-satellite-and-holds-industry-briefing-at-university-of-surrey/page-data.json": [
		"13Cp",
		515
	],
	"./page-data/en/articles/scaled-perovskite-solar-modules-pass-three-critical-stability-tests/page-data.json": [
		"cc30",
		516
	],
	"./page-data/en/articles/seamless-communication-soon-possible-even-in-crisis-situations/page-data.json": [
		"pSEP",
		517
	],
	"./page-data/en/articles/security-and-privacy-a-must-for-the-internet-of-things/page-data.json": [
		"YPMV",
		518
	],
	"./page-data/en/articles/security-flaws-in-passive-keyless-entry-and-start-systems/page-data.json": [
		"orvf",
		519
	],
	"./page-data/en/articles/self-calibrated-10-mbit-s-phase-modulator-with-low-power-fractional-pll-architecture-exceeding-state-of-the-art-performance/page-data.json": [
		"Cnuq",
		520
	],
	"./page-data/en/articles/semi-partners-launch-largest-microelectronics-education-initiative-co-funded-by-erasmus-program/page-data.json": [
		"rzZv",
		521
	],
	"./page-data/en/articles/sensor-bracelet-detects-epileptic-seizures/page-data.json": [
		"4b/y",
		522
	],
	"./page-data/en/articles/sequential-infiltration-synthesis-sis-significantly-improves-euv-patterning/page-data.json": [
		"yBSA",
		523
	],
	"./page-data/en/articles/silicon-photonics-a-scaling-path-towards-terabit-s-data-center-networks/page-data.json": [
		"/Usp",
		524
	],
	"./page-data/en/articles/silicon-photonics-for-everyone/page-data.json": [
		"xuob",
		525
	],
	"./page-data/en/articles/silicon-photonics-towards-an-accessible-technology-for-telecom-and-sensing/page-data.json": [
		"tWfw",
		526
	],
	"./page-data/en/articles/slimme-gewasbescherming-in-aardappel-en-fruitteelt-dankzij-vlaamse-technologie/page-data.json": [
		"ZZrQ",
		527
	],
	"./page-data/en/articles/small-energy-efficient-health-patch-from-imec-and-holst-centre-lays-the-foundation-for-better-mobile-health-solutions-2/page-data.json": [
		"kv4I",
		528
	],
	"./page-data/en/articles/smart-cities/page-data.json": [
		"XyC9",
		529
	],
	"./page-data/en/articles/smart-data-revolutie-in-de-schaatssport/page-data.json": [
		"/tHn",
		530
	],
	"./page-data/en/articles/smart-education/page-data.json": [
		"lTre",
		531
	],
	"./page-data/en/articles/smart-health/page-data.json": [
		"b3LS",
		532
	],
	"./page-data/en/articles/smart-industries/page-data.json": [
		"Fbkt",
		533
	],
	"./page-data/en/articles/smart-mobility/page-data.json": [
		"Agww",
		534
	],
	"./page-data/en/articles/solar-energy-a-crucial-step-towards-energy-neutral-commercial-buildings/page-data.json": [
		"D4+8",
		535
	],
	"./page-data/en/articles/solid-state-batteries-for-wearable-sensors-and-electric-cars/page-data.json": [
		"XtaD",
		536
	],
	"./page-data/en/articles/solliance-realizes-first-up-scaled-perovskite-based-pv-modules-with-10-efficiency/page-data.json": [
		"lIGl",
		537
	],
	"./page-data/en/articles/solliance-tops-21-5-efficiency-with-a-flexible-perovskite-cigs-tandem/page-data.json": [
		"Nns3",
		538
	],
	"./page-data/en/articles/sr-and-imec-formalize-joint-venture-for-euv-lithography-resist-solutions/page-data.json": [
		"kDNW",
		539
	],
	"./page-data/en/articles/stacked-perovskite-cigs-solar-module-achieves-unprecedented-efficiency-at-17-8-percent/page-data.json": [
		"17Go",
		540
	],
	"./page-data/en/articles/start-up-buildeye-komt-sterk-uit-de-steiger-met-innovatief-communicatieplatform-voor-de-bouwsector/page-data.json": [
		"ZCbk",
		541
	],
	"./page-data/en/articles/statement-accident-at-imec/page-data.json": [
		"YJRB",
		542
	],
	"./page-data/en/articles/succesvolle-start-voor-flanders-new-york-accelerator/page-data.json": [
		"tfMs",
		543
	],
	"./page-data/en/articles/t-mining-welcomes-new-investors-taste-invest-westerlund-and-pmv/page-data.json": [
		"Kyah",
		544
	],
	"./page-data/en/articles/taxinomisis-project/page-data.json": [
		"fNFC",
		545
	],
	"./page-data/en/articles/tech4win-consortium-leads-an-ambitious-and-disruptive-ec-funded-project-for-the-development-of-the-future-new-generation-of-transparent-smart-solar-windows-converting-the-uv-and-ir-light-from-the-sun-into-electricity/page-data.json": [
		"dkh7",
		546
	],
	"./page-data/en/articles/teraboard-paves-the-way-to-a-high-bandwidth-density-low-power-consumption-integrated-photonic-interconnection-for-chip-to-chip-and-board-to-board-communications/page-data.json": [
		"Z0Bi",
		547
	],
	"./page-data/en/articles/the-10-things-you-need-to-know-about-imec-in-2019/page-data.json": [
		"MePm",
		548
	],
	"./page-data/en/articles/the-beacon-a-success-story-after-only-one-year/page-data.json": [
		"dyTc",
		549
	],
	"./page-data/en/articles/the-climate-debate-let-s-not-sit-idle-and-wait/page-data.json": [
		"AasR",
		550
	],
	"./page-data/en/articles/the-key-to-a-sustainable-building-faade/page-data.json": [
		"mGA8",
		551
	],
	"./page-data/en/articles/the-new-hardware-hipsters/page-data.json": [
		"m6Ks",
		552
	],
	"./page-data/en/articles/the-ping-consortium-is-delighted-to-be-selected-as-winner-of-the-innovation-product-award/page-data.json": [
		"z2dU",
		553
	],
	"./page-data/en/articles/the-power-of-droplets/page-data.json": [
		"Cvwn",
		554
	],
	"./page-data/en/articles/the-therapy-lens-project/page-data.json": [
		"Qyr3",
		555
	],
	"./page-data/en/articles/these-5-imec-innovations-help-us-live-a-more-sustainable-life/page-data.json": [
		"Gu0V",
		556
	],
	"./page-data/en/articles/three-new-developments-for-smarter-sensor-chips/page-data.json": [
		"vnSo",
		557
	],
	"./page-data/en/articles/thriving-in-an-intellectually-diverse-setting/page-data.json": [
		"C9To",
		558
	],
	"./page-data/en/articles/timothy-de-keulenaer-received-the-nokia-belgium-scientific-award/page-data.json": [
		"GSFh",
		559
	],
	"./page-data/en/articles/top-investor-of-the-year-2017-award-voor-imec-istart-manager-sven-de-cleyn/page-data.json": [
		"aAlr",
		560
	],
	"./page-data/en/articles/towards-responsible-e-gambling-assessing-the-perceived-opportunities-and-risks-associated-with-digital-gambling/page-data.json": [
		"Zx1B",
		561
	],
	"./page-data/en/articles/turbulent-the-start-up-of-the-year-that-is-shaping-the-market-of-renewable-energies/page-data.json": [
		"XWih",
		562
	],
	"./page-data/en/articles/ugent-and-imec-launch-fiber-optic-sensing-spin-off-sentea/page-data.json": [
		"jVFx",
		563
	],
	"./page-data/en/articles/ultra-sensitive-and-low-power-radar-enables-intuitive-human-computer-interaction/page-data.json": [
		"aFVc",
		564
	],
	"./page-data/en/articles/unity-technologies-acquires-graphine/page-data.json": [
		"bEOk",
		565
	],
	"./page-data/en/articles/vlaams-minister-homans-maakt-1-miljoen-euro-vrij-voor-smart-cities/page-data.json": [
		"umQ0",
		566
	],
	"./page-data/en/articles/vlaamse-digitale-coach-biedt-mensen-met-overgewicht-doeltreffend-hulpmiddel-om-blijvend-gewicht-te-verliezen/page-data.json": [
		"lG2A",
		567
	],
	"./page-data/en/articles/vlaamse-start-up-smash-it-voegt-sociale-speldimensie-toe-aan-tablet/page-data.json": [
		"CGMz",
		568
	],
	"./page-data/en/articles/vlaamse-start-up-smash-it-voegt-sociale-speldimensie-toe-aan-tablet_2/page-data.json": [
		"ozTe",
		569
	],
	"./page-data/en/articles/what-if-we-could-design-chips-that-behave-like-brains/page-data.json": [
		"Tv7o",
		570
	],
	"./page-data/en/articles/when-you-come-aboard/page-data.json": [
		"lxbM",
		571
	],
	"./page-data/en/articles/why-work-in-belgium/page-data.json": [
		"WPr+",
		572
	],
	"./page-data/en/articles/x-fab-strengthens-its-foundry-service-cooperation-with-europractice/page-data.json": [
		"ESuc",
		573
	],
	"./page-data/en/articles/yes-but-what-about-privacy/page-data.json": [
		"wrCb",
		574
	],
	"./page-data/en/artificial-intelligence/page-data.json": [
		"tTfe",
		575
	],
	"./page-data/en/artificial-intelligence/tiny-ai/page-data.json": [
		"rgao",
		576
	],
	"./page-data/en/artificial-intelligence/what-is-artificial-intelligence/page-data.json": [
		"DkCd",
		577
	],
	"./page-data/en/beamforming/page-data.json": [
		"eo0/",
		578
	],
	"./page-data/en/belcham/call-your-office-in-the-us/page-data.json": [
		"54sz",
		579
	],
	"./page-data/en/belcham/page-data.json": [
		"662q",
		580
	],
	"./page-data/en/bestwishes/page-data.json": [
		"1Y8U",
		581
	],
	"./page-data/en/biomat/page-data.json": [
		"RwNT",
		582
	],
	"./page-data/en/business-model-innovation/page-data.json": [
		"lbLe",
		583
	],
	"./page-data/en/calendar/international-microwave-symposium/page-data.json": [
		"5UXe",
		584
	],
	"./page-data/en/cams/page-data.json": [
		"9vAC",
		585
	],
	"./page-data/en/careers/academic-excellence/Joint-Programs-and-Scholarships/page-data.json": [
		"R4AO",
		586
	],
	"./page-data/en/careers/academic-excellence/page-data.json": [
		"O3bM",
		587
	],
	"./page-data/en/careers/academic-excellence/teaching-at-imec/page-data.json": [
		"r04O",
		588
	],
	"./page-data/en/careers/academic-excellence/tenure-track/page-data.json": [
		"tsqf",
		589
	],
	"./page-data/en/careers/engineers-technicians/page-data.json": [
		"nlC1",
		590
	],
	"./page-data/en/careers/go/page-data.json": [
		"3o41",
		591
	],
	"./page-data/en/careers/imec-school/faq/page-data.json": [
		"YWLS",
		592
	],
	"./page-data/en/careers/job-fair-de-nayer-ucll-diepenbeek-copy/page-data.json": [
		"vIQr",
		593
	],
	"./page-data/en/careers/job-fair/page-data.json": [
		"BCZg",
		594
	],
	"./page-data/en/careers/page-data.json": [
		"IKXv",
		595
	],
	"./page-data/en/careers/research-development/page-data.json": [
		"ymNQ",
		596
	],
	"./page-data/en/careers/sales-management-support-services/page-data.json": [
		"w7//",
		597
	],
	"./page-data/en/careers/start-your-technical-career-at-imec/page-data.json": [
		"2sHD",
		598
	],
	"./page-data/en/cellular-wifi-scalable-radio/page-data.json": [
		"CKQU",
		599
	],
	"./page-data/en/chill/page-data.json": [
		"6CF+",
		600
	],
	"./page-data/en/circuitry-sensor-hubs/disposable-health-patch/page-data.json": [
		"nXlw",
		601
	],
	"./page-data/en/citymeter/page-data.json": [
		"/M0h",
		602
	],
	"./page-data/en/cityofthings/citizens-in-the-city-of-things/page-data.json": [
		"ygrp",
		603
	],
	"./page-data/en/cityofthings/city-of-things-for-city-governments/page-data.json": [
		"rDVS",
		604
	],
	"./page-data/en/cityofthings/city-of-things-for-companies/page-data.json": [
		"1RnN",
		605
	],
	"./page-data/en/cityofthings/city-of-things-for-researchers/page-data.json": [
		"K4Mo",
		606
	],
	"./page-data/en/cityofthings/page-data.json": [
		"TNPR",
		607
	],
	"./page-data/en/connect-with-us/cmst-imec-research-group-at-ghent-university/page-data.json": [
		"fzk1",
		608
	],
	"./page-data/en/connect-with-us/cosic/page-data.json": [
		"64N5",
		609
	],
	"./page-data/en/connect-with-us/distrinet/page-data.json": [
		"itnV",
		610
	],
	"./page-data/en/connect-with-us/etro-imec-research-group-at-vub/page-data.json": [
		"vOak",
		611
	],
	"./page-data/en/connect-with-us/idlab-imec-reseach-group-at-ghent-university/page-data.json": [
		"Wp6W",
		612
	],
	"./page-data/en/connect-with-us/idlab-imec-research-group-at-university-of-antwerp/page-data.json": [
		"ZCOL",
		613
	],
	"./page-data/en/connect-with-us/imec-antwerp/page-data.json": [
		"grph",
		614
	],
	"./page-data/en/connect-with-us/imec-belgium/page-data.json": [
		"I73o",
		615
	],
	"./page-data/en/connect-with-us/imec-berkeley-office/page-data.json": [
		"XKFt",
		616
	],
	"./page-data/en/connect-with-us/imec-brussels/page-data.json": [
		"CsJ2",
		617
	],
	"./page-data/en/connect-with-us/imec-china/page-data.json": [
		"Hur8",
		618
	],
	"./page-data/en/connect-with-us/imec-genk-energyville/page-data.json": [
		"8KG5",
		619
	],
	"./page-data/en/connect-with-us/imec-gent/page-data.json": [
		"1biA",
		620
	],
	"./page-data/en/connect-with-us/imec-india/page-data.json": [
		"ya4Y",
		621
	],
	"./page-data/en/connect-with-us/imec-japan/page-data.json": [
		"bL4L",
		622
	],
	"./page-data/en/connect-with-us/imec-san-jos-office/page-data.json": [
		"O7EL",
		623
	],
	"./page-data/en/connect-with-us/imec-taiwan/page-data.json": [
		"pNgL",
		624
	],
	"./page-data/en/connect-with-us/imec-the-netherlands/page-data.json": [
		"hDJV",
		625
	],
	"./page-data/en/connect-with-us/imec-usa-florida/page-data.json": [
		"okRw",
		626
	],
	"./page-data/en/connect-with-us/imec-usa/page-data.json": [
		"WHu2",
		627
	],
	"./page-data/en/connect-with-us/imomec-imec-research-group-at-university-of-hasselt/page-data.json": [
		"jR14",
		628
	],
	"./page-data/en/connect-with-us/intec-imec-research-group-at-ghent-university/page-data.json": [
		"VkCA",
		629
	],
	"./page-data/en/connect-with-us/ipi-imec-reseach-group-at-ghent-university/page-data.json": [
		"83C6",
		630
	],
	"./page-data/en/connect-with-us/itec/page-data.json": [
		"NJGA",
		631
	],
	"./page-data/en/connect-with-us/mict-imec-reseach-group-at-ghent-university/page-data.json": [
		"+rpu",
		632
	],
	"./page-data/en/connect-with-us/page-data.json": [
		"tebb",
		633
	],
	"./page-data/en/connect-with-us/request-form-to-visit-imec/page-data.json": [
		"rztP",
		634
	],
	"./page-data/en/connect-with-us/sales-contacts/page-data.json": [
		"NbXW",
		635
	],
	"./page-data/en/connect-with-us/smit-an-imec-research-group-at-vub/page-data.json": [
		"6mmh",
		636
	],
	"./page-data/en/connect-with-us/visionlab-imec-research-group-at-university-of-antwerp/page-data.json": [
		"if0e",
		637
	],
	"./page-data/en/connect-with-us/waves-imec-reseach-group-at-ghent-university/page-data.json": [
		"Jd6i",
		638
	],
	"./page-data/en/connected-health-solutions/dry-eeg-electrodes/page-data.json": [
		"RjIo",
		639
	],
	"./page-data/en/connected-health-solutions/gait-analysis/page-data.json": [
		"Uo4B",
		640
	],
	"./page-data/en/connected-health-solutions/innovative-algorithms-for-actionable-insights/page-data.json": [
		"RMJN",
		641
	],
	"./page-data/en/connected-health-solutions/neurotechnology/page-data.json": [
		"M/tR",
		642
	],
	"./page-data/en/connected-health-solutions/new-dialysis-approaches-using-microelectronics-nanotechnology/page-data.json": [
		"eqbW",
		643
	],
	"./page-data/en/connected-health-solutions/non-contact-vital-sign-sensing/page-data.json": [
		"ZxUD",
		644
	],
	"./page-data/en/connected-health-solutions/ophthalmology/page-data.json": [
		"vXsn",
		645
	],
	"./page-data/en/connected-health-solutions/page-data.json": [
		"O1i9",
		646
	],
	"./page-data/en/connected-health-solutions/pain-and-stress-monitoring/page-data.json": [
		"fOkr",
		647
	],
	"./page-data/en/connected-health-solutions/partner-with-imec-for-your-medical-device-r-d/page-data.json": [
		"jVIe",
		648
	],
	"./page-data/en/connected-health-solutions/patent-request/page-data.json": [
		"VF9M",
		649
	],
	"./page-data/en/connected-health-solutions/remote-vital-sign-monitoring-technologies-for-the-new-standard-of-care/page-data.json": [
		"0o3e",
		650
	],
	"./page-data/en/connected-health-solutions/remote-vital-sign-monitoring-technologies-for-the-new-standard-of-care/remote-vital-sign-monitoring-technologies-for-the-new-standard-of-care-video-session-1/page-data.json": [
		"epqg",
		651
	],
	"./page-data/en/connected-health-solutions/remote-vital-sign-monitoring-technologies-for-the-new-standard-of-care/remote-vital-sign-monitoring-technologies-for-the-new-standard-of-care-video-session-2/page-data.json": [
		"7S3h",
		652
	],
	"./page-data/en/connected-health-solutions/sleep-monitoring-technology/page-data.json": [
		"tQ0r",
		653
	],
	"./page-data/en/connected-health-solutions/stay-ahead-with-imec-s-latest-developments-in-connected-health-solutions/page-data.json": [
		"x2Se",
		654
	],
	"./page-data/en/connected-health-solutions/systems-on-chip-for-medical-sensor-devices/page-data.json": [
		"1KXO",
		655
	],
	"./page-data/en/connected-health-solutions/technology-for-respiratory-care/page-data.json": [
		"jfvn",
		656
	],
	"./page-data/en/connected-health-solutions/the-future-of-respiratory-monitoring-invisible-mobile-accurate/page-data.json": [
		"0BJK",
		657
	],
	"./page-data/en/connected-health-solutions/the-future-of-respiratory-monitoring-invisible-mobile-accurate/recording-the-future-of-respiratory-monitoring-invisible-mobile-accurate-10am-pt-7pm-cest-session/page-data.json": [
		"RlNa",
		658
	],
	"./page-data/en/connected-health-solutions/the-future-of-respiratory-monitoring-invisible-mobile-accurate/recording-the-future-of-respiratory-monitoring-invisible-mobile-accurate-3pm-cst-9am-cest-session/page-data.json": [
		"VMZ5",
		659
	],
	"./page-data/en/connected-health-solutions/vital-sign-monitoring/page-data.json": [
		"xDyK",
		660
	],
	"./page-data/en/connected-health-solutions/watch-the-video-of-the-kidnew-meeting-on-wearable-and-implantable-kidneys/page-data.json": [
		"Hi4Q",
		661
	],
	"./page-data/en/contractor-portal/page-data.json": [
		"0pKx",
		662
	],
	"./page-data/en/covid-19/page-data.json": [
		"Um2u",
		663
	],
	"./page-data/en/data-mining/page-data.json": [
		"CdG6",
		664
	],
	"./page-data/en/data-science-and-security/Strategy-commonly-used-by-cloud-based-security-providers-to-protect-customers-websites-proves-not-to-be-foolproof/page-data.json": [
		"IwMt",
		665
	],
	"./page-data/en/data-science-and-security/page-data.json": [
		"CZbA",
		666
	],
	"./page-data/en/data-science/page-data.json": [
		"47u0",
		667
	],
	"./page-data/en/data-security-privacy-innovations/page-data.json": [
		"2YpI",
		668
	],
	"./page-data/en/data-visualization/page-data.json": [
		"ecOC",
		669
	],
	"./page-data/en/de-techpeditie/page-data.json": [
		"Grrd",
		670
	],
	"./page-data/en/digimeter-2016/devices-connections/page-data.json": [
		"xy9l",
		671
	],
	"./page-data/en/digimeter-2016/digimeter-profiles/page-data.json": [
		"PREl",
		672
	],
	"./page-data/en/digimeter-2016/download/page-data.json": [
		"E02S",
		673
	],
	"./page-data/en/digimeter-2016/gaming/page-data.json": [
		"+/tk",
		674
	],
	"./page-data/en/digimeter-2016/general-media/page-data.json": [
		"4p0R",
		675
	],
	"./page-data/en/digimeter-2016/messaging/page-data.json": [
		"g5CF",
		676
	],
	"./page-data/en/digimeter-2016/news-consumption/page-data.json": [
		"J5W/",
		677
	],
	"./page-data/en/digimeter-2016/radio-music/page-data.json": [
		"/Elq",
		678
	],
	"./page-data/en/digimeter-2016/social-media/page-data.json": [
		"Fbva",
		679
	],
	"./page-data/en/digimeter-2016/tv-video/page-data.json": [
		"rdFy",
		680
	],
	"./page-data/en/digimeter2017/devices-connections/page-data.json": [
		"os1D",
		681
	],
	"./page-data/en/digimeter2017/gaming/page-data.json": [
		"XgDp",
		682
	],
	"./page-data/en/digimeter2017/general-media/page-data.json": [
		"TrNq",
		683
	],
	"./page-data/en/digimeter2017/imec-digimeter-download/page-data.json": [
		"CWOt",
		684
	],
	"./page-data/en/digimeter2017/media-profiles/page-data.json": [
		"SKiG",
		685
	],
	"./page-data/en/digimeter2017/messaging-communication/page-data.json": [
		"fzBN",
		686
	],
	"./page-data/en/digimeter2017/news-consumption/page-data.json": [
		"48mi",
		687
	],
	"./page-data/en/digimeter2017/page-data.json": [
		"gjcr",
		688
	],
	"./page-data/en/digimeter2017/radio-music/page-data.json": [
		"DkIh",
		689
	],
	"./page-data/en/digimeter2017/social-media/page-data.json": [
		"ApFd",
		690
	],
	"./page-data/en/digimeter2017/tv-video/page-data.json": [
		"zA6q",
		691
	],
	"./page-data/en/digimeter2018/artificial-intelligence/page-data.json": [
		"GB01",
		692
	],
	"./page-data/en/digimeter2018/attitudes-to-technology/page-data.json": [
		"C5lq",
		693
	],
	"./page-data/en/digimeter2018/devices-connections/page-data.json": [
		"1vxY",
		694
	],
	"./page-data/en/digimeter2018/e-commerce-sharing-economy-makers/page-data.json": [
		"Fu7U",
		695
	],
	"./page-data/en/digimeter2018/imec-digimeter-2018-download/page-data.json": [
		"d5zw",
		696
	],
	"./page-data/en/digimeter2018/news/page-data.json": [
		"GRSE",
		697
	],
	"./page-data/en/digimeter2018/page-data.json": [
		"9gp4",
		698
	],
	"./page-data/en/digimeter2018/privacy/page-data.json": [
		"DUFo",
		699
	],
	"./page-data/en/digimeter2018/profiles/page-data.json": [
		"bLr6",
		700
	],
	"./page-data/en/digimeter2018/social-media/page-data.json": [
		"9vtA",
		701
	],
	"./page-data/en/digimeter2018/video-audio-gaming/page-data.json": [
		"m7xn",
		702
	],
	"./page-data/en/digimeter2018/virtual-reality-augmented-reality/page-data.json": [
		"ONJV",
		703
	],
	"./page-data/en/disclaimer-imec/page-data.json": [
		"EWD9",
		704
	],
	"./page-data/en/eeg/page-data.json": [
		"aiqY",
		705
	],
	"./page-data/en/ehealthmonitor/page-data.json": [
		"bKPQ",
		706
	],
	"./page-data/en/email-disclaimer/page-data.json": [
		"3eY6",
		707
	],
	"./page-data/en/empoweringgirls/page-data.json": [
		"eBst",
		708
	],
	"./page-data/en/energy-technologies/page-data.json": [
		"AKzf",
		709
	],
	"./page-data/en/energy-technologies/power-to-molecules-p2m/page-data.json": [
		"xGzj",
		710
	],
	"./page-data/en/engineering/page-data.json": [
		"/ZCk",
		711
	],
	"./page-data/en/eog/page-data.json": [
		"EOGZ",
		712
	],
	"./page-data/en/european-network-of-livinglabs/page-data.json": [
		"//Zi",
		713
	],
	"./page-data/en/exclusive-vip-dinner-on-may-13-in-antwerp/page-data.json": [
		"Ott4",
		714
	],
	"./page-data/en/expertise/life-sciences-2018/whitepaper/page-data.json": [
		"eTGE",
		715
	],
	"./page-data/en/expertise/lifesciences/biophotonics/page-data.json": [
		"Q6Sy",
		716
	],
	"./page-data/en/expertise/lifesciences/biosensors/page-data.json": [
		"Qunu",
		717
	],
	"./page-data/en/expertise/lifesciences/cell-and-gene-therapy/page-data.json": [
		"cEUh",
		718
	],
	"./page-data/en/expertise/lifesciences/diagnostics/page-data.json": [
		"iUu9",
		719
	],
	"./page-data/en/expertise/lifesciences/genomics/dna-sequence-analysis-software/page-data.json": [
		"34L7",
		720
	],
	"./page-data/en/expertise/lifesciences/genomics/page-data.json": [
		"gdjj",
		721
	],
	"./page-data/en/expertise/lifesciences/high-throughput-cytometry-and-cell-sorting-facs/page-data.json": [
		"2KJT",
		722
	],
	"./page-data/en/expertise/lifesciences/medical-imaging/page-data.json": [
		"7pcf",
		723
	],
	"./page-data/en/expertise/lifesciences/microfluidics/page-data.json": [
		"QLo2",
		724
	],
	"./page-data/en/expertise/lifesciences/neural-probes/page-data.json": [
		"Bbu2",
		725
	],
	"./page-data/en/expertise/lifesciences/neurotech/page-data.json": [
		"HjH4",
		726
	],
	"./page-data/en/expertise/lifesciences/pcr-on-chip/page-data.json": [
		"oVxs",
		727
	],
	"./page-data/en/expertise/lifesciences/smart-implantable-devices/page-data.json": [
		"JW4J",
		728
	],
	"./page-data/en/expertise/lifesciences/smart-medical-devices/page-data.json": [
		"ryE7",
		729
	],
	"./page-data/en/expertise/page-data.json": [
		"bYoj",
		730
	],
	"./page-data/en/expertise/radar-sensing-systems/140ghz-radar-modules/page-data.json": [
		"17aS",
		731
	],
	"./page-data/en/expertise/sensors-for-iot/secure-system-solutions/distance-bounding-white-paper/page-data.json": [
		"X6ka",
		732
	],
	"./page-data/en/expertise/sensors-for-iot/secure-system-solutions/page-data.json": [
		"+TaK",
		733
	],
	"./page-data/en/expertise/sensors-for-iot/sensor-network-testbeds/page-data.json": [
		"0WOR",
		734
	],
	"./page-data/en/expertise/sensors-for-iot/sensors-for-iot/page-data.json": [
		"K5sC",
		735
	],
	"./page-data/en/expertise/sensors-for-iot/ultra-low-power-iot-radios/page-data.json": [
		"p+7f",
		736
	],
	"./page-data/en/expertise/wearables/advanced-algorithms/page-data.json": [
		"kxWT",
		737
	],
	"./page-data/en/flexible-and-stretchable-electronics/page-data.json": [
		"Mp1i",
		738
	],
	"./page-data/en/flexible-electronics/page-data.json": [
		"xNut",
		739
	],
	"./page-data/en/flexlines/page-data.json": [
		"EawN",
		740
	],
	"./page-data/en/fundamental-research-in-life-sciences/page-data.json": [
		"SHS0",
		741
	],
	"./page-data/en/home/page-data.json": [
		"SFB1",
		742
	],
	"./page-data/en/hyperspectral-imaging/page-data.json": [
		"n4E4",
		743
	],
	"./page-data/en/ic-link/imec-ic-link-partners/page-data.json": [
		"0zCa",
		744
	],
	"./page-data/en/ic-link/page-data.json": [
		"WGpO",
		745
	],
	"./page-data/en/icon/Airobot-how-onestart-up-is-revolutionizing-the-drone-industry/page-data.json": [
		"9Dw7",
		746
	],
	"./page-data/en/icon/faq/faq-about-intellectual-property-rights-ipr/page-data.json": [
		"iPQV",
		747
	],
	"./page-data/en/icon/faq/page-data.json": [
		"VKoy",
		748
	],
	"./page-data/en/icon/myproject-video-tutorials/page-data.json": [
		"KxUg",
		749
	],
	"./page-data/en/icon/open-call/page-data.json": [
		"t87t",
		750
	],
	"./page-data/en/icon/page-data.json": [
		"rUfO",
		751
	],
	"./page-data/en/icon/project-documents/page-data.json": [
		"BZU6",
		752
	],
	"./page-data/en/imaging-vision-systems/handheld-raman-spectrometer-technology/page-data.json": [
		"431j",
		753
	],
	"./page-data/en/imaging-vision-systems/page-data.json": [
		"BNJz",
		754
	],
	"./page-data/en/imaging-vision-systems/pixel-technology-explore/page-data.json": [
		"zeIT",
		755
	],
	"./page-data/en/imec-ai-barometer/page-data.json": [
		"19d8",
		756
	],
	"./page-data/en/imec-cookie-policy/page-data.json": [
		"1X+1",
		757
	],
	"./page-data/en/imec-digimeter-2019/page-data.json": [
		"N4OE",
		758
	],
	"./page-data/en/imec-leti-workshop-iedm/page-data.json": [
		"wMvi",
		759
	],
	"./page-data/en/imec-magazine/best-of-2016/chips-must-learn-how-to-feel-pain-and-how-to-cure-themselves/page-data.json": [
		"Zr1v",
		760
	],
	"./page-data/en/imec-magazine/best-of-2016/everything-gets-smart-and-imec-can-give-a-helping-hand/page-data.json": [
		"zszx",
		761
	],
	"./page-data/en/imec-magazine/best-of-2016/imec-enters-the-race-to-unleash-quantum-computing-with-silicon-qubits/page-data.json": [
		"cx5V",
		762
	],
	"./page-data/en/imec-magazine/best-of-2016/imec-s-new-design-center-for-photonics-and-high-speed-electronics/page-data.json": [
		"rVFZ",
		763
	],
	"./page-data/en/imec-magazine/best-of-2016/joint-european-effort-to-unlock-the-potential-of-graphene/page-data.json": [
		"8cMf",
		764
	],
	"./page-data/en/imec-magazine/best-of-2016/making-perovskite-solar-cells-ready-for-the-market/page-data.json": [
		"g6b3",
		765
	],
	"./page-data/en/imec-magazine/best-of-2016/photolithography-a-key-technology-for-next-generation-high-resolution-amoled-displays/page-data.json": [
		"5OEZ",
		766
	],
	"./page-data/en/imec-magazine/best-of-2016/quantifying-a-tumor-s-response-to-treatment-earlier-and-more-accurately/page-data.json": [
		"/Rql",
		767
	],
	"./page-data/en/imec-magazine/best-of-2016/sensor-bracelet-detects-epileptic-seizures/page-data.json": [
		"ZMdP",
		768
	],
	"./page-data/en/imec-magazine/best-of-2016/this-optical-antenna-is-a-magic-wand-for-light/page-data.json": [
		"hd8l",
		769
	],
	"./page-data/en/imec-magazine/imec-magazine-ai-special/accurate-personalized-and-predictive-healthcare-within-reach/page-data.json": [
		"1KEB",
		770
	],
	"./page-data/en/imec-magazine/imec-magazine-ai-special/affordable-ai-in-the-box/page-data.json": [
		"AlFM",
		771
	],
	"./page-data/en/imec-magazine/imec-magazine-ai-special/ai-in-industry-4-0-two-angles-to-value-creation/page-data.json": [
		"aYQG",
		772
	],
	"./page-data/en/imec-magazine/imec-magazine-ai-special/bringing-ai-to-the-edge/page-data.json": [
		"ZXfw",
		773
	],
	"./page-data/en/imec-magazine/imec-magazine-ai-special/clinical-genomics-affordable-for-daily-use-in-hospital/page-data.json": [
		"77C4",
		774
	],
	"./page-data/en/imec-magazine/imec-magazine-ai-special/flanders-amongst-the-global-leaders-in-ai-research-and-transfer-to-industry/page-data.json": [
		"uq9c",
		775
	],
	"./page-data/en/imec-magazine/imec-magazine-ai-special/flanders-invests-30-million-in-artificial-intelligence/page-data.json": [
		"HxV6",
		776
	],
	"./page-data/en/imec-magazine/imec-magazine-ai-special/from-self-driving-car-to-smart-mobility-system/page-data.json": [
		"bSsC",
		777
	],
	"./page-data/en/imec-magazine/imec-magazine-ai-special/gifted-digital-twin/page-data.json": [
		"7wh+",
		778
	],
	"./page-data/en/imec-magazine/imec-magazine-ai-special/less-jobs-or-fewer-accidents/page-data.json": [
		"ZtsV",
		779
	],
	"./page-data/en/imec-magazine/imec-magazine-ai-special/news-from-2035/page-data.json": [
		"iUNW",
		780
	],
	"./page-data/en/imec-magazine/imec-magazine-ai-special/object-recognition-in-augmented-reality/page-data.json": [
		"m7LW",
		781
	],
	"./page-data/en/imec-magazine/imec-magazine-ai-special/radar-and-video-a-cooperative-method-for-sensor-fusion/page-data.json": [
		"0pfh",
		782
	],
	"./page-data/en/imec-magazine/imec-magazine-ai-special/reducing-the-risks-of-premature-births/page-data.json": [
		"hiEm",
		783
	],
	"./page-data/en/imec-magazine/imec-magazine-ai-special/smart-spectrum-management/page-data.json": [
		"E3T3",
		784
	],
	"./page-data/en/imec-magazine/imec-magazine-ai-special/test-shows-how-cars-can-work-together-to-avoid-accidents/page-data.json": [
		"TDjH",
		785
	],
	"./page-data/en/imec-magazine/imec-magazine-ai-special/the-tower-of-babel-human-like-ai/page-data.json": [
		"/nm8",
		786
	],
	"./page-data/en/imec-magazine/imec-magazine-ai-special/three-proof-of-concepts-for-edge-ai/page-data.json": [
		"mB3V",
		787
	],
	"./page-data/en/imec-magazine/imec-magazine-ai-special/three-proof-of-concepts-for-man-machine-communication/page-data.json": [
		"rRUu",
		788
	],
	"./page-data/en/imec-magazine/imec-magazine-april-2017/3d-systems-on-chip/page-data.json": [
		"dhLY",
		789
	],
	"./page-data/en/imec-magazine/imec-magazine-april-2017/60ghz-technology-for-wigig-and-5g-applications/page-data.json": [
		"qHWV",
		790
	],
	"./page-data/en/imec-magazine/imec-magazine-april-2017/chips-with-fingerprints-make-the-connected-world-safer/page-data.json": [
		"ka4g",
		791
	],
	"./page-data/en/imec-magazine/imec-magazine-april-2017/cumul-io-turning-your-company-s-data-into-knowledge/page-data.json": [
		"hN8O",
		792
	],
	"./page-data/en/imec-magazine/imec-magazine-april-2017/imec-livinglabs-promotes-intrapreneurship-and-user-innovation-in-organizations/page-data.json": [
		"lBUT",
		793
	],
	"./page-data/en/imec-magazine/imec-magazine-april-2017/preface/page-data.json": [
		"fSWq",
		794
	],
	"./page-data/en/imec-magazine/imec-magazine-april-2017/the-5-highlights-of-march/page-data.json": [
		"6HSn",
		795
	],
	"./page-data/en/imec-magazine/imec-magazine-april-2017/will-our-future-colleagues-be-humanoid-robots/page-data.json": [
		"BrKO",
		796
	],
	"./page-data/en/imec-magazine/imec-magazine-april-2018/assessing-nanorisks-in-the-semiconductor-industry/page-data.json": [
		"4aF/",
		797
	],
	"./page-data/en/imec-magazine/imec-magazine-april-2018/developing-silicon-photonics-technologies-with-a-wafer-level-test-station/page-data.json": [
		"8ZRS",
		798
	],
	"./page-data/en/imec-magazine/imec-magazine-april-2018/from-bright-idea-to-booming-business-imec-s-venturing-opportunities/page-data.json": [
		"MpUc",
		799
	],
	"./page-data/en/imec-magazine/imec-magazine-april-2018/fundamental-study-unlocks-potential-of-organic-semiconductors/page-data.json": [
		"Q9MW",
		800
	],
	"./page-data/en/imec-magazine/imec-magazine-april-2018/preface-april-2018/page-data.json": [
		"2mBD",
		801
	],
	"./page-data/en/imec-magazine/imec-magazine-april-2018/the-five-highlights-of-march-2018/page-data.json": [
		"OP7N",
		802
	],
	"./page-data/en/imec-magazine/imec-magazine-april-2019/how-can-you-help-lonely-seniors-not-with-a-talking-flowerpot-but-by-having-people-actually-go-and-visit-them-courtesy-of-technology/page-data.json": [
		"BiGW",
		803
	],
	"./page-data/en/imec-magazine/imec-magazine-april-2019/in-line-software-closes-the-quality-gap-between-lens-and-imager/page-data.json": [
		"zaxb",
		804
	],
	"./page-data/en/imec-magazine/imec-magazine-april-2019/preface-april-2019/page-data.json": [
		"DMc+",
		805
	],
	"./page-data/en/imec-magazine/imec-magazine-april-2019/putting-a-yes-in-no-se/page-data.json": [
		"G95x",
		806
	],
	"./page-data/en/imec-magazine/imec-magazine-april-2019/silicon-magic-designing-and-fabricating-fully-customized-chips/page-data.json": [
		"EopT",
		807
	],
	"./page-data/en/imec-magazine/imec-magazine-april-2019/solving-the-contact-resistance-challenge-for-7nm-and-beyond-cmos/page-data.json": [
		"hGoV",
		808
	],
	"./page-data/en/imec-magazine/imec-magazine-april-2019/the-five-highlights-of-march-2019/page-data.json": [
		"16do",
		809
	],
	"./page-data/en/imec-magazine/imec-magazine-april-2019/will-our-children-remember-the-taste-of-steak/page-data.json": [
		"0Nse",
		810
	],
	"./page-data/en/imec-magazine/imec-magazine-april-2020/monitoring-water-quality-in-flanders/page-data.json": [
		"icQe",
		811
	],
	"./page-data/en/imec-magazine/imec-magazine-april-2020/romware-teams-up-with-imec-for-the-development-of-its-wearable-worker-safety-device/page-data.json": [
		"iffX",
		812
	],
	"./page-data/en/imec-magazine/imec-magazine-april-2020/temporary-bonding-and-mold-process-to-enable-next-gen-fan-out-wafer-level-packaging/page-data.json": [
		"ouop",
		813
	],
	"./page-data/en/imec-magazine/imec-magazine-april-2020/the-medical-implants-of-the-future-faster-smarter-and-more-connected/page-data.json": [
		"XxdN",
		814
	],
	"./page-data/en/imec-magazine/imec-magazine-december-2019/can-we-integrate-solar-cells-in-sound-barriers-cycle-paths-and-motorways/page-data.json": [
		"fcw7",
		815
	],
	"./page-data/en/imec-magazine/imec-magazine-december-2019/preface-december-2019/page-data.json": [
		"84/Y",
		816
	],
	"./page-data/en/imec-magazine/imec-magazine-december-2019/scaling-cmos-beyond-finfets-from-nanosheets-and-forksheets-to-cfets/page-data.json": [
		"lner",
		817
	],
	"./page-data/en/imec-magazine/imec-magazine-december-2019/silicon-photonics-technology-for-next-generation-datacenter-interconnect/page-data.json": [
		"kCbi",
		818
	],
	"./page-data/en/imec-magazine/imec-magazine-december-2019/the-5-highlights-of-november-2019/page-data.json": [
		"1IV0",
		819
	],
	"./page-data/en/imec-magazine/imec-magazine-december-2019/the-future-of-connectivity/page-data.json": [
		"uNZN",
		820
	],
	"./page-data/en/imec-magazine/imec-magazine-december-2019/why-a-smart-city-can-be-so-much-more-than-just-the-sum-of-its-smart-parts/page-data.json": [
		"N2JK",
		821
	],
	"./page-data/en/imec-magazine/imec-magazine-february-2017/a-personal-assistant-at-your-side/page-data.json": [
		"X7Vr",
		822
	],
	"./page-data/en/imec-magazine/imec-magazine-february-2017/a-smartwatch-for-getting-patients-faster-from-a-to-b/page-data.json": [
		"OuPT",
		823
	],
	"./page-data/en/imec-magazine/imec-magazine-february-2017/harvesting-sunlight-from-both-sides-of-pv-cells-may-give-pv-plants-a-significant-energy-boost/page-data.json": [
		"xDE7",
		824
	],
	"./page-data/en/imec-magazine/imec-magazine-february-2017/improving-user-experience-and-security-at-large-public-events/page-data.json": [
		"4Fgc",
		825
	],
	"./page-data/en/imec-magazine/imec-magazine-february-2017/preface/page-data.json": [
		"A77X",
		826
	],
	"./page-data/en/imec-magazine/imec-magazine-february-2017/spotcrowd-connecting-the-crowd-to-spot-shoplifters/page-data.json": [
		"cNGJ",
		827
	],
	"./page-data/en/imec-magazine/imec-magazine-february-2017/the-consumption-of-digital-media-is-increasing-but-is-this-synonymous-with-problematic-use/page-data.json": [
		"PI4c",
		828
	],
	"./page-data/en/imec-magazine/imec-magazine-february-2017/towards-improved-data-retention-in-oxrram-memory-devices/page-data.json": [
		"iGwF",
		829
	],
	"./page-data/en/imec-magazine/imec-magazine-february-2018/Lost-in-information-ontoforce-s-search-engine-connects-your-data/page-data.json": [
		"vkWT",
		830
	],
	"./page-data/en/imec-magazine/imec-magazine-february-2018/engineering-better-batteries-to-drive-the-electrified-future/page-data.json": [
		"/gqf",
		831
	],
	"./page-data/en/imec-magazine/imec-magazine-february-2018/metrology-is-not-a-cost-factor-but-a-profit-center/page-data.json": [
		"VI9j",
		832
	],
	"./page-data/en/imec-magazine/imec-magazine-february-2018/preface-february-2018/page-data.json": [
		"p79W",
		833
	],
	"./page-data/en/imec-magazine/imec-magazine-february-2018/tackling-the-challenges-of-5g-with-hybrid-iii-v-si-technology/page-data.json": [
		"nyzp",
		834
	],
	"./page-data/en/imec-magazine/imec-magazine-february-2018/the-five-highlights-of-january-2018/page-data.json": [
		"F9p7",
		835
	],
	"./page-data/en/imec-magazine/imec-magazine-february-2018/what-chip-technology-can-do-for-cell-therapy/page-data.json": [
		"Cel8",
		836
	],
	"./page-data/en/imec-magazine/imec-magazine-february-2019/a-300mm-platform-for-2d-material-based-mosfet-devices/page-data.json": [
		"emZt",
		837
	],
	"./page-data/en/imec-magazine/imec-magazine-february-2019/a-cold-shower-for-chips/page-data.json": [
		"nrHz",
		838
	],
	"./page-data/en/imec-magazine/imec-magazine-february-2019/artificial-intelligence-finds-reliable-path-through-wireless-jungle/page-data.json": [
		"mACh",
		839
	],
	"./page-data/en/imec-magazine/imec-magazine-february-2019/belgian-tech-start-ups-on-a-mission-to-expand-their-business-internationally/page-data.json": [
		"q7Mh",
		840
	],
	"./page-data/en/imec-magazine/imec-magazine-february-2019/preface-february-2019/page-data.json": [
		"qoHa",
		841
	],
	"./page-data/en/imec-magazine/imec-magazine-february-2019/sensor-searches-demanding-application/page-data.json": [
		"ZOPy",
		842
	],
	"./page-data/en/imec-magazine/imec-magazine-february-2019/the-five-highlights-of-january-2019/page-data.json": [
		"vrcS",
		843
	],
	"./page-data/en/imec-magazine/imec-magazine-february-2019/what-if-we-all-drive-electric-cars-this-algorithm-makes-sure-the-light-stays-on/page-data.json": [
		"OBHB",
		844
	],
	"./page-data/en/imec-magazine/imec-magazine-february-2020/battery-day-2020-shifting-gears-to-solid-state-battery-technology/page-data.json": [
		"hFki",
		845
	],
	"./page-data/en/imec-magazine/imec-magazine-february-2020/building-patterns-from-the-bottom-a-complementary-approach-to-lithography/page-data.json": [
		"pSxJ",
		846
	],
	"./page-data/en/imec-magazine/imec-magazine-february-2020/immunotherapy-beyond-the-promises/page-data.json": [
		"lu+6",
		847
	],
	"./page-data/en/imec-magazine/imec-magazine-february-2020/new-software-makes-the-diagnosis-of-rare-diseases-less-of-an-odyssey/page-data.json": [
		"oAH5",
		848
	],
	"./page-data/en/imec-magazine/imec-magazine-february-2020/ultra-sensitive-and-low-power-radar-enables-intuitive-human-computer-interaction/page-data.json": [
		"py2Z",
		849
	],
	"./page-data/en/imec-magazine/imec-magazine-january-2017/intro-enabling-the-intuitive-internet-of-things/page-data.json": [
		"ozRJ",
		850
	],
	"./page-data/en/imec-magazine/imec-magazine-january-2017/preface/page-data.json": [
		"gmuF",
		851
	],
	"./page-data/en/imec-magazine/imec-magazine-january-2017/the-highlights-of-2016/page-data.json": [
		"2Esa",
		852
	],
	"./page-data/en/imec-magazine/imec-magazine-january-2017/vision-a-living-lab-for-smart-cities-worldwide/page-data.json": [
		"hP3k",
		853
	],
	"./page-data/en/imec-magazine/imec-magazine-january-2017/vision-a-new-era-in-mobility/page-data.json": [
		"1wvV",
		854
	],
	"./page-data/en/imec-magazine/imec-magazine-january-2017/vision-dna-sequencing-becoming-routine/page-data.json": [
		"TgXy",
		855
	],
	"./page-data/en/imec-magazine/imec-magazine-january-2017/vision-helping-companies-small-and-big-translate-innovative-ideas-into-market-ready-solutions/page-data.json": [
		"EG0U",
		856
	],
	"./page-data/en/imec-magazine/imec-magazine-january-2017/vision-imec-digs-into-the-goldmine-of-flemish-high-tech/page-data.json": [
		"Et83",
		857
	],
	"./page-data/en/imec-magazine/imec-magazine-january-2017/vision-interplay-between-chip-and-digital-technologies-crucial-for-the-iot/page-data.json": [
		"LL3W",
		858
	],
	"./page-data/en/imec-magazine/imec-magazine-january-2017/vision-optimizing-technology-for-iot-systems-adding-fingerprints-and-brains/page-data.json": [
		"ScXs",
		859
	],
	"./page-data/en/imec-magazine/imec-magazine-january-2017/vision-renewable-energy-and-ict-for-a-sustainable-energy-system/page-data.json": [
		"OY86",
		860
	],
	"./page-data/en/imec-magazine/imec-magazine-january-2017/vision-technologies-to-extend-semiconductor-scaling/page-data.json": [
		"XXAJ",
		861
	],
	"./page-data/en/imec-magazine/imec-magazine-january-2017/vision-the-fourth-industrial-revolution-is-underway/page-data.json": [
		"zsKi",
		862
	],
	"./page-data/en/imec-magazine/imec-magazine-january-2019/2018-in-10-highlights/page-data.json": [
		"mlTO",
		863
	],
	"./page-data/en/imec-magazine/imec-magazine-january-2019/ai-systems-will-become-our-workmates-workmates-we-understand-and-trust/page-data.json": [
		"DqfC",
		864
	],
	"./page-data/en/imec-magazine/imec-magazine-january-2019/ai-takes-the-guesswork-out-of-being-human/page-data.json": [
		"J73f",
		865
	],
	"./page-data/en/imec-magazine/imec-magazine-january-2019/ar-glasses-have-the-potential-to-replace-the-smartphone-within-10-15-years-from-now/page-data.json": [
		"OTAs",
		866
	],
	"./page-data/en/imec-magazine/imec-magazine-january-2019/at-the-tipping-point-of-a-new-energy-era/page-data.json": [
		"owZi",
		867
	],
	"./page-data/en/imec-magazine/imec-magazine-january-2019/back-to-the-future-how-we-will-regain-control-of-our-personal-data/page-data.json": [
		"vS8t",
		868
	],
	"./page-data/en/imec-magazine/imec-magazine-january-2019/by-2035-you-will-manage-your-health-like-a-bank-account/page-data.json": [
		"pGy/",
		869
	],
	"./page-data/en/imec-magazine/imec-magazine-january-2019/in-2035-quantum-processors-with-a-few-thousand-qubits-will-run-first-small-applications/page-data.json": [
		"m32c",
		870
	],
	"./page-data/en/imec-magazine/imec-magazine-january-2019/it-s-all-about-letterboxes-fashion-designers-and-scooters-the-city-of-the-future-where-you-ll-definitely-want-to-live/page-data.json": [
		"0Fjl",
		871
	],
	"./page-data/en/imec-magazine/imec-magazine-january-2019/man-and-machine-collaborating-on-the-factory-floor-a-nightmare-or-a-match-made-in-heaven/page-data.json": [
		"2fMC",
		872
	],
	"./page-data/en/imec-magazine/imec-magazine-january-2019/michael-peeters-on-networks/page-data.json": [
		"S+8p",
		873
	],
	"./page-data/en/imec-magazine/imec-magazine-january-2019/on-martians-and-telepresence/page-data.json": [
		"OG1h",
		874
	],
	"./page-data/en/imec-magazine/imec-magazine-january-2019/preface-luc-van-den-hove/page-data.json": [
		"XLxQ",
		875
	],
	"./page-data/en/imec-magazine/imec-magazine-january-2019/the-post-smartphone-era-everyone-an-engineer/page-data.json": [
		"47Y3",
		876
	],
	"./page-data/en/imec-magazine/imec-magazine-january-2019/will-technology-know-students-better-than-their-teacher/page-data.json": [
		"XEiY",
		877
	],
	"./page-data/en/imec-magazine/imec-magazine-july-2017/a-breakthrough-camera-solution-for-harsh-weather-conditions/page-data.json": [
		"d+9B",
		878
	],
	"./page-data/en/imec-magazine/imec-magazine-july-2017/bringing-a-new-level-of-security-and-privacy-to-cloud-services/page-data.json": [
		"76oB",
		879
	],
	"./page-data/en/imec-magazine/imec-magazine-july-2017/chip-technology-and-photonics-enable-smaller-faster-and-cheaper-medical-devices/page-data.json": [
		"tnfc",
		880
	],
	"./page-data/en/imec-magazine/imec-magazine-july-2017/flexible-rfid-tags-for-a-smarter-interconnected-world/page-data.json": [
		"SehR",
		881
	],
	"./page-data/en/imec-magazine/imec-magazine-july-2017/interview-met-dr-kinam-kim-samsung/page-data.json": [
		"AY1Y",
		882
	],
	"./page-data/en/imec-magazine/imec-magazine-july-2017/new-implantable-chip-to-hook-up-bionic-arm-to-brain/page-data.json": [
		"OEJg",
		883
	],
	"./page-data/en/imec-magazine/imec-magazine-july-2017/preface-pushing-boundaries/page-data.json": [
		"ueRO",
		884
	],
	"./page-data/en/imec-magazine/imec-magazine-july-2017/the-5-highlights-of-june/page-data.json": [
		"z/d6",
		885
	],
	"./page-data/en/imec-magazine/imec-magazine-july-2018/a-smart-shoe-for-athletes-and-diabetics/page-data.json": [
		"7cFD",
		886
	],
	"./page-data/en/imec-magazine/imec-magazine-july-2018/a-summer-of-science-abroad/page-data.json": [
		"OF6R",
		887
	],
	"./page-data/en/imec-magazine/imec-magazine-july-2018/finding-the-needle-in-the-haystack/page-data.json": [
		"5Sxg",
		888
	],
	"./page-data/en/imec-magazine/imec-magazine-july-2018/iot-platform-for-the-process-industry/page-data.json": [
		"GEzT",
		889
	],
	"./page-data/en/imec-magazine/imec-magazine-july-2018/preface-july-2018/page-data.json": [
		"8qoe",
		890
	],
	"./page-data/en/imec-magazine/imec-magazine-july-2018/technologies-for-tomorrow-s-world/page-data.json": [
		"1j4S",
		891
	],
	"./page-data/en/imec-magazine/imec-magazine-july-2018/technology-designed-to-empower-people/page-data.json": [
		"Mo/2",
		892
	],
	"./page-data/en/imec-magazine/imec-magazine-july-2018/the-five-highlights-of-june-2018/page-data.json": [
		"eTVV",
		893
	],
	"./page-data/en/imec-magazine/imec-magazine-july-2018/what-do-capsuled-coffee-and-imec-s-eyetracking-glasses-have-in-common/page-data.json": [
		"ol5r",
		894
	],
	"./page-data/en/imec-magazine/imec-magazine-july-2019/a-3d-technology-toolbox-in-support-of-system-technology-co-optimization/page-data.json": [
		"tkGh",
		895
	],
	"./page-data/en/imec-magazine/imec-magazine-july-2019/euv-lithography-sailing-along-the-stochastic-cliffs/page-data.json": [
		"3LCi",
		896
	],
	"./page-data/en/imec-magazine/imec-magazine-july-2019/preface-july-2019/page-data.json": [
		"HABs",
		897
	],
	"./page-data/en/imec-magazine/imec-magazine-july-2019/smart-cycling-outfit-prevents-back-pain-in-riders/page-data.json": [
		"euhM",
		898
	],
	"./page-data/en/imec-magazine/imec-magazine-july-2019/the-five-highlights-of-june-2019/page-data.json": [
		"QtsJ",
		899
	],
	"./page-data/en/imec-magazine/imec-magazine-july-2019/will-this-belgian-startup-democratize-cryptocurrencies/page-data.json": [
		"AbUW",
		900
	],
	"./page-data/en/imec-magazine/imec-magazine-june-2017/first-time-demonstration-of-fully-isolated-gan-power-devices-using-soi-technology/page-data.json": [
		"yZ9r",
		901
	],
	"./page-data/en/imec-magazine/imec-magazine-june-2017/new-solution-for-testing-chips-prior-to-3d-stacking/page-data.json": [
		"ql1C",
		902
	],
	"./page-data/en/imec-magazine/imec-magazine-june-2017/preface/page-data.json": [
		"UWaR",
		903
	],
	"./page-data/en/imec-magazine/imec-magazine-june-2017/results-of-the-imec-smart-city-meter-survey/page-data.json": [
		"30Oj",
		904
	],
	"./page-data/en/imec-magazine/imec-magazine-june-2017/rethinking-the-home-grid-a-case-for-direct-current/page-data.json": [
		"//Yz",
		905
	],
	"./page-data/en/imec-magazine/imec-magazine-june-2017/tengu-data-scientists-toolbox-for-easier-and-faster-big-data-analysis/page-data.json": [
		"lg4j",
		906
	],
	"./page-data/en/imec-magazine/imec-magazine-june-2017/the-5-highlights-of-may/page-data.json": [
		"LKjW",
		907
	],
	"./page-data/en/imec-magazine/imec-magazine-june-2017/the-iot-is-coming-but-can-it-be-made-secure/page-data.json": [
		"qQZT",
		908
	],
	"./page-data/en/imec-magazine/imec-magazine-june-2018/Human-centric-intuitive-buildings/page-data.json": [
		"6pcS",
		909
	],
	"./page-data/en/imec-magazine/imec-magazine-june-2018/energy-generating-facades-will-make-offices-shine/page-data.json": [
		"Wk8Q",
		910
	],
	"./page-data/en/imec-magazine/imec-magazine-june-2018/here-is-that-good-old-roll-of-film-again/page-data.json": [
		"1ncf",
		911
	],
	"./page-data/en/imec-magazine/imec-magazine-june-2018/packaging-solution-for-gan-on-200mm-si-devices/page-data.json": [
		"yeqR",
		912
	],
	"./page-data/en/imec-magazine/imec-magazine-june-2018/preface-june-2018/page-data.json": [
		"wn3B",
		913
	],
	"./page-data/en/imec-magazine/imec-magazine-june-2018/put-your-heart-on-this-chip-and-get-a-healthier-cancer-treatment/page-data.json": [
		"Yt2q",
		914
	],
	"./page-data/en/imec-magazine/imec-magazine-june-2018/the-five-highlights-of-may-2018/page-data.json": [
		"KiOj",
		915
	],
	"./page-data/en/imec-magazine/imec-magazine-june-2018/the-internet-of-unexpected-things/page-data.json": [
		"V0NS",
		916
	],
	"./page-data/en/imec-magazine/imec-magazine-june-2018/the-potential-of-sequential-3d-integration-for-advanced-semiconductor-scaling/page-data.json": [
		"lsRR",
		917
	],
	"./page-data/en/imec-magazine/imec-magazine-june-2019/a-new-approach-to-fan-out-wafer-level-packaging/page-data.json": [
		"4SOa",
		918
	],
	"./page-data/en/imec-magazine/imec-magazine-june-2019/euv-lithography-weighing-the-options-for-future-logic-and-memory-applications/page-data.json": [
		"eCcg",
		919
	],
	"./page-data/en/imec-magazine/imec-magazine-june-2019/how-to-shrink-a-raman-spectroscope-and-analyze-complex-samples-on-the-go/page-data.json": [
		"Y/xg",
		920
	],
	"./page-data/en/imec-magazine/imec-magazine-june-2019/the-five-highlights-of-june-2019/page-data.json": [
		"IL1P",
		921
	],
	"./page-data/en/imec-magazine/imec-magazine-june-2019/the-technology-of-tomorrow-5-trends-on-the-futuresummits-demo-floor/page-data.json": [
		"eCWl",
		922
	],
	"./page-data/en/imec-magazine/imec-magazine-june-2019/triangulation-like-approach-to-wireless-charging/page-data.json": [
		"f3Ix",
		923
	],
	"./page-data/en/imec-magazine/imec-magazine-june-2020/haptic-feedback-the-next-step-in-smart-interfacing/page-data.json": [
		"q/xh",
		924
	],
	"./page-data/en/imec-magazine/imec-magazine-june-2020/technology-positions-flanders-as-a-leader-in-measuring-water-quality-monitoring/page-data.json": [
		"laVh",
		925
	],
	"./page-data/en/imec-magazine/imec-magazine-june-2020/the-history-and-future-of-dram-architectures-in-different-application-domains-an-analysis/page-data.json": [
		"KCU8",
		926
	],
	"./page-data/en/imec-magazine/imec-magazine-june-2020/the-tandem-module-a-unique-opportunity-to-reboost-eu-pv-industry/page-data.json": [
		"7J7i",
		927
	],
	"./page-data/en/imec-magazine/imec-magazine-march-2017/ava-trix-the-classroom-digital-game-showing-children-the-fun-side-of-science/page-data.json": [
		"R16x",
		928
	],
	"./page-data/en/imec-magazine/imec-magazine-march-2017/first-euv-lithography-high-volume-manufacturing-solution-for-n5-beol/page-data.json": [
		"+v4S",
		929
	],
	"./page-data/en/imec-magazine/imec-magazine-march-2017/innovative-communications-satellite-launched-with-dare-enabled-chips-inside/page-data.json": [
		"TuNb",
		930
	],
	"./page-data/en/imec-magazine/imec-magazine-march-2017/making-car-electronics-safe-again/page-data.json": [
		"tFg1",
		931
	],
	"./page-data/en/imec-magazine/imec-magazine-march-2017/new-plastic-chip-in-the-making-that-communicates-with-touchscreens/page-data.json": [
		"y6vB",
		932
	],
	"./page-data/en/imec-magazine/imec-magazine-march-2017/photonics-on-chip-makes-doctors-dream/page-data.json": [
		"qB+j",
		933
	],
	"./page-data/en/imec-magazine/imec-magazine-march-2017/preface/page-data.json": [
		"BRn8",
		934
	],
	"./page-data/en/imec-magazine/imec-magazine-march-2017/smart-apps-for-smart-cities/page-data.json": [
		"yszr",
		935
	],
	"./page-data/en/imec-magazine/imec-magazine-march-2017/the-5-highlights-of-february/page-data.json": [
		"WzOy",
		936
	],
	"./page-data/en/imec-magazine/imec-magazine-march-2018/imec-pushes-the-limits-of-euv-lithography-single-exposure-for-future-logic-and-memory-applications/page-data.json": [
		"x1SU",
		937
	],
	"./page-data/en/imec-magazine/imec-magazine-march-2018/origami-for-cells-self-folding-3d-cell-grippers-for-recording/page-data.json": [
		"E5Ln",
		938
	],
	"./page-data/en/imec-magazine/imec-magazine-march-2018/plugging-robots-into-the-iot/page-data.json": [
		"aTqP",
		939
	],
	"./page-data/en/imec-magazine/imec-magazine-march-2018/preface-march-2018/page-data.json": [
		"Da/z",
		940
	],
	"./page-data/en/imec-magazine/imec-magazine-march-2018/the-five-highlights-of-february-2018/page-data.json": [
		"KzI0",
		941
	],
	"./page-data/en/imec-magazine/imec-magazine-march-2018/ultra-small-economical-and-cheap-radar-made-possible-thanks-to-chip-technology/page-data.json": [
		"AHs+",
		942
	],
	"./page-data/en/imec-magazine/imec-magazine-march-2019/a-new-generation-of-power-electronics-will-make-electric-cars-more-efficient-and-cheap/page-data.json": [
		"NI3l",
		943
	],
	"./page-data/en/imec-magazine/imec-magazine-march-2019/new-measuring-method-discovers-and-helps-understand-electromigration-in-chips-much-more-quickly-without-destroying-them/page-data.json": [
		"PJhi",
		944
	],
	"./page-data/en/imec-magazine/imec-magazine-march-2019/preface-march-2019/page-data.json": [
		"ncQE",
		945
	],
	"./page-data/en/imec-magazine/imec-magazine-march-2019/seeing-more-of-the-living-brain-at-work/page-data.json": [
		"VTG/",
		946
	],
	"./page-data/en/imec-magazine/imec-magazine-march-2019/the-five-highlights-of-february-2019/page-data.json": [
		"QSU8",
		947
	],
	"./page-data/en/imec-magazine/imec-magazine-march-2019/unique-chip-makes-medical-plasters-possible/page-data.json": [
		"+HqJ",
		948
	],
	"./page-data/en/imec-magazine/imec-magazine-march-2020/a-design-for-test-standard-for-test-access-in-3d-integrated-circuits/page-data.json": [
		"wqth",
		949
	],
	"./page-data/en/imec-magazine/imec-magazine-may-2017/a-city-full-of-energy/page-data.json": [
		"mPVv",
		950
	],
	"./page-data/en/imec-magazine/imec-magazine-may-2017/azilpix-filming-and-broadcasting-events-becomes-a-one-man-show/page-data.json": [
		"2va0",
		951
	],
	"./page-data/en/imec-magazine/imec-magazine-may-2017/exascience-life-lab-helps-pharma-companies-dig-for-drug-candidates-in-existing-data/page-data.json": [
		"kvhV",
		952
	],
	"./page-data/en/imec-magazine/imec-magazine-may-2017/imec-looking-for-partners-to-combat-chronic-diseases/page-data.json": [
		"xsLw",
		953
	],
	"./page-data/en/imec-magazine/imec-magazine-may-2017/new-silicon-photonics-technology-delivers-faster-data-traffic-in-data-centers/page-data.json": [
		"7Xi6",
		954
	],
	"./page-data/en/imec-magazine/imec-magazine-may-2017/preface/page-data.json": [
		"J7RF",
		955
	],
	"./page-data/en/imec-magazine/imec-magazine-may-2017/smart-education-catching-up-with-the-digital-revolution/page-data.json": [
		"fGbL",
		956
	],
	"./page-data/en/imec-magazine/imec-magazine-may-2017/the-5-highlights-of-april/page-data.json": [
		"35xF",
		957
	],
	"./page-data/en/imec-magazine/imec-magazine-may-2018/a-predictor-for-solar-panels/page-data.json": [
		"Zjv6",
		958
	],
	"./page-data/en/imec-magazine/imec-magazine-may-2018/here-s-how-to-make-materials-feel-pain/page-data.json": [
		"R0pl",
		959
	],
	"./page-data/en/imec-magazine/imec-magazine-may-2018/preface-may-2018/page-data.json": [
		"gPu9",
		960
	],
	"./page-data/en/imec-magazine/imec-magazine-may-2018/the-five-highlights-of-april-2018/page-data.json": [
		"4iOK",
		961
	],
	"./page-data/en/imec-magazine/imec-magazine-may-2018/when-logic-goes-democratic/page-data.json": [
		"mmDM",
		962
	],
	"./page-data/en/imec-magazine/imec-magazine-may-2018/will-your-car-window-turn-into-a-display/page-data.json": [
		"kKZm",
		963
	],
	"./page-data/en/imec-magazine/imec-magazine-may-2019/a-compact-140ghz-radar-chip-for-detecting-small-movements-such-as-heartbeats/page-data.json": [
		"lmC9",
		964
	],
	"./page-data/en/imec-magazine/imec-magazine-may-2019/in-the-future-doctors-and-patients-will-use-wearables-every-day-there-s-no-stopping-these-advances/page-data.json": [
		"dNlE",
		965
	],
	"./page-data/en/imec-magazine/imec-magazine-may-2019/once-upon-a-time-there-were-three-princes-and-an-algorithm-how-technology-gives-you-a-personalized-and-enjoyably-surprising-day-out-in-the-city/page-data.json": [
		"oyw+",
		966
	],
	"./page-data/en/imec-magazine/imec-magazine-may-2019/preface-may-2019/page-data.json": [
		"KBor",
		967
	],
	"./page-data/en/imec-magazine/imec-magazine-may-2019/the-five-highlights-of-april-2019/page-data.json": [
		"C7be",
		968
	],
	"./page-data/en/imec-magazine/imec-magazine-may-2019/the-potential-of-artificial-diamond-from-drilling-heads-to-quantum-sensors/page-data.json": [
		"5WeQ",
		969
	],
	"./page-data/en/imec-magazine/imec-magazine-may-2020/about-qubits-and-quantum-circuits/page-data.json": [
		"EgKq",
		970
	],
	"./page-data/en/imec-magazine/imec-magazine-may-2020/covid-19-and-the-medical-uptake-of-off-the-shelf-technologies/page-data.json": [
		"nTKe",
		971
	],
	"./page-data/en/imec-magazine/imec-magazine-may-2020/iii-v-devices-on-si-for-beyond-5g-rf-front-end-modules/page-data.json": [
		"Y2aE",
		972
	],
	"./page-data/en/imec-magazine/imec-magazine-may-2020/in-the-footsteps-of-princess-leia-the-search-for-the-holy-grail-of-holography/page-data.json": [
		"4m+o",
		973
	],
	"./page-data/en/imec-magazine/imec-magazine-may-2020/power-to-molecules-a-multistage-rocket-to-a-new-energy-area/page-data.json": [
		"Wj6k",
		974
	],
	"./page-data/en/imec-magazine/imec-magazine-may-2020/towards-monolithically-integrated-all-gan-power-ics/page-data.json": [
		"SSrE",
		975
	],
	"./page-data/en/imec-magazine/imec-magazine-november-2017/An-excellent-profile-selective-epitaxy-promises-more-cost-effective-solar-cells/page-data.json": [
		"Pr2F",
		976
	],
	"./page-data/en/imec-magazine/imec-magazine-november-2017/Imec-icon-research-projects-put-Televic-Rail-on-the-right-track/page-data.json": [
		"uTWC",
		977
	],
	"./page-data/en/imec-magazine/imec-magazine-november-2017/Testing-your-product-for-real/page-data.json": [
		"hJNE",
		978
	],
	"./page-data/en/imec-magazine/imec-magazine-november-2017/When-sharing-knowledge-becomes-a-piece-of-cake/page-data.json": [
		"whnb",
		979
	],
	"./page-data/en/imec-magazine/imec-magazine-november-2017/imec-delivers-solutions-for-ultrafast-and-extremely-precise-stereovision/page-data.json": [
		"iZvS",
		980
	],
	"./page-data/en/imec-magazine/imec-magazine-november-2017/preface-november-2017/page-data.json": [
		"ZFnw",
		981
	],
	"./page-data/en/imec-magazine/imec-magazine-november-2017/the-five-highlights-of-october-2017/page-data.json": [
		"NJs4",
		982
	],
	"./page-data/en/imec-magazine/imec-magazine-november-2018/Preface-November-2018/page-data.json": [
		"Kfgv",
		983
	],
	"./page-data/en/imec-magazine/imec-magazine-november-2018/can-we-measure-happiness/page-data.json": [
		"RQyx",
		984
	],
	"./page-data/en/imec-magazine/imec-magazine-november-2018/from-mediaeval-paintings-to-holography-how-jpeg-is-revolutionizing-the-way-the-world-is-photographed-and-displayed/page-data.json": [
		"LNLs",
		985
	],
	"./page-data/en/imec-magazine/imec-magazine-november-2018/good-better-best-reliable-assessment-made-simple-with-d-pac/page-data.json": [
		"LakT",
		986
	],
	"./page-data/en/imec-magazine/imec-magazine-november-2018/industry-4-0-can-revive-europe-s-pv-sector/page-data.json": [
		"A8S5",
		987
	],
	"./page-data/en/imec-magazine/imec-magazine-november-2018/real-time-sdr-to-hdr-video-conversion/page-data.json": [
		"ENj2",
		988
	],
	"./page-data/en/imec-magazine/imec-magazine-november-2018/the-5-highlights-of-october-2018/page-data.json": [
		"fL44",
		989
	],
	"./page-data/en/imec-magazine/imec-magazine-november-2018/the-supervia-a-promising-scaling-booster-for-the-sub-3nm-technology-node/page-data.json": [
		"McxF",
		990
	],
	"./page-data/en/imec-magazine/imec-magazine-november-2019/home-sweet-homelab/page-data.json": [
		"nQhE",
		991
	],
	"./page-data/en/imec-magazine/imec-magazine-november-2019/how-to-efficiently-cool-power-electronics-and-optoelectronic-sensors/page-data.json": [
		"XeQj",
		992
	],
	"./page-data/en/imec-magazine/imec-magazine-november-2019/imec-and-nokia-bell-labs-collaborate-on-smart-streetlights/page-data.json": [
		"QMGm",
		993
	],
	"./page-data/en/imec-magazine/imec-magazine-november-2019/paintings-pythons-and-pears-the-spectrum-of-hyperspectral-applications/page-data.json": [
		"AYzL",
		994
	],
	"./page-data/en/imec-magazine/imec-magazine-november-2019/preface-november-2019/page-data.json": [
		"1nRi",
		995
	],
	"./page-data/en/imec-magazine/imec-magazine-november-2019/thanks-to-imec-icon-we-were-able-to-enter-a-new-market-and-the-business-unit-s-turnover-grew-by-30/page-data.json": [
		"eUn5",
		996
	],
	"./page-data/en/imec-magazine/imec-magazine-november-2019/the-5-things-you-always-wanted-to-know-about-perovskite-solar-cells-the-new-hype-in-pv-world/page-data.json": [
		"u8JO",
		997
	],
	"./page-data/en/imec-magazine/imec-magazine-november-2019/the-five-highlights-of-october-2019/page-data.json": [
		"czRx",
		998
	],
	"./page-data/en/imec-magazine/imec-magazine-october-2017/blockchain-is-hot-but-how-can-it-help-you/page-data.json": [
		"kuWj",
		999
	],
	"./page-data/en/imec-magazine/imec-magazine-october-2017/how-deep-is-the-sea-start-up-fluves-makes-offshore-wind-farms-less-vulnerable/page-data.json": [
		"e9Vq",
		1000
	],
	"./page-data/en/imec-magazine/imec-magazine-october-2017/image-sensor-combining-the-best-of-different-worlds/page-data.json": [
		"L7/o",
		1001
	],
	"./page-data/en/imec-magazine/imec-magazine-october-2017/in-pursuit-of-high-density-storage-class-memory/page-data.json": [
		"PYxB",
		1002
	],
	"./page-data/en/imec-magazine/imec-magazine-october-2017/liquid-biopsy-a-new-tool-for-cancer-experts/page-data.json": [
		"Lua5",
		1003
	],
	"./page-data/en/imec-magazine/imec-magazine-october-2017/poor-and-unstable-indoor-wi-fi-coverage-a-relic-from-the-past/page-data.json": [
		"nqd6",
		1004
	],
	"./page-data/en/imec-magazine/imec-magazine-october-2017/preface-october-2017/page-data.json": [
		"P3DA",
		1005
	],
	"./page-data/en/imec-magazine/imec-magazine-october-2017/the-five-highlights-of-september-2017/page-data.json": [
		"CTDV",
		1006
	],
	"./page-data/en/imec-magazine/imec-magazine-october-2017/the-vertical-ferroelectric-fet-a-new-contender-for-3d-nand-flash-memory-and-machine-learning/page-data.json": [
		"UpJ5",
		1007
	],
	"./page-data/en/imec-magazine/imec-magazine-october-2017/wanted-life-science-companies-seeking-to-make-their-products-more-compact-and-less-expensive-with-photonics/page-data.json": [
		"oByU",
		1008
	],
	"./page-data/en/imec-magazine/imec-magazine-october-2017/why-falling-doesnt-need-to-be-a-stumbling-block/page-data.json": [
		"Vc2V",
		1009
	],
	"./page-data/en/imec-magazine/imec-magazine-october-2018/a-big-step-in-a-small-world-developing-a-lens-free-fluorescence-microscope/page-data.json": [
		"OEVG",
		1010
	],
	"./page-data/en/imec-magazine/imec-magazine-october-2018/a-topping-of-perovskites-to-boost-solar-cell-efficiencies/page-data.json": [
		"40Ja",
		1011
	],
	"./page-data/en/imec-magazine/imec-magazine-october-2018/gaming-is-not-always-a-game/page-data.json": [
		"Zc2J",
		1012
	],
	"./page-data/en/imec-magazine/imec-magazine-october-2018/liborg-2-0-a-robot-for-on-the-fly-3d-mapping-of-environments/page-data.json": [
		"HGlt",
		1013
	],
	"./page-data/en/imec-magazine/imec-magazine-october-2018/preface-october-2018/page-data.json": [
		"sKE4",
		1014
	],
	"./page-data/en/imec-magazine/imec-magazine-october-2018/silicon-photonic-interposers-for-400gb-s-and-beyond-optical-interconnects/page-data.json": [
		"zy3M",
		1015
	],
	"./page-data/en/imec-magazine/imec-magazine-october-2018/smog-gets-in-your-eyes/page-data.json": [
		"ztOg",
		1016
	],
	"./page-data/en/imec-magazine/imec-magazine-october-2018/the-5-highlights-of-september-2018/page-data.json": [
		"8FlQ",
		1017
	],
	"./page-data/en/imec-magazine/imec-magazine-october-2018/when-will-doctors-and-specialists-really-be-able-to-use-dna-sequencing-in-their-practices/page-data.json": [
		"Mu1/",
		1018
	],
	"./page-data/en/imec-magazine/imec-magazine-october-2019/fast-faster-pharrowtech/page-data.json": [
		"BRWM",
		1019
	],
	"./page-data/en/imec-magazine/imec-magazine-october-2019/make-smartphones-and-autonomous-vehicles-see-the-impossible/page-data.json": [
		"Hb/X",
		1020
	],
	"./page-data/en/imec-magazine/imec-magazine-october-2019/new-killer-application-for-cell-sorter-chip/page-data.json": [
		"BrIr",
		1021
	],
	"./page-data/en/imec-magazine/imec-magazine-october-2019/perovskites-move-beyond-solar-cells-and-revolutionize-laser-based-projectors-and-x-ray-imaging/page-data.json": [
		"Tk9T",
		1022
	],
	"./page-data/en/imec-magazine/imec-magazine-october-2019/preface-october-2019/page-data.json": [
		"ueh2",
		1023
	],
	"./page-data/en/imec-magazine/imec-magazine-october-2019/start-your-own-research-group-at-imec/page-data.json": [
		"rr8V",
		1024
	],
	"./page-data/en/imec-magazine/imec-magazine-october-2019/the-five-highlights-of-october-2019/page-data.json": [
		"JKdf",
		1025
	],
	"./page-data/en/imec-magazine/imec-magazine-october-2019/towards-circular-business-models-for-the-pv-sector/page-data.json": [
		"7XV9",
		1026
	],
	"./page-data/en/imec-magazine/imec-magazine-september-2017/bright-future-for-flexible-electronics-ahead/page-data.json": [
		"qb7s",
		1027
	],
	"./page-data/en/imec-magazine/imec-magazine-september-2017/get-your-daily-health-check-in-the-car/page-data.json": [
		"0iCf",
		1028
	],
	"./page-data/en/imec-magazine/imec-magazine-september-2017/how-to-solve-the-back-end-of-line-rc-delay-problem/page-data.json": [
		"Ryuq",
		1029
	],
	"./page-data/en/imec-magazine/imec-magazine-september-2017/imec-spin-off-develops-revolutionary-digital-glasses/page-data.json": [
		"VB2J",
		1030
	],
	"./page-data/en/imec-magazine/imec-magazine-september-2017/it-s-an-illusion-to-think-that-everyone-is-interested-in-tracking-their-health/page-data.json": [
		"ULTP",
		1031
	],
	"./page-data/en/imec-magazine/imec-magazine-september-2017/new-technique-localizes-defects-in-3d-chips/page-data.json": [
		"Uknk",
		1032
	],
	"./page-data/en/imec-magazine/imec-magazine-september-2017/preface/page-data.json": [
		"ah5Q",
		1033
	],
	"./page-data/en/imec-magazine/imec-magazine-september-2017/spott-the-start-up-that-will-revolutionize-tv-advertising/page-data.json": [
		"b+pS",
		1034
	],
	"./page-data/en/imec-magazine/imec-magazine-september-2017/the-5-highlights-of-the-summer/page-data.json": [
		"9nJQ",
		1035
	],
	"./page-data/en/imec-magazine/imec-magazine-september-2017/the-vertical-nanowire-fet-enabler-of-highly-dense-srams/page-data.json": [
		"4J5+",
		1036
	],
	"./page-data/en/imec-magazine/imec-magazine-september-2018/Look-inside-objects-without-breaking-them/page-data.json": [
		"Pghw",
		1037
	],
	"./page-data/en/imec-magazine/imec-magazine-september-2018/bringing-artificial-intelligence-to-the-edge-of-the-iot/page-data.json": [
		"Ekni",
		1038
	],
	"./page-data/en/imec-magazine/imec-magazine-september-2018/emerging-memories-for-the-zettabyte-era/page-data.json": [
		"JrKG",
		1039
	],
	"./page-data/en/imec-magazine/imec-magazine-september-2018/from-talking-tomato-plants-to-sweat-plasters-this-fluid-sensor-can-do-it-all/page-data.json": [
		"pQH6",
		1040
	],
	"./page-data/en/imec-magazine/imec-magazine-september-2018/glasses-that-keep-an-eye-on-your-health/page-data.json": [
		"duW9",
		1041
	],
	"./page-data/en/imec-magazine/imec-magazine-september-2018/preface/page-data.json": [
		"jf2n",
		1042
	],
	"./page-data/en/imec-magazine/imec-magazine-september-2018/so-this-sensor-goes-to-see-a-psychiatrist/page-data.json": [
		"KI3A",
		1043
	],
	"./page-data/en/imec-magazine/imec-magazine-september-2018/ten-years-of-enabling-smart-applications-at-imec-taiwan/page-data.json": [
		"lIBO",
		1044
	],
	"./page-data/en/imec-magazine/imec-magazine-september-2018/the-five-highlights-of-summer-2018/page-data.json": [
		"WZ2M",
		1045
	],
	"./page-data/en/imec-magazine/imec-magazine-september-2018/twikit-and-waylay-two-imec-istart-alumni-conquering-the-world/page-data.json": [
		"H9eP",
		1046
	],
	"./page-data/en/imec-magazine/imec-magazine-september-2019/building-smart-products-the-right-way-do-s-and-don-ts/page-data.json": [
		"hXkm",
		1047
	],
	"./page-data/en/imec-magazine/imec-magazine-september-2019/choosing-the-right-accelerator-at-the-right-time/page-data.json": [
		"rmAo",
		1048
	],
	"./page-data/en/imec-magazine/imec-magazine-september-2019/how-can-chips-enable-realtime-inline-monitoring-of-bioprocesses/page-data.json": [
		"iWXy",
		1049
	],
	"./page-data/en/imec-magazine/imec-magazine-september-2019/no-heat-no-laser-no-powder-fabric8labs-reinvents-3d-metal-printing/page-data.json": [
		"/ss6",
		1050
	],
	"./page-data/en/imec-magazine/imec-magazine-september-2019/preface-september-2019/page-data.json": [
		"dbg+",
		1051
	],
	"./page-data/en/imec-magazine/imec-magazine-september-2019/scaling-the-beol-a-toolbox-filled-with-new-processes-boosters-and-conductors/page-data.json": [
		"WwGb",
		1052
	],
	"./page-data/en/imec-magazine/imec-magazine-september-2019/the-five-highlights-of-september-2019/page-data.json": [
		"ztiG",
		1053
	],
	"./page-data/en/imec-magazine/imec-reading-room-january-2020/12-technical-highlights-for-2019/page-data.json": [
		"90/x",
		1054
	],
	"./page-data/en/imec-magazine/imec-reading-room-january-2020/heterogeneous-iii-v-cmos-technologies-for-beyond-5g-rf-front-end-modules/page-data.json": [
		"p76P",
		1055
	],
	"./page-data/en/imec-magazine/imec-reading-room-january-2020/how-the-web-failed-its-own-inventor/page-data.json": [
		"+eyO",
		1056
	],
	"./page-data/en/imec-magazine/imec-reading-room-january-2020/miniaturization-of-medical-devices-is-crucial-for-space-exploration/page-data.json": [
		"SeG9",
		1057
	],
	"./page-data/en/imec-magazine/january-2018/2017-was-the-year-in-which-algorithmic-and-hardware-innovations-gave-each-other-a-mutual-boost-in-the-areas-of-AI-and-AR/page-data.json": [
		"g/4H",
		1058
	],
	"./page-data/en/imec-magazine/january-2018/A-2017-recap-and-outlook-for-2018-by-imecs-Senior-Leadership-Team/page-data.json": [
		"8GR3",
		1059
	],
	"./page-data/en/imec-magazine/january-2018/Computation-in-Memory-fits-into-a-new-concept-of-scaling-that-may-bring-huge-largely-untapped-energy-savings/page-data.json": [
		"Apv3",
		1060
	],
	"./page-data/en/imec-magazine/january-2018/In-the-long-term-the-industry-will-have-to-think-of-new-characterization-metrology-approaches-with-one-possible-scenario-being-MEMS-based-analytical-devices/page-data.json": [
		"jMgK",
		1061
	],
	"./page-data/en/imec-magazine/january-2018/Increasingly-electronics-will-be-built-into-our-bodies/page-data.json": [
		"ITSB",
		1062
	],
	"./page-data/en/imec-magazine/january-2018/Look-at-3D-chip-technology-as-a-way-of-getting-your-system-to-perform-better-not-as-an-additional-expense/page-data.json": [
		"qTB3",
		1063
	],
	"./page-data/en/imec-magazine/january-2018/Our-ambition-is-to-become-an-even-more-relevant-partner-locally-and-internationally/page-data.json": [
		"dFVU",
		1064
	],
	"./page-data/en/imec-magazine/january-2018/Our-experts-are-working-on-what-will-be-the-next-revolution-in-consumer-electronics/page-data.json": [
		"H37n",
		1065
	],
	"./page-data/en/imec-magazine/january-2018/Technology-has-the-potential-to-revolutionize-education-with-imec-s-Smart-Education-program-we-ve-built-the-ecosystem-to-accelerate-this-innovation/page-data.json": [
		"vLa7",
		1066
	],
	"./page-data/en/imec-magazine/january-2018/The-future-is-optical/page-data.json": [
		"ROuK",
		1067
	],
	"./page-data/en/imec-magazine/january-2018/The-key-challenge-we-re-going-to-face-is-making-optimal-use-of-renewable-energy-surpluses/page-data.json": [
		"hAw4",
		1068
	],
	"./page-data/en/imec-magazine/january-2018/The-seeds-that-will-grow-into-the-leading-semiconductor-technology-of-the-future-have-already-been-planted/page-data.json": [
		"0i29",
		1069
	],
	"./page-data/en/imec-magazine/january-2018/We-need-smarter-ways-to-compute-store-and-connect/page-data.json": [
		"rbyA",
		1070
	],
	"./page-data/en/imec-magazine/january-2018/We-need-to-prevent-people-from-becoming-patients-in-the-first-place/page-data.json": [
		"CGhD",
		1071
	],
	"./page-data/en/imec-magazine/january-2018/iot-technology-is-catching-up-with-our-visionary-dream/page-data.json": [
		"dGBA",
		1072
	],
	"./page-data/en/imec-magazine/january-2018/our-knowledge-on-materials-and-reliability-issues-enables-innovations-in-other-domains/page-data.json": [
		"B2nK",
		1073
	],
	"./page-data/en/imec-magazine/page-data.json": [
		"1px3",
		1074
	],
	"./page-data/en/imec-patent-portfolio/page-data.json": [
		"zMNO",
		1075
	],
	"./page-data/en/imec-the-netherlands/government-funded-research/healthcare/page-data.json": [
		"TcA/",
		1076
	],
	"./page-data/en/imec-the-netherlands/government-funded-research/high-tech-agriculture/page-data.json": [
		"dCg1",
		1077
	],
	"./page-data/en/imec-the-netherlands/government-funded-research/page-data.json": [
		"pNF7",
		1078
	],
	"./page-data/en/imec-the-netherlands/government-funded-research/smart-environments/page-data.json": [
		"/TKK",
		1079
	],
	"./page-data/en/imec-the-netherlands/work-with-us-in-the-netherlands/page-data.json": [
		"bz6u",
		1080
	],
	"./page-data/en/imec-turns-35-in-2019/a-food-printer/page-data.json": [
		"JSXE",
		1081
	],
	"./page-data/en/imec-turns-35-in-2019/about-robots/page-data.json": [
		"8clI",
		1082
	],
	"./page-data/en/imec-turns-35-in-2019/augmented-reality-glasses/page-data.json": [
		"eTbt",
		1083
	],
	"./page-data/en/imec-turns-35-in-2019/batteries-and-energy/page-data.json": [
		"tIp8",
		1084
	],
	"./page-data/en/imec-turns-35-in-2019/beam-me-up-scotty/page-data.json": [
		"sD0h",
		1085
	],
	"./page-data/en/imec-turns-35-in-2019/classroom-of-the-future/page-data.json": [
		"MuAk",
		1086
	],
	"./page-data/en/imec-turns-35-in-2019/datapods/page-data.json": [
		"jSu2",
		1087
	],
	"./page-data/en/imec-turns-35-in-2019/hacking-a-sport/page-data.json": [
		"qTnJ",
		1088
	],
	"./page-data/en/imec-turns-35-in-2019/in-2035-you-ll-manage-your-health-just-as-you-do-your-bank-account-today/page-data.json": [
		"pDYe",
		1089
	],
	"./page-data/en/imec-turns-35-in-2019/industry-5-0/page-data.json": [
		"xt+j",
		1090
	],
	"./page-data/en/imec-turns-35-in-2019/living-in-a-city/page-data.json": [
		"c2vC",
		1091
	],
	"./page-data/en/imec-turns-35-in-2019/machine-learning/page-data.json": [
		"j//4",
		1092
	],
	"./page-data/en/imec-turns-35-in-2019/no-more-bad-connections/page-data.json": [
		"Sjgg",
		1093
	],
	"./page-data/en/imec-turns-35-in-2019/quantum-computing/page-data.json": [
		"jOoU",
		1094
	],
	"./page-data/en/imec-turns-35-in-2019/technology-will-help-us-tackle-the-problems-of-the-21st-century/page-data.json": [
		"YuW7",
		1095
	],
	"./page-data/en/imec-turns-35-in-2019/the-smartphone-comes-apart/page-data.json": [
		"Fgks",
		1096
	],
	"./page-data/en/imec-usa-florida/research-highlight-lidar/page-data.json": [
		"pTtq",
		1097
	],
	"./page-data/en/imec-usa-florida/research-highlights-mm-wave-imaging/page-data.json": [
		"O0C3",
		1098
	],
	"./page-data/en/imecdigimeter2016/page-data.json": [
		"N8ea",
		1099
	],
	"./page-data/en/imecusa/join-the-forward-thinkers/page-data.json": [
		"YAVb",
		1100
	],
	"./page-data/en/implantables/page-data.json": [
		"Ld98",
		1101
	],
	"./page-data/en/industries/page-data.json": [
		"ejhw",
		1102
	],
	"./page-data/en/infrastructure/page-data.json": [
		"iG+g",
		1103
	],
	"./page-data/en/ingestibles/page-data.json": [
		"tvsq",
		1104
	],
	"./page-data/en/innovation/build-your-gan-ics-with-imec-s-gan-on-soi-mpw-process/page-data.json": [
		"3/t+",
		1105
	],
	"./page-data/en/innovation/build-your-gan-ics-with-imec-s-gan-on-soi-mpw-process/tutorial-gan-ics-in-gan-on-soi-technology/page-data.json": [
		"8d2r",
		1106
	],
	"./page-data/en/innovation/innovatrix/page-data.json": [
		"Hami",
		1107
	],
	"./page-data/en/innovation/page-data.json": [
		"Z4r6",
		1108
	],
	"./page-data/en/innovation/sin-photonics-mpw-runs/page-data.json": [
		"TvlN",
		1109
	],
	"./page-data/en/innovation/smart-media-meetups/page-data.json": [
		"uh/O",
		1110
	],
	"./page-data/en/innovation/testing-grounds-for-industry-4-0_2/page-data.json": [
		"dXOK",
		1111
	],
	"./page-data/en/integrated-photonics/page-data.json": [
		"2p7M",
		1112
	],
	"./page-data/en/istart-portfolio/page-data.json": [
		"hNZS",
		1113
	],
	"./page-data/en/istart/200-million-party/page-data.json": [
		"uFNa",
		1114
	],
	"./page-data/en/istart/MOLECUBES-raises-1,9M-euro/page-data.json": [
		"NCyy",
		1115
	],
	"./page-data/en/istart/Mediahuis-Connect-offers-premium-targeting-in-collaboration-with-Predicube/page-data.json": [
		"bM6A",
		1116
	],
	"./page-data/en/istart/NoisyChannels-towards-simpler-faster-and-more-efficient-customer-inquiry-and-complaints-handling/page-data.json": [
		"fiqe",
		1117
	],
	"./page-data/en/istart/call/page-data.json": [
		"HgwU",
		1118
	],
	"./page-data/en/istart/corporate-partner/page-data.json": [
		"T+VT",
		1119
	],
	"./page-data/en/istart/enterpreneur/page-data.json": [
		"vIiY",
		1120
	],
	"./page-data/en/istart/imec-istart-info-session/page-data.json": [
		"pFl7",
		1121
	],
	"./page-data/en/istart/imec-istart-jobs/blended-mobility/page-data.json": [
		"dzem",
		1122
	],
	"./page-data/en/istart/imec-istart-partner-mentor-material/page-data.json": [
		"ANf8",
		1123
	],
	"./page-data/en/istart/industry-verticals/FinTech-InsurTech-CyberSecurity/page-data.json": [
		"fCTS",
		1124
	],
	"./page-data/en/istart/industry-verticals/Learn-HRTech/page-data.json": [
		"A9Ge",
		1125
	],
	"./page-data/en/istart/industry-verticals/Media-Telecom-Entertainment/page-data.json": [
		"vc1M",
		1126
	],
	"./page-data/en/istart/industry-verticals/health/page-data.json": [
		"7Hh2",
		1127
	],
	"./page-data/en/istart/industry-verticals/industry-4-0/page-data.json": [
		"kxL7",
		1128
	],
	"./page-data/en/istart/industry-verticals/page-data.json": [
		"yc1x",
		1129
	],
	"./page-data/en/istart/industry-verticals/sports/page-data.json": [
		"eIJB",
		1130
	],
	"./page-data/en/istart/investor/page-data.json": [
		"pzcg",
		1131
	],
	"./page-data/en/istart/jobs/page-data.json": [
		"g8pa",
		1132
	],
	"./page-data/en/istart/mentors/page-data.json": [
		"auXH",
		1133
	],
	"./page-data/en/istart/mentorship/page-data.json": [
		"x3NR",
		1134
	],
	"./page-data/en/istart/page-data.json": [
		"y/Ks",
		1135
	],
	"./page-data/en/istart/program-partners/page-data.json": [
		"+/3z",
		1136
	],
	"./page-data/en/istart/quamotion-a-new-generation-of-mobile-testing-applications/page-data.json": [
		"WLHt",
		1137
	],
	"./page-data/en/istart/special-tracks/imec-istart-track-on-logistics-mobility/page-data.json": [
		"L3mi",
		1138
	],
	"./page-data/en/istart/special-tracks/imec-istart-track-on-space-technology/page-data.json": [
		"Rrxe",
		1139
	],
	"./page-data/en/istart/startup-initiatives-covid-19/page-data.json": [
		"zwGG",
		1140
	],
	"./page-data/en/istart/startups-initiatives-in-times-of-covid-19-copy/page-data.json": [
		"QxnD",
		1141
	],
	"./page-data/en/job-fair/page-data.json": [
		"dfKf",
		1142
	],
	"./page-data/en/lae/about-the-lae-group/page-data.json": [
		"rZbG",
		1143
	],
	"./page-data/en/lae/page-data.json": [
		"W+mT",
		1144
	],
	"./page-data/en/lae/thin-film-displays/page-data.json": [
		"7Vw6",
		1145
	],
	"./page-data/en/lae/thin-film-energy-storage/page-data.json": [
		"wi8b",
		1146
	],
	"./page-data/en/lae/thin-film-ic-design/page-data.json": [
		"4d0U",
		1147
	],
	"./page-data/en/lae/thin-film-imagers-and-sensors/page-data.json": [
		"ia7g",
		1148
	],
	"./page-data/en/lae/thin-film-material-research/page-data.json": [
		"ebty",
		1149
	],
	"./page-data/en/large-storage-solid-state-li-ion-batteries/page-data.json": [
		"v8QJ",
		1150
	],
	"./page-data/en/lens-free-microscopy/page-data.json": [
		"+fly",
		1151
	],
	"./page-data/en/lifesciences/contract-r-d/page-data.json": [
		"cPpJ",
		1152
	],
	"./page-data/en/lifesciences/lens-free-imaging/page-data.json": [
		"HqAl",
		1153
	],
	"./page-data/en/lifesciences/micro-electrode-arrays/page-data.json": [
		"STCo",
		1154
	],
	"./page-data/en/lifesciences/nanopore-technology/page-data.json": [
		"CDko",
		1155
	],
	"./page-data/en/lifesciences/page-data.json": [
		"oKSk",
		1156
	],
	"./page-data/en/lifesciences/process-analytical-technologies/page-data.json": [
		"/sAP",
		1157
	],
	"./page-data/en/lifesciences/raman-spectroscopy/page-data.json": [
		"WBeg",
		1158
	],
	"./page-data/en/livinglabs/gebruikerspanel/algemene-voorwaarden/page-data.json": [
		"nUr0",
		1159
	],
	"./page-data/en/livinglabs/gebruikerspanel/project/niet-actieve-projecten/page-data.json": [
		"ocGz",
		1160
	],
	"./page-data/en/livinglabs/gebruikerspanel/project/oproep-voor-de-sportclubs/page-data.json": [
		"/9MJ",
		1161
	],
	"./page-data/en/livinglabs/gebruikerspanel/wedstrijdreglement/page-data.json": [
		"Qzz0",
		1162
	],
	"./page-data/en/livinglabs/page-data.json": [
		"zb+i",
		1163
	],
	"./page-data/en/livinglabs/panel-and-community-management/page-data.json": [
		"SJdg",
		1164
	],
	"./page-data/en/machine-learning/page-data.json": [
		"RpYh",
		1165
	],
	"./page-data/en/mmwave-wireless-communication/page-data.json": [
		"FuY2",
		1166
	],
	"./page-data/en/monIEflex/page-data.json": [
		"yUqz",
		1167
	],
	"./page-data/en/multi-junction-solar-stacks/page-data.json": [
		"pULB",
		1168
	],
	"./page-data/en/nano-batteries-on-foil-for-flexible-electronics/page-data.json": [
		"dw9E",
		1169
	],
	"./page-data/en/nano4sports/page-data.json": [
		"M+bx",
		1170
	],
	"./page-data/en/need-advanced-asics-take-the-trusted-route/page-data.json": [
		"+J7n",
		1171
	],
	"./page-data/en/nervocity/page-data.json": [
		"PSm9",
		1172
	],
	"./page-data/en/neuromorphic-computing/page-data.json": [
		"BJiK",
		1173
	],
	"./page-data/en/next-generation-logic-devices/page-data.json": [
		"MFZh",
		1174
	],
	"./page-data/en/next-generation-silicon-photonics/page-data.json": [
		"roRu",
		1175
	],
	"./page-data/en/non-payroll-agreements/page-data.json": [
		"nHuZ",
		1176
	],
	"./page-data/en/novel-memory-concepts/page-data.json": [
		"5H2d",
		1177
	],
	"./page-data/en/opening-homelab/page-data.json": [
		"dFIB",
		1178
	],
	"./page-data/en/organization/board-of-directors/page-data.json": [
		"woYu",
		1179
	],
	"./page-data/en/organization/management-team/page-data.json": [
		"3KX9",
		1180
	],
	"./page-data/en/organization/page-data.json": [
		"jM6B",
		1181
	],
	"./page-data/en/organization/scientific-advisory-board/page-data.json": [
		"YTqX",
		1182
	],
	"./page-data/en/page-data.json": [
		"xKdq",
		1183
	],
	"./page-data/en/partner-site/page-data.json": [
		"aJY+",
		1184
	],
	"./page-data/en/pcb-pba-design-manufacturing/page-data.json": [
		"Ftdy",
		1185
	],
	"./page-data/en/powermodel/page-data.json": [
		"Z7nc",
		1186
	],
	"./page-data/en/privacy-notice-webinars-whitepapers/page-data.json": [
		"JDlZ",
		1187
	],
	"./page-data/en/privacy-statement/page-data.json": [
		"gCIo",
		1188
	],
	"./page-data/en/prototypes/page-data.json": [
		"382a",
		1189
	],
	"./page-data/en/prototyping-and-manufacturing/page-data.json": [
		"tT/4",
		1190
	],
	"./page-data/en/prototyping-and-testing-support/page-data.json": [
		"Dynv",
		1191
	],
	"./page-data/en/quantum-computing/page-data.json": [
		"6L4D",
		1192
	],
	"./page-data/en/reading-room/page-data.json": [
		"GXil",
		1193
	],
	"./page-data/en/reconfigurable-saw-less-radio-transceiver/page-data.json": [
		"R32A",
		1194
	],
	"./page-data/en/sab2017-registration/page-data.json": [
		"7oYj",
		1195
	],
	"./page-data/en/scalable-c-programmable-vliw-dsp-processor/page-data.json": [
		"yNsV",
		1196
	],
	"./page-data/en/scalable-ldpc-asip-core/page-data.json": [
		"vHBl",
		1197
	],
	"./page-data/en/search/page-data.json": [
		"z81g",
		1198
	],
	"./page-data/en/semiconductor-technology-and-systems/materials-and-components-analysis/page-data.json": [
		"NKKX",
		1199
	],
	"./page-data/en/semiconductor-technology-and-systems/page-data.json": [
		"DtLe",
		1200
	],
	"./page-data/en/sensor-networks-for-IoT/build-your-continuous-water-quality-monitoring-system-with-imec-technology/page-data.json": [
		"poV3",
		1201
	],
	"./page-data/en/sensor-networks-for-IoT/driver-monitoring-technology/page-data.json": [
		"t9W5",
		1202
	],
	"./page-data/en/sensor-networks-for-IoT/next-generation-adas-technology/page-data.json": [
		"tnbW",
		1203
	],
	"./page-data/en/sensor-networks-for-IoT/page-data.json": [
		"Pe6B",
		1204
	],
	"./page-data/en/sensor-networks-for-IoT/secure-proximity-key-to-driver-comfort-and-safety/page-data.json": [
		"uKd0",
		1205
	],
	"./page-data/en/sensor-networks-for-IoT/secure-proximity-key-to-driver-comfort-and-safety/recording-secure-proximity-key-to-driver-comfort-and-safety-10am-pt-7pm-cest-session/page-data.json": [
		"Fks9",
		1206
	],
	"./page-data/en/sensor-networks-for-IoT/secure-proximity-key-to-driver-comfort-and-safety/recording-secure-proximity-key-to-driver-comfort-and-safety-3pm-cst-9am-cest-session/page-data.json": [
		"1qkO",
		1207
	],
	"./page-data/en/sensor-networks-for-IoT/technology-for-real-time-air-quality-monitoring/page-data.json": [
		"NG4R",
		1208
	],
	"./page-data/en/sensor-networks-for-IoT/using-in-cabin-radar-to-improve-driver-comfort-and-safety/page-data.json": [
		"Vv4z",
		1209
	],
	"./page-data/en/sensor-networks-for-IoT/using-in-cabin-radar-to-improve-driver-comfort-and-safety/recording-using-in-cabin-radar-to-improve-driver-comfort-and-safety-10am-pt-7pm-cest-session/page-data.json": [
		"Vmoy",
		1210
	],
	"./page-data/en/sensor-networks-for-IoT/using-in-cabin-radar-to-improve-driver-comfort-and-safety/recording-using-in-cabin-radar-to-improve-driver-comfort-and-safety-3pm-cst-9am-cest-session/page-data.json": [
		"uLFK",
		1211
	],
	"./page-data/en/silicon-and-thin-film-photovoltaics/page-data.json": [
		"hCI+",
		1212
	],
	"./page-data/en/silicon-photonic-ICs-prototyping/page-data.json": [
		"Q7l8",
		1213
	],
	"./page-data/en/silicon-solar-cells-and-modules/page-data.json": [
		"KYba",
		1214
	],
	"./page-data/en/smart-energy/page-data.json": [
		"SpvA",
		1215
	],
	"./page-data/en/smartflanders/page-data.json": [
		"7RRe",
		1216
	],
	"./page-data/en/smarthighway/page-data.json": [
		"P85Z",
		1217
	],
	"./page-data/en/software-sensor-fusion/page-data.json": [
		"K/D/",
		1218
	],
	"./page-data/en/solid-state-batteries/page-data.json": [
		"VOji",
		1219
	],
	"./page-data/en/specialty-CMOS-image-sensors/page-data.json": [
		"8dSH",
		1220
	],
	"./page-data/en/spin-offs/page-data.json": [
		"PI3w",
		1221
	],
	"./page-data/en/stay-up-to-date-imec-flanders-innovation-services/page-data.json": [
		"A2d3",
		1222
	],
	"./page-data/en/stay-up-to-date-imec-global-r-d/page-data.json": [
		"Jmua",
		1223
	],
	"./page-data/en/stay-up-to-date-imec-startups-entrepreneurship/page-data.json": [
		"TG+d",
		1224
	],
	"./page-data/en/stayuptodate/page-data.json": [
		"q3w7",
		1225
	],
	"./page-data/en/sustainability/page-data.json": [
		"7CN9",
		1226
	],
	"./page-data/en/system-on-chip/page-data.json": [
		"RAPw",
		1227
	],
	"./page-data/en/the-five-highlights-of-june-2019-copy/page-data.json": [
		"FwPg",
		1228
	],
	"./page-data/en/the-netherlands/envisioning-it-or-realizing-it/page-data.json": [
		"ab+i",
		1229
	],
	"./page-data/en/the-netherlands/page-data.json": [
		"41cu",
		1230
	],
	"./page-data/en/the-netherlands/smart-toilet/page-data.json": [
		"87D9",
		1231
	],
	"./page-data/en/the-netherlands/work-at-imec-the-netherlands/page-data.json": [
		"T2sY",
		1232
	],
	"./page-data/en/thin-film-circuits-RFID-NFC/page-data.json": [
		"hQbB",
		1233
	],
	"./page-data/en/thin-film-displays/page-data.json": [
		"IzZt",
		1234
	],
	"./page-data/en/thin-film-image-sensors/page-data.json": [
		"2ytF",
		1235
	],
	"./page-data/en/thin-film-solar-cells-and-modules/page-data.json": [
		"M9WW",
		1236
	],
	"./page-data/en/thin-film-solar-cells-and-modules/pvopmaat/page-data.json": [
		"/srH",
		1237
	],
	"./page-data/en/thin-film-solar-cells-and-modules/rolling-solar/page-data.json": [
		"+8Gr",
		1238
	],
	"./page-data/en/ulp-ir-uwb-radio/page-data.json": [
		"GjV9",
		1239
	],
	"./page-data/en/usa/imec-usa-berkeley/environment-for-system-technology-co-optimization-exploration/page-data.json": [
		"s9e1",
		1240
	],
	"./page-data/en/usa/imec-usa-berkeley/novel-architectures-for-machine-learning-and-artificial-intelligence/page-data.json": [
		"s0t0",
		1241
	],
	"./page-data/en/usa/imec-usa-berkeley/page-data.json": [
		"aW0p",
		1242
	],
	"./page-data/en/usa/imec-usa-florida/analog-and-rf-circuit-design/page-data.json": [
		"PAzM",
		1243
	],
	"./page-data/en/usa/imec-usa-florida/camera-systems-and-computational-imaging/page-data.json": [
		"Bpmp",
		1244
	],
	"./page-data/en/usa/imec-usa-florida/nanotechnology-for-research-and-health-monitoring-in-space/page-data.json": [
		"DfqC",
		1245
	],
	"./page-data/en/usa/imec-usa-florida/page-data.json": [
		"YKeS",
		1246
	],
	"./page-data/en/usa/imec-usa-florida/silicon-photonics-design_2/page-data.json": [
		"eLTd",
		1247
	],
	"./page-data/en/usa/page-data.json": [
		"mEJV",
		1248
	],
	"./page-data/en/user-research-toolkit/page-data.json": [
		"g0in",
		1249
	],
	"./page-data/en/what-we-offer/design-for-photonics-and-high-speed-electronics/page-data.json": [
		"lEkv",
		1250
	],
	"./page-data/en/what-we-offer/development/build-your-gan-ics-with-imec-s-gan-on-soi-mpw-process/page-data.json": [
		"LcIg",
		1251
	],
	"./page-data/en/what-we-offer/development/core-wafer-services/page-data.json": [
		"L6iL",
		1252
	],
	"./page-data/en/what-we-offer/development/ip-transfer/page-data.json": [
		"sdFu",
		1253
	],
	"./page-data/en/what-we-offer/development/local-initiatives/page-data.json": [
		"9vgQ",
		1254
	],
	"./page-data/en/what-we-offer/development/mems-development/page-data.json": [
		"hOea",
		1255
	],
	"./page-data/en/what-we-offer/development/page-data.json": [
		"h+bu",
		1256
	],
	"./page-data/en/what-we-offer/development/product-development-based-on-imec-imaging-technology/page-data.json": [
		"U7Kr",
		1257
	],
	"./page-data/en/what-we-offer/development/product-development/page-data.json": [
		"4ama",
		1258
	],
	"./page-data/en/what-we-offer/development/silicon-photonics-prototyping-platform/page-data.json": [
		"bMC1",
		1259
	],
	"./page-data/en/what-we-offer/development/sin-photonics-mpw-runs/page-data.json": [
		"ozuR",
		1260
	],
	"./page-data/en/what-we-offer/development/smart-media-meetups/page-data.json": [
		"pgP8",
		1261
	],
	"./page-data/en/what-we-offer/development/test-labs/page-data.json": [
		"URYn",
		1262
	],
	"./page-data/en/what-we-offer/ic-link/agenda/page-data.json": [
		"yP0P",
		1263
	],
	"./page-data/en/what-we-offer/ic-link/asic-design/page-data.json": [
		"NUX5",
		1264
	],
	"./page-data/en/what-we-offer/ic-link/ic-manufacturing/page-data.json": [
		"xIB8",
		1265
	],
	"./page-data/en/what-we-offer/ic-link/low-power-design/page-data.json": [
		"xzVV",
		1266
	],
	"./page-data/en/what-we-offer/ic-link/photonic-integrated-circuits/page-data.json": [
		"AJkB",
		1267
	],
	"./page-data/en/what-we-offer/ic-link/prototyping/page-data.json": [
		"6ZmK",
		1268
	],
	"./page-data/en/what-we-offer/ic-link/radiation-hardened-cmos-technology/page-data.json": [
		"mogg",
		1269
	],
	"./page-data/en/what-we-offer/ic-link/the-internet-of-things/page-data.json": [
		"7y7o",
		1270
	],
	"./page-data/en/what-we-offer/iclink/contact/page-data.json": [
		"5xQT",
		1271
	],
	"./page-data/en/what-we-offer/iclink/low-power-design/test-page-detail/page-data.json": [
		"s7su",
		1272
	],
	"./page-data/en/what-we-offer/icon-portfolio/diastole/page-data.json": [
		"TFzk",
		1273
	],
	"./page-data/en/what-we-offer/innovation-services/MEMS-and-embedded-micro-devices-prototyping-and-manufacturing/page-data.json": [
		"u8V2",
		1274
	],
	"./page-data/en/what-we-offer/innovation-services/city-of-things/city-of-things-use-cases/page-data.json": [
		"AbQs",
		1275
	],
	"./page-data/en/what-we-offer/innovation-services/city-of-things/the-four-cornerstones-of-the-city-of-things/page-data.json": [
		"Lodf",
		1276
	],
	"./page-data/en/what-we-offer/innovation-services/local-initiatives/page-data.json": [
		"SqbO",
		1277
	],
	"./page-data/en/what-we-offer/innovation-services/silicon-photonics-prototyping-platform/page-data.json": [
		"mAW3",
		1278
	],
	"./page-data/en/what-we-offer/innovation-services/smart-spaces/holst-centre-air-quality-monitoring/page-data.json": [
		"zyEC",
		1279
	],
	"./page-data/en/what-we-offer/innovation-services/smart-spaces/homelab/page-data.json": [
		"926w",
		1280
	],
	"./page-data/en/what-we-offer/innovation-services/smart-spaces/officelab/page-data.json": [
		"pQcW",
		1281
	],
	"./page-data/en/what-we-offer/innovation-services/smart-spaces/page-data.json": [
		"onF/",
		1282
	],
	"./page-data/en/what-we-offer/innovation-services/smart-spaces/smart-public-space/page-data.json": [
		"o8dW",
		1283
	],
	"./page-data/en/what-we-offer/innovation-services/technology-transfer-of-white-box-ip-blocks/analog-mixed-signal-ip-a2d-converter-cloned/page-data.json": [
		"cEet",
		1284
	],
	"./page-data/en/what-we-offer/innovation-services/technology-transfer-of-white-box-ip-blocks/analog-mixed-signal-ip-a2d-converter/page-data.json": [
		"8o0R",
		1285
	],
	"./page-data/en/what-we-offer/innovation-services/technology-transfer-of-white-box-ip-blocks/page-data.json": [
		"uEl1",
		1286
	],
	"./page-data/en/what-we-offer/innovation-services/test-labs/broadbandoptical/page-data.json": [
		"GkdH",
		1287
	],
	"./page-data/en/what-we-offer/innovation-services/test-labs/page-data.json": [
		"Qa2P",
		1288
	],
	"./page-data/en/what-we-offer/innovation-services/test-labs/rf-mmwave/page-data.json": [
		"cmG4",
		1289
	],
	"./page-data/en/what-we-offer/innovation-services/test-labs/virtual-wall/page-data.json": [
		"S1wo",
		1290
	],
	"./page-data/en/what-we-offer/innovation-services/test-labs/wireless-testlab/page-data.json": [
		"hQWL",
		1291
	],
	"./page-data/en/what-we-offer/innovation-services/wafer-service/page-data.json": [
		"Kj7g",
		1292
	],
	"./page-data/en/what-we-offer/material-analysis-testing/page-data.json": [
		"fNfv",
		1293
	],
	"./page-data/en/what-we-offer/page-data.json": [
		"uArv",
		1294
	],
	"./page-data/en/what-we-offer/product-development-based-on-imec-imaging-technology/page-data.json": [
		"HifW",
		1295
	],
	"./page-data/en/what-we-offer/research-and-development/bilateral-research/page-data.json": [
		"h4nw",
		1296
	],
	"./page-data/en/what-we-offer/research-and-development/page-data.json": [
		"LGBB",
		1297
	],
	"./page-data/en/what-we-offer/research-and-development/r-d-with-multiple-partners/page-data.json": [
		"k/ER",
		1298
	],
	"./page-data/en/what-we-offer/research-portfolio/5guards/page-data.json": [
		"CiuX",
		1299
	],
	"./page-data/en/what-we-offer/research-portfolio/analyst-pv/page-data.json": [
		"6TNW",
		1300
	],
	"./page-data/en/what-we-offer/research-portfolio/aorta/page-data.json": [
		"ZXlR",
		1301
	],
	"./page-data/en/what-we-offer/research-portfolio/aria/page-data.json": [
		"hmFe",
		1302
	],
	"./page-data/en/what-we-offer/research-portfolio/asimov/page-data.json": [
		"/jru",
		1303
	],
	"./page-data/en/what-we-offer/research-portfolio/b-slim/page-data.json": [
		"MaYE",
		1304
	],
	"./page-data/en/what-we-offer/research-portfolio/bahamas/page-data.json": [
		"KJrx",
		1305
	],
	"./page-data/en/what-we-offer/research-portfolio/bluess/page-data.json": [
		"Jl7+",
		1306
	],
	"./page-data/en/what-we-offer/research-portfolio/bolucap/page-data.json": [
		"7hom",
		1307
	],
	"./page-data/en/what-we-offer/research-portfolio/boss/page-data.json": [
		"to/9",
		1308
	],
	"./page-data/en/what-we-offer/research-portfolio/caprads/page-data.json": [
		"nVCq",
		1309
	],
	"./page-data/en/what-we-offer/research-portfolio/claxon/page-data.json": [
		"0hEj",
		1310
	],
	"./page-data/en/what-we-offer/research-portfolio/combust/page-data.json": [
		"m8Tb",
		1311
	],
	"./page-data/en/what-we-offer/research-portfolio/conamo/page-data.json": [
		"NTpR",
		1312
	],
	"./page-data/en/what-we-offer/research-portfolio/cosmo/page-data.json": [
		"cRcT",
		1313
	],
	"./page-data/en/what-we-offer/research-portfolio/cosmos/page-data.json": [
		"5txU",
		1314
	],
	"./page-data/en/what-we-offer/research-portfolio/creative/page-data.json": [
		"7VSf",
		1315
	],
	"./page-data/en/what-we-offer/research-portfolio/d-base/page-data.json": [
		"V0Qo",
		1316
	],
	"./page-data/en/what-we-offer/research-portfolio/daiquiri/page-data.json": [
		"EKqH",
		1317
	],
	"./page-data/en/what-we-offer/research-portfolio/discrete/page-data.json": [
		"cuSP",
		1318
	],
	"./page-data/en/what-we-offer/research-portfolio/diskman/page-data.json": [
		"7cp2",
		1319
	],
	"./page-data/en/what-we-offer/research-portfolio/dynamo/page-data.json": [
		"ugRe",
		1320
	],
	"./page-data/en/what-we-offer/research-portfolio/dyversify/page-data.json": [
		"ycTK",
		1321
	],
	"./page-data/en/what-we-offer/research-portfolio/ecodalo/page-data.json": [
		"C2UQ",
		1322
	],
	"./page-data/en/what-we-offer/research-portfolio/edutablet/page-data.json": [
		"e3U8",
		1323
	],
	"./page-data/en/what-we-offer/research-portfolio/elite/page-data.json": [
		"Ijwl",
		1324
	],
	"./page-data/en/what-we-offer/research-portfolio/emd/page-data.json": [
		"15Si",
		1325
	],
	"./page-data/en/what-we-offer/research-portfolio/essence/page-data.json": [
		"HOuf",
		1326
	],
	"./page-data/en/what-we-offer/research-portfolio/fast/page-data.json": [
		"zPer",
		1327
	],
	"./page-data/en/what-we-offer/research-portfolio/fiat/page-data.json": [
		"Ir8Q",
		1328
	],
	"./page-data/en/what-we-offer/research-portfolio/footwork/page-data.json": [
		"DLzb",
		1329
	],
	"./page-data/en/what-we-offer/research-portfolio/forward/page-data.json": [
		"YD6N",
		1330
	],
	"./page-data/en/what-we-offer/research-portfolio/fuse/page-data.json": [
		"WSfW",
		1331
	],
	"./page-data/en/what-we-offer/research-portfolio/gap/page-data.json": [
		"mEo+",
		1332
	],
	"./page-data/en/what-we-offer/research-portfolio/gipa/page-data.json": [
		"+8fU",
		1333
	],
	"./page-data/en/what-we-offer/research-portfolio/gps4integratedcare/page-data.json": [
		"nqci",
		1334
	],
	"./page-data/en/what-we-offer/research-portfolio/haces/page-data.json": [
		"Wmm7",
		1335
	],
	"./page-data/en/what-we-offer/research-portfolio/hd2r/page-data.json": [
		"PBfF",
		1336
	],
	"./page-data/en/what-we-offer/research-portfolio/help-video/page-data.json": [
		"+pCH",
		1337
	],
	"./page-data/en/what-we-offer/research-portfolio/hips/page-data.json": [
		"U959",
		1338
	],
	"./page-data/en/what-we-offer/research-portfolio/hoof-mate/page-data.json": [
		"I0xi",
		1339
	],
	"./page-data/en/what-we-offer/research-portfolio/hycoware/page-data.json": [
		"atV4",
		1340
	],
	"./page-data/en/what-we-offer/research-portfolio/i-cart/page-data.json": [
		"xD5Q",
		1341
	],
	"./page-data/en/what-we-offer/research-portfolio/i2afo/page-data.json": [
		"Ncyl",
		1342
	],
	"./page-data/en/what-we-offer/research-portfolio/ifest/page-data.json": [
		"5LbR",
		1343
	],
	"./page-data/en/what-we-offer/research-portfolio/illuminate/page-data.json": [
		"vleh",
		1344
	],
	"./page-data/en/what-we-offer/research-portfolio/inwaredrones/page-data.json": [
		"CqwS",
		1345
	],
	"./page-data/en/what-we-offer/research-portfolio/iot-chef/page-data.json": [
		"HmOl",
		1346
	],
	"./page-data/en/what-we-offer/research-portfolio/iplay/page-data.json": [
		"lv5y",
		1347
	],
	"./page-data/en/what-we-offer/research-portfolio/ixcon/page-data.json": [
		"m8wQ",
		1348
	],
	"./page-data/en/what-we-offer/research-portfolio/leaps/page-data.json": [
		"mrmB",
		1349
	],
	"./page-data/en/what-we-offer/research-portfolio/lecture/page-data.json": [
		"1QqR",
		1350
	],
	"./page-data/en/what-we-offer/research-portfolio/ledstrack/page-data.json": [
		"OY7J",
		1351
	],
	"./page-data/en/what-we-offer/research-portfolio/lunar/page-data.json": [
		"tz2K",
		1352
	],
	"./page-data/en/what-we-offer/research-portfolio/magician/page-data.json": [
		"jhx/",
		1353
	],
	"./page-data/en/what-we-offer/research-portfolio/masslift/page-data.json": [
		"CH8K",
		1354
	],
	"./page-data/en/what-we-offer/research-portfolio/mecano/page-data.json": [
		"eN+z",
		1355
	],
	"./page-data/en/what-we-offer/research-portfolio/mecovi/page-data.json": [
		"04hO",
		1356
	],
	"./page-data/en/what-we-offer/research-portfolio/metroct/page-data.json": [
		"nUho",
		1357
	],
	"./page-data/en/what-we-offer/research-portfolio/mobisense/page-data.json": [
		"KTvL",
		1358
	],
	"./page-data/en/what-we-offer/research-portfolio/monicow/page-data.json": [
		"DtLT",
		1359
	],
	"./page-data/en/what-we-offer/research-portfolio/msipad/page-data.json": [
		"kcFy",
		1360
	],
	"./page-data/en/what-we-offer/research-portfolio/muscle-iot/page-data.json": [
		"xE3L",
		1361
	],
	"./page-data/en/what-we-offer/research-portfolio/myhealthdata/page-data.json": [
		"NgjX",
		1362
	],
	"./page-data/en/what-we-offer/research-portfolio/newsbutler/page-data.json": [
		"to8b",
		1363
	],
	"./page-data/en/what-we-offer/research-portfolio/nose/page-data.json": [
		"fseo",
		1364
	],
	"./page-data/en/what-we-offer/research-portfolio/page-data.json": [
		"ZRca",
		1365
	],
	"./page-data/en/what-we-offer/research-portfolio/patronus/page-data.json": [
		"o9na",
		1366
	],
	"./page-data/en/what-we-offer/research-portfolio/pro-flow/page-data.json": [
		"yoQh",
		1367
	],
	"./page-data/en/what-we-offer/research-portfolio/radiance/page-data.json": [
		"4MXY",
		1368
	],
	"./page-data/en/what-we-offer/research-portfolio/rails/page-data.json": [
		"hwbr",
		1369
	],
	"./page-data/en/what-we-offer/research-portfolio/rhetoric/page-data.json": [
		"eraE",
		1370
	],
	"./page-data/en/what-we-offer/research-portfolio/robo-cure/page-data.json": [
		"jE+Y",
		1371
	],
	"./page-data/en/what-we-offer/research-portfolio/safedroneware/page-data.json": [
		"EM13",
		1372
	],
	"./page-data/en/what-we-offer/research-portfolio/sara/page-data.json": [
		"V1Hj",
		1373
	],
	"./page-data/en/what-we-offer/research-portfolio/seclosed/page-data.json": [
		"PPyX",
		1374
	],
	"./page-data/en/what-we-offer/research-portfolio/seizeit/page-data.json": [
		"IZdv",
		1375
	],
	"./page-data/en/what-we-offer/research-portfolio/selvie/page-data.json": [
		"iv1h",
		1376
	],
	"./page-data/en/what-we-offer/research-portfolio/sencom/page-data.json": [
		"tGVT",
		1377
	],
	"./page-data/en/what-we-offer/research-portfolio/sensecity/page-data.json": [
		"46I8",
		1378
	],
	"./page-data/en/what-we-offer/research-portfolio/sequoia/page-data.json": [
		"H+R6",
		1379
	],
	"./page-data/en/what-we-offer/research-portfolio/sergio/page-data.json": [
		"HkWV",
		1380
	],
	"./page-data/en/what-we-offer/research-portfolio/shake/page-data.json": [
		"vVrE",
		1381
	],
	"./page-data/en/what-we-offer/research-portfolio/shift-tv/page-data.json": [
		"gsfY",
		1382
	],
	"./page-data/en/what-we-offer/research-portfolio/slogan/page-data.json": [
		"9aOQ",
		1383
	],
	"./page-data/en/what-we-offer/research-portfolio/smart-diapers/page-data.json": [
		"xt2M",
		1384
	],
	"./page-data/en/what-we-offer/research-portfolio/smart-suitcases/page-data.json": [
		"8Njy",
		1385
	],
	"./page-data/en/what-we-offer/research-portfolio/smartglaz/page-data.json": [
		"C1eR",
		1386
	],
	"./page-data/en/what-we-offer/research-portfolio/smartwatergrid/page-data.json": [
		"SNlB",
		1387
	],
	"./page-data/en/what-we-offer/research-portfolio/track/page-data.json": [
		"f2sI",
		1388
	],
	"./page-data/en/what-we-offer/research-portfolio/trapist/page-data.json": [
		"kfyh",
		1389
	],
	"./page-data/en/what-we-offer/research-portfolio/trendify/page-data.json": [
		"RfYH",
		1390
	],
	"./page-data/en/what-we-offer/research-portfolio/tru-bliss/page-data.json": [
		"RzqY",
		1391
	],
	"./page-data/en/what-we-offer/research-portfolio/twill-bipv/page-data.json": [
		"+tK3",
		1392
	],
	"./page-data/en/what-we-offer/research-portfolio/v-force/page-data.json": [
		"LNL7",
		1393
	],
	"./page-data/en/what-we-offer/research-portfolio/vil/page-data.json": [
		"x54X",
		1394
	],
	"./page-data/en/what-we-offer/research-portfolio/we-move/page-data.json": [
		"Mhwf",
		1395
	],
	"./page-data/en/what-we-offer/research-portfolio/wonder/page-data.json": [
		"HaFF",
		1396
	],
	"./page-data/en/what-we-offer/research/collaborative-research/page-data.json": [
		"xyr+",
		1397
	],
	"./page-data/en/what-we-offer/research/government-funded-research/page-data.json": [
		"XM4z",
		1398
	],
	"./page-data/en/what-we-offer/research/page-data.json": [
		"Q/ND",
		1399
	],
	"./page-data/en/what-we-offer/solutions/page-data.json": [
		"VUEz",
		1400
	],
	"./page-data/en/what-we-offer/venturing-and-startups/page-data.json": [
		"RqLv",
		1401
	],
	"./page-data/en/what-we-offer/venturing-for-start-ups-and-funds/imec-scale-ups/page-data.json": [
		"hgnd",
		1402
	],
	"./page-data/en/what-we-offer/venturing-for-start-ups-and-funds/page-data.json": [
		"Jgt2",
		1403
	],
	"./page-data/en/what-we-offer/venturing/page-data.json": [
		"Ah0n",
		1404
	],
	"./page-data/en/work-at-imec/academic-csc-opportunities/page-data.json": [
		"3ap5",
		1405
	],
	"./page-data/en/work-at-imec/academic-opportunities/page-data.json": [
		"skEN",
		1406
	],
	"./page-data/en/work-at-imec/data-privacy-statement/page-data.json": [
		"BHgH",
		1407
	],
	"./page-data/en/work-at-imec/job-opportunities/3d-circuit-technology-co-exploration-of-convolutional-neural-networks_2/page-data.json": [
		"/JNe",
		1408
	],
	"./page-data/en/work-at-imec/job-opportunities/3d-integration-engineer/page-data.json": [
		"UELB",
		1409
	],
	"./page-data/en/work-at-imec/job-opportunities/3state-3d-machine-learning-engineer/page-data.json": [
		"FT6i",
		1410
	],
	"./page-data/en/work-at-imec/job-opportunities/3state-angular-architect-team-lead-for-3d-vr-platform/page-data.json": [
		"4k2L",
		1411
	],
	"./page-data/en/work-at-imec/job-opportunities/3state-blender-python-developer/page-data.json": [
		"RiiG",
		1412
	],
	"./page-data/en/work-at-imec/job-opportunities/3state-experienced-python-developer-for-3d-platform/page-data.json": [
		"/bQb",
		1413
	],
	"./page-data/en/work-at-imec/job-opportunities/3state-junior-angular-developer-for-3d-vr-platform/page-data.json": [
		"vXXT",
		1414
	],
	"./page-data/en/work-at-imec/job-opportunities/3state-senior-web-3d-vr-developer/page-data.json": [
		"mW5c",
		1415
	],
	"./page-data/en/work-at-imec/job-opportunities/a-multisensory-virtual-reality-system-to-study-spatial-navigation-in-mice/page-data.json": [
		"PW+q",
		1416
	],
	"./page-data/en/work-at-imec/job-opportunities/ab-initio-modeling-of-extreme-uv-matter-interactions/page-data.json": [
		"G0i1",
		1417
	],
	"./page-data/en/work-at-imec/job-opportunities/access-to-talent-mission-internationalization-coordinator/page-data.json": [
		"EkG0",
		1418
	],
	"./page-data/en/work-at-imec/job-opportunities/additive-manufacturing-for-novel-heat-dissipation-techniques-in-power-converters-csc-related-type-1/page-data.json": [
		"uib+",
		1419
	],
	"./page-data/en/work-at-imec/job-opportunities/administratief-medewerker-masterdata-materialen-interim_2/page-data.json": [
		"OaKc",
		1420
	],
	"./page-data/en/work-at-imec/job-opportunities/administrative-assistant/page-data.json": [
		"CjTG",
		1421
	],
	"./page-data/en/work-at-imec/job-opportunities/adshot-internship-web-development/page-data.json": [
		"fnSY",
		1422
	],
	"./page-data/en/work-at-imec/job-opportunities/advanced-multiscale-modelling-of-quantum-dots-for-quantum-computing-or-optoelectronic-applications/page-data.json": [
		"lKS+",
		1423
	],
	"./page-data/en/work-at-imec/job-opportunities/ai-based-prediction-of-agitation-in-dementia-patients/page-data.json": [
		"kjtO",
		1424
	],
	"./page-data/en/work-at-imec/job-opportunities/ai-system-r-d-engineer/page-data.json": [
		"5wzV",
		1425
	],
	"./page-data/en/work-at-imec/job-opportunities/airshaper-summer-internship-2020-market-research-analysis/page-data.json": [
		"+Ibx",
		1426
	],
	"./page-data/en/work-at-imec/job-opportunities/alexandria-works-design-ux-ui-internship/page-data.json": [
		"V9yi",
		1427
	],
	"./page-data/en/work-at-imec/job-opportunities/alexandria-works-full-stack-developer/page-data.json": [
		"AT3l",
		1428
	],
	"./page-data/en/work-at-imec/job-opportunities/alexandria-works-marketing-internship/page-data.json": [
		"CB6a",
		1429
	],
	"./page-data/en/work-at-imec/job-opportunities/all-solid-state-thin-film-batteries-with-flexible-form-factor/page-data.json": [
		"Mkcm",
		1430
	],
	"./page-data/en/work-at-imec/job-opportunities/ambassify-machine-learning-expert/page-data.json": [
		"cyag",
		1431
	],
	"./page-data/en/work-at-imec/job-opportunities/analog-design-engineer-for-cmos-imager/page-data.json": [
		"UKyX",
		1432
	],
	"./page-data/en/work-at-imec/job-opportunities/analog-design-engineer-for-ultra-low-power-biomedical-applications_2/page-data.json": [
		"pUzT",
		1433
	],
	"./page-data/en/work-at-imec/job-opportunities/anything-imaging-intern-summer/page-data.json": [
		"1NBY",
		1434
	],
	"./page-data/en/work-at-imec/job-opportunities/appm-project-manager/page-data.json": [
		"eUCh",
		1435
	],
	"./page-data/en/work-at-imec/job-opportunities/artificial-intelligence-based-spectral-correction-for-hyperspectral-imaging-sensors/page-data.json": [
		"eQcq",
		1436
	],
	"./page-data/en/work-at-imec/job-opportunities/asic-test-engineer_2/page-data.json": [
		"y28h",
		1437
	],
	"./page-data/en/work-at-imec/job-opportunities/assistent-architect-consultant/page-data.json": [
		"d6w1",
		1438
	],
	"./page-data/en/work-at-imec/job-opportunities/atmospheric-pressure-plasma-enhanced-chemical-vapor-deposition-ap-pecvd-of-functional-coatings-for-electrochemical-sensing/page-data.json": [
		"MGrR",
		1439
	],
	"./page-data/en/work-at-imec/job-opportunities/atom-probe-tomography-for-next-generation-3d-semiconductor-nanodevice-characterization/page-data.json": [
		"86Hk",
		1440
	],
	"./page-data/en/work-at-imec/job-opportunities/automating-the-optical-detection-of-exfoliated-two-dimensional-materials/page-data.json": [
		"39mp",
		1441
	],
	"./page-data/en/work-at-imec/job-opportunities/azamuta-user-interface-engineer-javascript-react/page-data.json": [
		"o+44",
		1442
	],
	"./page-data/en/work-at-imec/job-opportunities/backend-expert/page-data.json": [
		"FAlX",
		1443
	],
	"./page-data/en/work-at-imec/job-opportunities/biochemical-engineer-oneplanet-research-center_2/page-data.json": [
		"M5aA",
		1444
	],
	"./page-data/en/work-at-imec/job-opportunities/biochemical-engineer_2/page-data.json": [
		"QPWR",
		1445
	],
	"./page-data/en/work-at-imec/job-opportunities/biomedical-engineer_6/page-data.json": [
		"C3M4",
		1446
	],
	"./page-data/en/work-at-imec/job-opportunities/biomedical-researcher-oneplanet-research-center_3/page-data.json": [
		"CEij",
		1447
	],
	"./page-data/en/work-at-imec/job-opportunities/brighterbins-business-development-sales-director-for-international-markets/page-data.json": [
		"pxpb",
		1448
	],
	"./page-data/en/work-at-imec/job-opportunities/buffl-community-growth-manager/page-data.json": [
		"lCpI",
		1449
	],
	"./page-data/en/work-at-imec/job-opportunities/buffl-front-end-developer/page-data.json": [
		"pOcQ",
		1450
	],
	"./page-data/en/work-at-imec/job-opportunities/buffl-marketing-sales-management-informatica-internships/page-data.json": [
		"Qz8N",
		1451
	],
	"./page-data/en/work-at-imec/job-opportunities/building-extreme-throughput-wireless-communication-systems-for-6g/page-data.json": [
		"rYZe",
		1452
	],
	"./page-data/en/work-at-imec/job-opportunities/business-controller_2/page-data.json": [
		"pIzI",
		1453
	],
	"./page-data/en/work-at-imec/job-opportunities/business-development-manager-semiconductor-specialty-components/page-data.json": [
		"3Q4E",
		1454
	],
	"./page-data/en/work-at-imec/job-opportunities/business-development-manager/page-data.json": [
		"WPd7",
		1455
	],
	"./page-data/en/work-at-imec/job-opportunities/business-lead-ceo-for-fake-financial-news-detection-venture-imec-vub/page-data.json": [
		"1vhp",
		1456
	],
	"./page-data/en/work-at-imec/job-opportunities/calltic-international-project-implementation-manager-ict/page-data.json": [
		"kVJU",
		1457
	],
	"./page-data/en/work-at-imec/job-opportunities/can-ai-support-objective-assessment-pain/page-data.json": [
		"e2Dh",
		1458
	],
	"./page-data/en/work-at-imec/job-opportunities/capillary-interactions-with-nanoscale-devices/page-data.json": [
		"Ng+0",
		1459
	],
	"./page-data/en/work-at-imec/job-opportunities/categorization-of-motor-behavior-using-machine-learning-approaches/page-data.json": [
		"WYQb",
		1460
	],
	"./page-data/en/work-at-imec/job-opportunities/category-buyer-indirecte-aankopen/page-data.json": [
		"PKEx",
		1461
	],
	"./page-data/en/work-at-imec/job-opportunities/cell-free-massive-mimo-for-ultra-reliable-6g-wireless-communication-systems/page-data.json": [
		"IBnm",
		1462
	],
	"./page-data/en/work-at-imec/job-opportunities/characterization-and-development-of-spin-torque-memory-for-cache-applications/page-data.json": [
		"HSSH",
		1463
	],
	"./page-data/en/work-at-imec/job-opportunities/characterization-and-statistical-analysis-of-waveguide-losses-on-a-silicon-nitride-photonics-platform/page-data.json": [
		"FlbR",
		1464
	],
	"./page-data/en/work-at-imec/job-opportunities/characterization-of-imc-intermetallic-compound-properties-used-at-3d-stacking-high-density-interconnects/page-data.json": [
		"cT6Z",
		1465
	],
	"./page-data/en/work-at-imec/job-opportunities/citizenlab-applied-nlp-engineer/page-data.json": [
		"SxEJ",
		1466
	],
	"./page-data/en/work-at-imec/job-opportunities/citizenlab-business-developer-manager-uk/page-data.json": [
		"dGOF",
		1467
	],
	"./page-data/en/work-at-imec/job-opportunities/citizenlab-digital-marketer/page-data.json": [
		"j7H7",
		1468
	],
	"./page-data/en/work-at-imec/job-opportunities/citizenlab-engineer-full-stack-back-end-2-positions/page-data.json": [
		"v+oY",
		1469
	],
	"./page-data/en/work-at-imec/job-opportunities/citizenlab-government-success-manager-netherlands/page-data.json": [
		"3J5Z",
		1470
	],
	"./page-data/en/work-at-imec/job-opportunities/citizenlab-head-of-partner-sales/page-data.json": [
		"M56C",
		1471
	],
	"./page-data/en/work-at-imec/job-opportunities/citizenlab-internship-business-development/page-data.json": [
		"PRrb",
		1472
	],
	"./page-data/en/work-at-imec/job-opportunities/citizenlab-product-manager/page-data.json": [
		"4jvD",
		1473
	],
	"./page-data/en/work-at-imec/job-opportunities/cleanroom-medewerker_2/page-data.json": [
		"u4+D",
		1474
	],
	"./page-data/en/work-at-imec/job-opportunities/cloud-developer-oneplanet-research-center/page-data.json": [
		"cDrY",
		1475
	],
	"./page-data/en/work-at-imec/job-opportunities/cmp-r-d-engineer/page-data.json": [
		"uTPL",
		1476
	],
	"./page-data/en/work-at-imec/job-opportunities/computer-vision-intern-summer/page-data.json": [
		"5dOw",
		1477
	],
	"./page-data/en/work-at-imec/job-opportunities/conductiv-ai-data-scientist/page-data.json": [
		"pObV",
		1478
	],
	"./page-data/en/work-at-imec/job-opportunities/constell8-embedded-software-engineer/page-data.json": [
		"Aimd",
		1479
	],
	"./page-data/en/work-at-imec/job-opportunities/contell8-application-developer/page-data.json": [
		"2z1+",
		1480
	],
	"./page-data/en/work-at-imec/job-opportunities/contento-customer-success-manager/page-data.json": [
		"Yqnq",
		1481
	],
	"./page-data/en/work-at-imec/job-opportunities/contento-customer-success-specialist/page-data.json": [
		"Nr1X",
		1482
	],
	"./page-data/en/work-at-imec/job-opportunities/contento-full-stack-developer-ads/page-data.json": [
		"/rne",
		1483
	],
	"./page-data/en/work-at-imec/job-opportunities/contento-full-stack-developer/page-data.json": [
		"ysse",
		1484
	],
	"./page-data/en/work-at-imec/job-opportunities/contento-full-stack-developer_2/page-data.json": [
		"jQQY",
		1485
	],
	"./page-data/en/work-at-imec/job-opportunities/contento-inbound-marketing-executive/page-data.json": [
		"EI41",
		1486
	],
	"./page-data/en/work-at-imec/job-opportunities/contento-inside-sales-executive/page-data.json": [
		"JPIR",
		1487
	],
	"./page-data/en/work-at-imec/job-opportunities/contract-and-grant-administrator/page-data.json": [
		"GIfC",
		1488
	],
	"./page-data/en/work-at-imec/job-opportunities/coo-for-a-single-cell-multi-omics-start-up-project-by-imec-and-vib/page-data.json": [
		"Pj1v",
		1489
	],
	"./page-data/en/work-at-imec/job-opportunities/coo-for-a-venture-backed-smart-contact-lens-startup/page-data.json": [
		"WoQF",
		1490
	],
	"./page-data/en/work-at-imec/job-opportunities/creative-therapy-full-stack-developer/page-data.json": [
		"DrPJ",
		1491
	],
	"./page-data/en/work-at-imec/job-opportunities/creative-therapy-marketing-sales-internships/page-data.json": [
		"9Fnm",
		1492
	],
	"./page-data/en/work-at-imec/job-opportunities/d-pac-cto/page-data.json": [
		"F7lt",
		1493
	],
	"./page-data/en/work-at-imec/job-opportunities/d-pac-marketing-sales-internship/page-data.json": [
		"IZ74",
		1494
	],
	"./page-data/en/work-at-imec/job-opportunities/data-analysis-on-in-vitro-neuronal-network-electrophysiology_2/page-data.json": [
		"AiI5",
		1495
	],
	"./page-data/en/work-at-imec/job-opportunities/data-scientist-in-the-domain-of-autonomous-drones/page-data.json": [
		"/bc2",
		1496
	],
	"./page-data/en/work-at-imec/job-opportunities/decoding-the-neural-circuits-for-spatial-memory/page-data.json": [
		"K8MI",
		1497
	],
	"./page-data/en/work-at-imec/job-opportunities/decoupling-2d-materials-from-its-growth-surface-via-ion-implantation/page-data.json": [
		"InRH",
		1498
	],
	"./page-data/en/work-at-imec/job-opportunities/deo-business-marketing-sales-logistics-it-engineering-internships/page-data.json": [
		"l08z",
		1499
	],
	"./page-data/en/work-at-imec/job-opportunities/design-of-broadband-photonic-integrated-components-for-optical-coherence-tomography/page-data.json": [
		"1OB6",
		1500
	],
	"./page-data/en/work-at-imec/job-opportunities/design-of-efficient-transmitter-architectures-for-5g-mm-wave-communication/page-data.json": [
		"dhLl",
		1501
	],
	"./page-data/en/work-at-imec/job-opportunities/design-technology-co-optimization-for-high-yield-sram-in-sub-7nm-nodes/page-data.json": [
		"T4lD",
		1502
	],
	"./page-data/en/work-at-imec/job-opportunities/design-technology-co-optimization-of-emerging-storage-class-memories/page-data.json": [
		"cSCV",
		1503
	],
	"./page-data/en/work-at-imec/job-opportunities/design-technology-co-optimization-of-logic-device-for-memory-application/page-data.json": [
		"1cAK",
		1504
	],
	"./page-data/en/work-at-imec/job-opportunities/detecting-protein-translocations-on-sin-nanopores/page-data.json": [
		"E7J5",
		1505
	],
	"./page-data/en/work-at-imec/job-opportunities/determining-the-ultrafast-molecular-dynamics-of-exposed-extreme-ultraviolet-photoresists/page-data.json": [
		"ewRH",
		1506
	],
	"./page-data/en/work-at-imec/job-opportunities/development-of-advanced-scripting-and-programming-algorithms-for-automated-scanning-electron-microscopy-sem-inspections/page-data.json": [
		"l4HY",
		1507
	],
	"./page-data/en/work-at-imec/job-opportunities/development-of-photo-emission-spectroscopy-from-planar-to-3d-structures/page-data.json": [
		"EWd4",
		1508
	],
	"./page-data/en/work-at-imec/job-opportunities/development-of-reliable-high-commutation-speed-gan-power-devices-with-applications-in-lidar-for-self-driving-vehicles/page-data.json": [
		"F7Cl",
		1509
	],
	"./page-data/en/work-at-imec/job-opportunities/development-of-reproducible-ultra-thin-cu-in-ga-se2-absorber-material-for-solar-cell-production/page-data.json": [
		"ZTVd",
		1510
	],
	"./page-data/en/work-at-imec/job-opportunities/device-engineer-at-cryogenic-temperature/page-data.json": [
		"+58A",
		1511
	],
	"./page-data/en/work-at-imec/job-opportunities/device-engineer-quantum-computing_3/page-data.json": [
		"Mqfh",
		1512
	],
	"./page-data/en/work-at-imec/job-opportunities/dfm-and-data-prep-engineer/page-data.json": [
		"ICee",
		1513
	],
	"./page-data/en/work-at-imec/job-opportunities/dielectric-nanosheets-for-scaled-two-dimensional-2d-material-devices/page-data.json": [
		"9DDt",
		1514
	],
	"./page-data/en/work-at-imec/job-opportunities/dielectric-reliability-in-3-d-highly-scaled-interconnects/page-data.json": [
		"IJaR",
		1515
	],
	"./page-data/en/work-at-imec/job-opportunities/director-facilities-and-infrastructure/page-data.json": [
		"I83I",
		1516
	],
	"./page-data/en/work-at-imec/job-opportunities/effect-of-biological-environments-and-cell-cultures-on-electronic-cmos-chips_2/page-data.json": [
		"tiYE",
		1517
	],
	"./page-data/en/work-at-imec/job-opportunities/electrical-capture-of-bio-particles-in-microfluidic-systems/page-data.json": [
		"nWLI",
		1518
	],
	"./page-data/en/work-at-imec/job-opportunities/electro-magnetic-and-thermal-modeling-for-future-rf-technologies/page-data.json": [
		"t8h6",
		1519
	],
	"./page-data/en/work-at-imec/job-opportunities/electrochemical-mechanical-study-of-solid-state-generation-lithium-batteries/page-data.json": [
		"5VBC",
		1520
	],
	"./page-data/en/work-at-imec/job-opportunities/electronic-landscaping-of-thin-film-imagers/page-data.json": [
		"5G/H",
		1521
	],
	"./page-data/en/work-at-imec/job-opportunities/elektromechanisch-ingenieur/page-data.json": [
		"cvdv",
		1522
	],
	"./page-data/en/work-at-imec/job-opportunities/enabling-2d-material-applications-through-interface-engineering/page-data.json": [
		"3Ta+",
		1523
	],
	"./page-data/en/work-at-imec/job-opportunities/energy-management-in-smart-buildings-and-districts-with-high-penetration-of-renewables/page-data.json": [
		"3SM5",
		1524
	],
	"./page-data/en/work-at-imec/job-opportunities/engineering-coordinator/page-data.json": [
		"0JEc",
		1525
	],
	"./page-data/en/work-at-imec/job-opportunities/entrepreneurial-ceo-for-imec-start-up-in-the-field-of-ar/page-data.json": [
		"h0YX",
		1526
	],
	"./page-data/en/work-at-imec/job-opportunities/entrepreneurial-head-of-business-development-with-ceo-potential-for-imec-nanosound-start-up/page-data.json": [
		"EqJN",
		1527
	],
	"./page-data/en/work-at-imec/job-opportunities/entrepreneurial-principal-member-of-technical-staff-ai-iot/page-data.json": [
		"Y/Qc",
		1528
	],
	"./page-data/en/work-at-imec/job-opportunities/entrepreneurial-scientist-with-cto-potential/page-data.json": [
		"hvjx",
		1529
	],
	"./page-data/en/work-at-imec/job-opportunities/epcon-data-science/page-data.json": [
		"AyP6",
		1530
	],
	"./page-data/en/work-at-imec/job-opportunities/epcon-epidemiology/page-data.json": [
		"Ei3w",
		1531
	],
	"./page-data/en/work-at-imec/job-opportunities/epcon-gis/page-data.json": [
		"DAFz",
		1532
	],
	"./page-data/en/work-at-imec/job-opportunities/epcon-iot-apps/page-data.json": [
		"CCvC",
		1533
	],
	"./page-data/en/work-at-imec/job-opportunities/epic-blue-senior-software-engineers/page-data.json": [
		"Sg5M",
		1534
	],
	"./page-data/en/work-at-imec/job-opportunities/epihunter-marketing-business-management-2018-2019-internship/page-data.json": [
		"jDVM",
		1535
	],
	"./page-data/en/work-at-imec/job-opportunities/epihunter-office-mangement-2018-2019-internship/page-data.json": [
		"VUzn",
		1536
	],
	"./page-data/en/work-at-imec/job-opportunities/epihunter-social-community-management-2018-2019-internship/page-data.json": [
		"oxqb",
		1537
	],
	"./page-data/en/work-at-imec/job-opportunities/epihunter-social-community-management/page-data.json": [
		"Mtcp",
		1538
	],
	"./page-data/en/work-at-imec/job-opportunities/epihunter-software-developer-2018-2019-internship/page-data.json": [
		"hmRl",
		1539
	],
	"./page-data/en/work-at-imec/job-opportunities/epihunter-software-developer/page-data.json": [
		"0F2n",
		1540
	],
	"./page-data/en/work-at-imec/job-opportunities/epihunter-translater-interpreter-2018-2019-internship/page-data.json": [
		"INSG",
		1541
	],
	"./page-data/en/work-at-imec/job-opportunities/epihunter-ux-designer-researcher-2018-2019-internship/page-data.json": [
		"YTtx",
		1542
	],
	"./page-data/en/work-at-imec/job-opportunities/epilog-research-engineer/page-data.json": [
		"q+AE",
		1543
	],
	"./page-data/en/work-at-imec/job-opportunities/equicty-fullstack-web-developer/page-data.json": [
		"h/Ri",
		1544
	],
	"./page-data/en/work-at-imec/job-opportunities/equicty-software-qa-engineer/page-data.json": [
		"c0D1",
		1545
	],
	"./page-data/en/work-at-imec/job-opportunities/equipment-engineer/page-data.json": [
		"gyy+",
		1546
	],
	"./page-data/en/work-at-imec/job-opportunities/equipment-engineering-manager/page-data.json": [
		"13vu",
		1547
	],
	"./page-data/en/work-at-imec/job-opportunities/exploration-of-true-artificial-intelligence-opportunities-starting-from-intrinsic-physical-properties-of-novel-device-technologies/page-data.json": [
		"n+bm",
		1548
	],
	"./page-data/en/work-at-imec/job-opportunities/exploring-mm-wave-large-signal-measurements-for-modelling-of-emerging-iii-v-and-iii-n-devices/page-data.json": [
		"2Jxf",
		1549
	],
	"./page-data/en/work-at-imec/job-opportunities/exploring-pixels-for-the-future-imager/page-data.json": [
		"mB+n",
		1550
	],
	"./page-data/en/work-at-imec/job-opportunities/fab-data-analyst/page-data.json": [
		"fy/G",
		1551
	],
	"./page-data/en/work-at-imec/job-opportunities/fab-wafer-bonding-assembly-engineer/page-data.json": [
		"vEUk",
		1552
	],
	"./page-data/en/work-at-imec/job-opportunities/fabrication-of-lithium-metal-anodes-for-rechargeable-solid-state-batteries/page-data.json": [
		"eYR9",
		1553
	],
	"./page-data/en/work-at-imec/job-opportunities/fan-arena-full-stack-java-developer/page-data.json": [
		"tP8u",
		1554
	],
	"./page-data/en/work-at-imec/job-opportunities/feasibility-analysis-of-wireless-power-transfer-implementation-in-building-integrated-photovoltaic-systems/page-data.json": [
		"oFUh",
		1555
	],
	"./page-data/en/work-at-imec/job-opportunities/field-service-engineer/page-data.json": [
		"x57R",
		1556
	],
	"./page-data/en/work-at-imec/job-opportunities/field-test-engineer/page-data.json": [
		"3n9g",
		1557
	],
	"./page-data/en/work-at-imec/job-opportunities/finance-systems-process-analyst/page-data.json": [
		"7Lbm",
		1558
	],
	"./page-data/en/work-at-imec/job-opportunities/find-structure-where-none-is-apparent-super-resolution-fluorescent-imaging-of-photoresists/page-data.json": [
		"kczR",
		1559
	],
	"./page-data/en/work-at-imec/job-opportunities/firmalyzer-business-development-manager-freelance/page-data.json": [
		"na8j",
		1560
	],
	"./page-data/en/work-at-imec/job-opportunities/firmalyzer-software-developer-freelance/page-data.json": [
		"chuG",
		1561
	],
	"./page-data/en/work-at-imec/job-opportunities/fowlp-integration-engineer/page-data.json": [
		"lWA2",
		1562
	],
	"./page-data/en/work-at-imec/job-opportunities/frequency-chirping-plls-for-mmwave-fmcw-radar/page-data.json": [
		"h0IG",
		1563
	],
	"./page-data/en/work-at-imec/job-opportunities/from-physics-based-fet-degradation-models-to-circuit-level-simulations/page-data.json": [
		"2P86",
		1564
	],
	"./page-data/en/work-at-imec/job-opportunities/gemotiveerde-technische-bachelor_2/page-data.json": [
		"n2lq",
		1565
	],
	"./page-data/en/work-at-imec/job-opportunities/gemotiveerde-technische-bachelor_3/page-data.json": [
		"Rfxr",
		1566
	],
	"./page-data/en/work-at-imec/job-opportunities/group-leader-thin-film-deposition-process-engineering/page-data.json": [
		"7L5B",
		1567
	],
	"./page-data/en/work-at-imec/job-opportunities/hardware-efficient-training-of-deep-neural-networks/page-data.json": [
		"sW5D",
		1568
	],
	"./page-data/en/work-at-imec/job-opportunities/hardware-efficient-vlsi-design-for-large-scale-neural-signal-processing/page-data.json": [
		"AUiV",
		1569
	],
	"./page-data/en/work-at-imec/job-opportunities/hardware-engineer/page-data.json": [
		"M/bg",
		1570
	],
	"./page-data/en/work-at-imec/job-opportunities/head-product-development-technical-role-at-belgian-office-yess-technologies/page-data.json": [
		"7U5H",
		1571
	],
	"./page-data/en/work-at-imec/job-opportunities/heat-conduction-in-2d-thin-films/page-data.json": [
		"9Xix",
		1572
	],
	"./page-data/en/work-at-imec/job-opportunities/helpilepsy-epione-chief-technology-officer-cto/page-data.json": [
		"STuj",
		1573
	],
	"./page-data/en/work-at-imec/job-opportunities/high-efficiency-interdigitated-back-contacted-si-heterojunction-ibc-shj-cells-for-tandem-applications/page-data.json": [
		"k78M",
		1574
	],
	"./page-data/en/work-at-imec/job-opportunities/high-k-and-magnetic-material-for-voltage-controlled-vcma-mram-applications/page-data.json": [
		"Zd0G",
		1575
	],
	"./page-data/en/work-at-imec/job-opportunities/high-speed-adcs-for-next-generation-optical-links/page-data.json": [
		"ShZW",
		1576
	],
	"./page-data/en/work-at-imec/job-opportunities/hr-director/page-data.json": [
		"KLaX",
		1577
	],
	"./page-data/en/work-at-imec/job-opportunities/hr-manager-total-rewards-payroll/page-data.json": [
		"gx5e",
		1578
	],
	"./page-data/en/work-at-imec/job-opportunities/hr-recruitment-assistant/page-data.json": [
		"zP7M",
		1579
	],
	"./page-data/en/work-at-imec/job-opportunities/human-activity-and-posture-classification-using-single-non-contact-radar-sensor/page-data.json": [
		"KwrC",
		1580
	],
	"./page-data/en/work-at-imec/job-opportunities/hy-spe3d-imaging-intern/page-data.json": [
		"GSVf",
		1581
	],
	"./page-data/en/work-at-imec/job-opportunities/hydrophilic-uv-curable-resins-for-3d-printing_2/page-data.json": [
		"MV4m",
		1582
	],
	"./page-data/en/work-at-imec/job-opportunities/ict-infra-security-project-leader/page-data.json": [
		"J3LR",
		1583
	],
	"./page-data/en/work-at-imec/job-opportunities/ict-project-leader-consultant/page-data.json": [
		"OEgE",
		1584
	],
	"./page-data/en/work-at-imec/job-opportunities/ict-project-leader/page-data.json": [
		"ICOP",
		1585
	],
	"./page-data/en/work-at-imec/job-opportunities/imec-istart-coordinator-tijdelijke-tewerkstelling-via-interim/page-data.json": [
		"K06s",
		1586
	],
	"./page-data/en/work-at-imec/job-opportunities/imec-istart-internship-market-research-feasibility-study/page-data.json": [
		"2fi/",
		1587
	],
	"./page-data/en/work-at-imec/job-opportunities/impact-of-thermal-gradients-on-the-reliability-of-nano-wires-3d-tsvs-and-heaters/page-data.json": [
		"Tbj8",
		1588
	],
	"./page-data/en/work-at-imec/job-opportunities/industrial-hyperspectral-image-sensor-calibration-and-yield-analysis_2/page-data.json": [
		"SPZr",
		1589
	],
	"./page-data/en/work-at-imec/job-opportunities/integrated-circuit-design-support-engineer/page-data.json": [
		"yGHt",
		1590
	],
	"./page-data/en/work-at-imec/job-opportunities/integrated-ghz-scanning-acoustic-microscope-for-3d-nano-imaging/page-data.json": [
		"MjPu",
		1591
	],
	"./page-data/en/work-at-imec/job-opportunities/integration-of-ageing-model-in-the-energy-yield-simulation-frame-for-pv-modules-imec_2/page-data.json": [
		"604e",
		1592
	],
	"./page-data/en/work-at-imec/job-opportunities/intelligent-multi-functional-sensor-platform-for-autonomous-nano-tomography/page-data.json": [
		"yQf2",
		1593
	],
	"./page-data/en/work-at-imec/job-opportunities/inverse-design-of-photonic-components/page-data.json": [
		"/WHU",
		1594
	],
	"./page-data/en/work-at-imec/job-opportunities/investigating-dry-etch-process-induced-damage-to-multilayer-stacks-used-in-complex-memory-technologies/page-data.json": [
		"qAro",
		1595
	],
	"./page-data/en/work-at-imec/job-opportunities/iot-mobile-app-developer-oneplanet-research-center_2/page-data.json": [
		"1gxU",
		1596
	],
	"./page-data/en/work-at-imec/job-opportunities/joint-radar-and-communications-in-massive-mimo-systems_2/page-data.json": [
		"QEtJ",
		1597
	],
	"./page-data/en/work-at-imec/job-opportunities/juce-growth-marketing-all-star/page-data.json": [
		"Kut+",
		1598
	],
	"./page-data/en/work-at-imec/job-opportunities/junior-process-step-engineer-for-d2w-heterogeneous-assembly/page-data.json": [
		"KKpo",
		1599
	],
	"./page-data/en/work-at-imec/job-opportunities/junior-project-manager_2/page-data.json": [
		"O108",
		1600
	],
	"./page-data/en/work-at-imec/job-opportunities/kadonation-full-stack-developer/page-data.json": [
		"hqdy",
		1601
	],
	"./page-data/en/work-at-imec/job-opportunities/kadonation-sales-talent/page-data.json": [
		"82mQ",
		1602
	],
	"./page-data/en/work-at-imec/job-opportunities/large-area-capacitive-mems-for-flexible-electronics/page-data.json": [
		"2hlb",
		1603
	],
	"./page-data/en/work-at-imec/job-opportunities/large-area-high-density-electrocorticography-ecog/page-data.json": [
		"eE3W",
		1604
	],
	"./page-data/en/work-at-imec/job-opportunities/layout-design-and-pdk-engineer/page-data.json": [
		"0Bte",
		1605
	],
	"./page-data/en/work-at-imec/job-opportunities/lead-engineer-test-and-characterization/page-data.json": [
		"2H5r",
		1606
	],
	"./page-data/en/work-at-imec/job-opportunities/legal-counsel-business-contracts/page-data.json": [
		"EOfP",
		1607
	],
	"./page-data/en/work-at-imec/job-opportunities/levelup-ios-developer/page-data.json": [
		"+8IE",
		1608
	],
	"./page-data/en/work-at-imec/job-opportunities/levelup-sales-development-representative-dutch/page-data.json": [
		"APZo",
		1609
	],
	"./page-data/en/work-at-imec/job-opportunities/levelup-xamarin-c-developer/page-data.json": [
		"52Cl",
		1610
	],
	"./page-data/en/work-at-imec/job-opportunities/low-loss-magnetic-components-for-high-performance-interaction-with-gallium-nitride-power-converters/page-data.json": [
		"eAil",
		1611
	],
	"./page-data/en/work-at-imec/job-opportunities/lynxcare-senior-sales-executive-orthopaedics/page-data.json": [
		"Akuj",
		1612
	],
	"./page-data/en/work-at-imec/job-opportunities/machine-learning-based-computational-lithography-opc-dfm/page-data.json": [
		"BA8r",
		1613
	],
	"./page-data/en/work-at-imec/job-opportunities/many-people-want-to-change-the-world-at-imec-we-are-actually-working-on-it/page-data.json": [
		"fTeF",
		1614
	],
	"./page-data/en/work-at-imec/job-opportunities/material-selection-for-3d-interconnects-for-devices-working-at-low-cryogenic-temperatures-in-3d-stacking/page-data.json": [
		"IF3g",
		1615
	],
	"./page-data/en/work-at-imec/job-opportunities/mbe-growth-and-characterization-of-novel-topological-insulating-oxide-based-materials-erc-cog/page-data.json": [
		"1fXs",
		1616
	],
	"./page-data/en/work-at-imec/job-opportunities/mealhero-engineering-product-dev-automatisation-industry-4-0-warehouse-it-erp/page-data.json": [
		"NDs0",
		1617
	],
	"./page-data/en/work-at-imec/job-opportunities/mealhero-event-management-internship/page-data.json": [
		"yGpd",
		1618
	],
	"./page-data/en/work-at-imec/job-opportunities/mealhero-front-end-software-developer/page-data.json": [
		"VPSm",
		1619
	],
	"./page-data/en/work-at-imec/job-opportunities/mealhero-graphic-design-internship/page-data.json": [
		"Uowk",
		1620
	],
	"./page-data/en/work-at-imec/job-opportunities/mealhero-internship-front-end-development/page-data.json": [
		"xAmN",
		1621
	],
	"./page-data/en/work-at-imec/job-opportunities/mealhero-internship-ux-ui-designer/page-data.json": [
		"UgBI",
		1622
	],
	"./page-data/en/work-at-imec/job-opportunities/mealhero-internships-tech-engineering/page-data.json": [
		"woan",
		1623
	],
	"./page-data/en/work-at-imec/job-opportunities/mealhero-junior-food-operations/page-data.json": [
		"rc0Z",
		1624
	],
	"./page-data/en/work-at-imec/job-opportunities/mealhero-marketing-internship/page-data.json": [
		"eA0Z",
		1625
	],
	"./page-data/en/work-at-imec/job-opportunities/mealhero-office-management-internship/page-data.json": [
		"CYKV",
		1626
	],
	"./page-data/en/work-at-imec/job-opportunities/mealhero-software-internship/page-data.json": [
		"tC35",
		1627
	],
	"./page-data/en/work-at-imec/job-opportunities/mealhero-supply-chain-operations-internship/page-data.json": [
		"uHFZ",
		1628
	],
	"./page-data/en/work-at-imec/job-opportunities/mechanical-stress-sensing/page-data.json": [
		"blX8",
		1629
	],
	"./page-data/en/work-at-imec/job-opportunities/mechanics-of-void-formation-and-evolution-in-highly-scaled-nano-wires/page-data.json": [
		"jM3C",
		1630
	],
	"./page-data/en/work-at-imec/job-opportunities/medical-imaging-by-2d-large-area-ultrasound-arrays_2/page-data.json": [
		"zRqp",
		1631
	],
	"./page-data/en/work-at-imec/job-opportunities/mems-design-engineer_2/page-data.json": [
		"1JU2",
		1632
	],
	"./page-data/en/work-at-imec/job-opportunities/metals-nanopatterning-for-future-quantum-and-cmos-technology/page-data.json": [
		"027e",
		1633
	],
	"./page-data/en/work-at-imec/job-opportunities/methodology-development-for-the-fundamental-investigation-of-high-energy-cathodes-in-lithium-batteries/page-data.json": [
		"fgJi",
		1634
	],
	"./page-data/en/work-at-imec/job-opportunities/ml-enhanced-phy-processing-for-6g-networks/page-data.json": [
		"An/k",
		1635
	],
	"./page-data/en/work-at-imec/job-opportunities/modeling-of-nanoscale-single-molecule-biosensors/page-data.json": [
		"drEj",
		1636
	],
	"./page-data/en/work-at-imec/job-opportunities/modelling-of-novel-2d-magnetic-materials/page-data.json": [
		"wwoG",
		1637
	],
	"./page-data/en/work-at-imec/job-opportunities/modelling-sun-tracking-pv-systems-installed-on-uneven-terrain/page-data.json": [
		"+y8m",
		1638
	],
	"./page-data/en/work-at-imec/job-opportunities/mram-postdoc-researcher/page-data.json": [
		"3k3V",
		1639
	],
	"./page-data/en/work-at-imec/job-opportunities/mram-researcher/page-data.json": [
		"GRFq",
		1640
	],
	"./page-data/en/work-at-imec/job-opportunities/nano-scale-field-effect-transistor-for-biomolecule-sensing_2/page-data.json": [
		"7Ym8",
		1641
	],
	"./page-data/en/work-at-imec/job-opportunities/nanofluidic-memory/page-data.json": [
		"THN4",
		1642
	],
	"./page-data/en/work-at-imec/job-opportunities/nanophotonic-raman-spectroscopy-for-sensitive-molecular-fingerprinting/page-data.json": [
		"wCmi",
		1643
	],
	"./page-data/en/work-at-imec/job-opportunities/neural-network-based-approach-to-design-complex-pv-systems/page-data.json": [
		"f8CJ",
		1644
	],
	"./page-data/en/work-at-imec/job-opportunities/neuromodulation-through-micro-electrodes-with-combined-stimulation-and-recording-capacity-in-a-semi-flexible-implantable-format/page-data.json": [
		"AWqo",
		1645
	],
	"./page-data/en/work-at-imec/job-opportunities/nextbook-full-stack-developer/page-data.json": [
		"s2xA",
		1646
	],
	"./page-data/en/work-at-imec/job-opportunities/nextbook-kuleuven-jobstudent-marketing-communication/page-data.json": [
		"7/gU",
		1647
	],
	"./page-data/en/work-at-imec/job-opportunities/non-classical-catalysis-methodologies-for-the-electrochemical-reduction-of-co2-to-valuable-chemicals/page-data.json": [
		"vZcr",
		1648
	],
	"./page-data/en/work-at-imec/job-opportunities/novel-electrode-architectures-for-efficient-electrosynthesis-of-valuable-fuels-from-co2-and-water/page-data.json": [
		"3BLr",
		1649
	],
	"./page-data/en/work-at-imec/job-opportunities/nowmax-java-kotlin-backend-developer/page-data.json": [
		"B4PJ",
		1650
	],
	"./page-data/en/work-at-imec/job-opportunities/nowmax-sales-manager/page-data.json": [
		"OJMK",
		1651
	],
	"./page-data/en/work-at-imec/job-opportunities/office-manager-ft-or-80-for-nerf/page-data.json": [
		"R335",
		1652
	],
	"./page-data/en/work-at-imec/job-opportunities/on-chip-machine-learning-with-hybrid-ai-models/page-data.json": [
		"fJdK",
		1653
	],
	"./page-data/en/work-at-imec/job-opportunities/on-hertz-front-end-developer/page-data.json": [
		"T7vN",
		1654
	],
	"./page-data/en/work-at-imec/job-opportunities/on-hertz-full-stack-developer-m-f-d/page-data.json": [
		"2OoK",
		1655
	],
	"./page-data/en/work-at-imec/job-opportunities/on-hertz-full-stack-developer/page-data.json": [
		"5H2A",
		1656
	],
	"./page-data/en/work-at-imec/job-opportunities/onlinewerkrooster-be-head-of-sales-m-v/page-data.json": [
		"XG0U",
		1657
	],
	"./page-data/en/work-at-imec/job-opportunities/operations-coordinator-imec-icon/page-data.json": [
		"i0+l",
		1658
	],
	"./page-data/en/work-at-imec/job-opportunities/operations-team-member/page-data.json": [
		"IF3j",
		1659
	],
	"./page-data/en/work-at-imec/job-opportunities/optical-designer_2/page-data.json": [
		"VGPv",
		1660
	],
	"./page-data/en/work-at-imec/job-opportunities/optical-sensing-researcher-oneplanet-research-center-copy/page-data.json": [
		"nzJl",
		1661
	],
	"./page-data/en/work-at-imec/job-opportunities/optical-sensing-researcher-oneplanet-research-center/page-data.json": [
		"jeGe",
		1662
	],
	"./page-data/en/work-at-imec/job-opportunities/optimization-of-ferroelectric-memory-cells-for-next-generation-scm_2/page-data.json": [
		"TK7N",
		1663
	],
	"./page-data/en/work-at-imec/job-opportunities/organometallic-photoresists-for-advanced-extreme-ultraviolet-lithography-euvl/page-data.json": [
		"c+5x",
		1664
	],
	"./page-data/en/work-at-imec/job-opportunities/otiv-software-developer/page-data.json": [
		"SQJM",
		1665
	],
	"./page-data/en/work-at-imec/job-opportunities/outdoor-measurements-of-thermal-and-wind-effects-for-photovoltaic-modules/page-data.json": [
		"85ji",
		1666
	],
	"./page-data/en/work-at-imec/job-opportunities/page-data.json": [
		"/TFF",
		1667
	],
	"./page-data/en/work-at-imec/job-opportunities/paralegal-sales-support-administrator-oneplanet-research-center/page-data.json": [
		"9NLZ",
		1668
	],
	"./page-data/en/work-at-imec/job-opportunities/part-time-management-assistant-belgian-office-yess-technologies/page-data.json": [
		"4b+o",
		1669
	],
	"./page-data/en/work-at-imec/job-opportunities/patent-information-officer/page-data.json": [
		"sJji",
		1670
	],
	"./page-data/en/work-at-imec/job-opportunities/phd-at-imec/page-data.json": [
		"JtVi",
		1671
	],
	"./page-data/en/work-at-imec/job-opportunities/phd-data-driven-and-ai-based-control-of-hvac-and-chemical-systems/page-data.json": [
		"DzJR",
		1672
	],
	"./page-data/en/work-at-imec/job-opportunities/phd-fellowship-in-microbial-systems-genetics/page-data.json": [
		"zIKa",
		1673
	],
	"./page-data/en/work-at-imec/job-opportunities/phd-fellowship-in-verifiable-and-elastic-wireless-communication-infrastructures/page-data.json": [
		"B8rL",
		1674
	],
	"./page-data/en/work-at-imec/job-opportunities/phd-fellowship-network-analysis-for-precision-oncology/page-data.json": [
		"Lo/5",
		1675
	],
	"./page-data/en/work-at-imec/job-opportunities/phd-on-real-time-closed-loop-control-for-robotic-grasping/page-data.json": [
		"hIk+",
		1676
	],
	"./page-data/en/work-at-imec/job-opportunities/phd-position-on-machine-learning-based-design-of-high-frequency-circuits-and-systems/page-data.json": [
		"bwX/",
		1677
	],
	"./page-data/en/work-at-imec/job-opportunities/phd-position-on-yield-and-variability-optimization-of-integrated-circuits-using-machine-learning/page-data.json": [
		"nZOd",
		1678
	],
	"./page-data/en/work-at-imec/job-opportunities/phd-researcher-software-for-high-performance-networks-clouds/page-data.json": [
		"/WBU",
		1679
	],
	"./page-data/en/work-at-imec/job-opportunities/phd-student-on-online-learning-for-robot-perception/page-data.json": [
		"lUAs",
		1680
	],
	"./page-data/en/work-at-imec/job-opportunities/phd-student-on-real-time-deep-learning-for-robot-control/page-data.json": [
		"II+v",
		1681
	],
	"./page-data/en/work-at-imec/job-opportunities/phd-vacancy-for-machine-learning-for-neurofeedback-applications/page-data.json": [
		"xkf3",
		1682
	],
	"./page-data/en/work-at-imec/job-opportunities/photo-acoustic-spectroscopy-for-subsurface-molecular-detection/page-data.json": [
		"1f9t",
		1683
	],
	"./page-data/en/work-at-imec/job-opportunities/photonic-chip-floor-plan-automation-intern-2020-summer/page-data.json": [
		"gFKH",
		1684
	],
	"./page-data/en/work-at-imec/job-opportunities/physical-design-layout-and-pdk-engineer/page-data.json": [
		"GcDA",
		1685
	],
	"./page-data/en/work-at-imec/job-opportunities/piesync-devops-engineer/page-data.json": [
		"wY1u",
		1686
	],
	"./page-data/en/work-at-imec/job-opportunities/piesync-digital-content-marketeer/page-data.json": [
		"3rYU",
		1687
	],
	"./page-data/en/work-at-imec/job-opportunities/piesync-integration-engineer/page-data.json": [
		"4TN7",
		1688
	],
	"./page-data/en/work-at-imec/job-opportunities/piesync-platform-engineer-haskell/page-data.json": [
		"ffFg",
		1689
	],
	"./page-data/en/work-at-imec/job-opportunities/planning-coordinator/page-data.json": [
		"OD+L",
		1690
	],
	"./page-data/en/work-at-imec/job-opportunities/planopsim-full-stack-developer-python-react-js/page-data.json": [
		"qAli",
		1691
	],
	"./page-data/en/work-at-imec/job-opportunities/play-it-safe-internship-frontend-web-developer/page-data.json": [
		"LGAY",
		1692
	],
	"./page-data/en/work-at-imec/job-opportunities/play-it-safe-internships-in-marketing-sales/page-data.json": [
		"861r",
		1693
	],
	"./page-data/en/work-at-imec/job-opportunities/play-it-safe-sales-manager-director/page-data.json": [
		"o6DN",
		1694
	],
	"./page-data/en/work-at-imec/job-opportunities/post-doc-in-advanced-photoemission-peem-arpes-time-resolved-for-semicon-materials-characterisation/page-data.json": [
		"unZw",
		1695
	],
	"./page-data/en/work-at-imec/job-opportunities/post-doc-performance-optimization-of-gan-ic-technology/page-data.json": [
		"5MTD",
		1696
	],
	"./page-data/en/work-at-imec/job-opportunities/post-doc-superconducting-qubits-fabrication/page-data.json": [
		"QLhQ",
		1697
	],
	"./page-data/en/work-at-imec/job-opportunities/post-doc-the-role-of-mechanical-stress-in-aging-of-advanced-cmos-devices/page-data.json": [
		"MgAg",
		1698
	],
	"./page-data/en/work-at-imec/job-opportunities/postdoc-at-imec/page-data.json": [
		"H8wz",
		1699
	],
	"./page-data/en/work-at-imec/job-opportunities/postdoc-integrated-deep-learning/page-data.json": [
		"po11",
		1700
	],
	"./page-data/en/work-at-imec/job-opportunities/postdoc-researcher-euv-photoresist-roughness-mitigation-for-advanced-logic-and-memory-patterning/page-data.json": [
		"53TJ",
		1701
	],
	"./page-data/en/work-at-imec/job-opportunities/postdoc-researcher-micromagnetic-modelling-of-next-generation-magnetic-memories/page-data.json": [
		"cTwF",
		1702
	],
	"./page-data/en/work-at-imec/job-opportunities/postdoc-researcher-study-of-highly-scaled-igzo-transistors-for-memory-applications/page-data.json": [
		"S2iz",
		1703
	],
	"./page-data/en/work-at-imec/job-opportunities/postdoc-spin-logic-benchmarking/page-data.json": [
		"autW",
		1704
	],
	"./page-data/en/work-at-imec/job-opportunities/postdoctoral-researcher-direct-growth-of-2d-materials-on-temperature-sensitive-device-architectures/page-data.json": [
		"uTHU",
		1705
	],
	"./page-data/en/work-at-imec/job-opportunities/postdoctoral-researcher-efficient-hardware-spike-detection-and-data-compression-for-next-generation/page-data.json": [
		"e5Yn",
		1706
	],
	"./page-data/en/work-at-imec/job-opportunities/postdoctoral-researcher-experimental-evaluation-of-nanopore-devices-for-protein-analysis/page-data.json": [
		"HMRl",
		1707
	],
	"./page-data/en/work-at-imec/job-opportunities/postdoctoral-researcher-exploration-of-compute-near-storage/page-data.json": [
		"q7Yg",
		1708
	],
	"./page-data/en/work-at-imec/job-opportunities/postdoctoral-researcher-in-atom-probe-tomography/page-data.json": [
		"HKT9",
		1709
	],
	"./page-data/en/work-at-imec/job-opportunities/postdoctoral-researcher-in-system-technology-co-optimization/page-data.json": [
		"PHoE",
		1710
	],
	"./page-data/en/work-at-imec/job-opportunities/postdoctoral-researcher-microfluidics-modeling-using-surface-energy-minimization-based-approach/page-data.json": [
		"W/rI",
		1711
	],
	"./page-data/en/work-at-imec/job-opportunities/postdoctoral-researcher-mm-wave-imaging-radar/page-data.json": [
		"7EYA",
		1712
	],
	"./page-data/en/work-at-imec/job-opportunities/postdoctoral-researcher-modeling-of-nonlinear-behavior-of-pzt-micro-actuator/page-data.json": [
		"biuq",
		1713
	],
	"./page-data/en/work-at-imec/job-opportunities/postdoctoral-researcher-monolithic-iii-v-lasers-on-si-for-swir-sensing-applications/page-data.json": [
		"SnzU",
		1714
	],
	"./page-data/en/work-at-imec/job-opportunities/postdoctoral-researcher-nanofluidic-memory/page-data.json": [
		"OUiS",
		1715
	],
	"./page-data/en/work-at-imec/job-opportunities/postdoctoral-researcher-non-planar-integrated-photovoltaic-electrochemical-systems/page-data.json": [
		"2nhb",
		1716
	],
	"./page-data/en/work-at-imec/job-opportunities/postdoctoral-researcher-on-flat-optics-by-nanoimprint-lithography/page-data.json": [
		"Mmfc",
		1717
	],
	"./page-data/en/work-at-imec/job-opportunities/postdoctoral-researcher-on-machine-learning-driven-programmable-networks/page-data.json": [
		"oxTS",
		1718
	],
	"./page-data/en/work-at-imec/job-opportunities/postdoctoral-researcher-on-oxide-oxide-cmos-wafer-bonding-for-video-holography/page-data.json": [
		"kxQ5",
		1719
	],
	"./page-data/en/work-at-imec/job-opportunities/postdoctoral-researcher-reliability-and-variability-design-and-technology-co-optimization/page-data.json": [
		"Eojl",
		1720
	],
	"./page-data/en/work-at-imec/job-opportunities/probing-the-electrical-properties-of-metals-at-the-nanometer-scale_2/page-data.json": [
		"BX3j",
		1721
	],
	"./page-data/en/work-at-imec/job-opportunities/proces-operator/page-data.json": [
		"8d2H",
		1722
	],
	"./page-data/en/work-at-imec/job-opportunities/process-assistant-chemical-mechanical-polishing-cmp/page-data.json": [
		"HSjP",
		1723
	],
	"./page-data/en/work-at-imec/job-opportunities/process-engineer-wafer-bonding-and-assembly/page-data.json": [
		"wvHt",
		1724
	],
	"./page-data/en/work-at-imec/job-opportunities/process-engineer/page-data.json": [
		"BHoQ",
		1725
	],
	"./page-data/en/work-at-imec/job-opportunities/process-engineer_2/page-data.json": [
		"4986",
		1726
	],
	"./page-data/en/work-at-imec/job-opportunities/process-engineering-coordinator_2/page-data.json": [
		"Cm50",
		1727
	],
	"./page-data/en/work-at-imec/job-opportunities/process-integration-engineer-gan-ic/page-data.json": [
		"ACPn",
		1728
	],
	"./page-data/en/work-at-imec/job-opportunities/process-integration-engineer_5/page-data.json": [
		"1y25",
		1729
	],
	"./page-data/en/work-at-imec/job-opportunities/product-engineer-image-sensors/page-data.json": [
		"d+lb",
		1730
	],
	"./page-data/en/work-at-imec/job-opportunities/program-manager-nano-imprint-lithography/page-data.json": [
		"/bUq",
		1731
	],
	"./page-data/en/work-at-imec/job-opportunities/program-manager-precision-agriculture-food-oneplanet-research-center/page-data.json": [
		"UdVM",
		1732
	],
	"./page-data/en/work-at-imec/job-opportunities/programmable-multiple-channel-power-source-for-photonic-integrated-circuits-for-advanced-microscopy/page-data.json": [
		"0s57",
		1733
	],
	"./page-data/en/work-at-imec/job-opportunities/project-manager-bouwprojecten_2/page-data.json": [
		"FapR",
		1734
	],
	"./page-data/en/work-at-imec/job-opportunities/projectleider-installaties-en-infrastructuur_2/page-data.json": [
		"Yk5Y",
		1735
	],
	"./page-data/en/work-at-imec/job-opportunities/proteoformix-postdoctoral-position-mass-spectrometry-histo-chemistry-mshc/page-data.json": [
		"rab8",
		1736
	],
	"./page-data/en/work-at-imec/job-opportunities/q1-6-web-app-developer/page-data.json": [
		"rYtC",
		1737
	],
	"./page-data/en/work-at-imec/job-opportunities/quality-assurance-specialist/page-data.json": [
		"tO3v",
		1738
	],
	"./page-data/en/work-at-imec/job-opportunities/quantitative-3d-mapping-of-carrier-concentration-in-quantum-confined-heterostructures-for-power-and-rf-applications/page-data.json": [
		"wTLT",
		1739
	],
	"./page-data/en/work-at-imec/job-opportunities/r-d-engineer-bonding-transfer-and-assembly/page-data.json": [
		"i7hY",
		1740
	],
	"./page-data/en/work-at-imec/job-opportunities/r-d-engineer-transition-metal-dichalchogenide-deposition-and-material-specialist/page-data.json": [
		"0NHw",
		1741
	],
	"./page-data/en/work-at-imec/job-opportunities/r-d-engineer-wet-clean-processing/page-data.json": [
		"3A+9",
		1742
	],
	"./page-data/en/work-at-imec/job-opportunities/r-d-etch-specialist/page-data.json": [
		"mZaH",
		1743
	],
	"./page-data/en/work-at-imec/job-opportunities/r-d-manager-for-connectivity-and-cognitive-sensing/page-data.json": [
		"ccIv",
		1744
	],
	"./page-data/en/work-at-imec/job-opportunities/r-d-manager-logic-feol-integration/page-data.json": [
		"FBwd",
		1745
	],
	"./page-data/en/work-at-imec/job-opportunities/r-d-manager-signal-processing-group-imec-the-netherlands/page-data.json": [
		"dHZL",
		1746
	],
	"./page-data/en/work-at-imec/job-opportunities/r-d-metrology-engineer/page-data.json": [
		"X4Su",
		1747
	],
	"./page-data/en/work-at-imec/job-opportunities/r-d-sims-engineer/page-data.json": [
		"vZmn",
		1748
	],
	"./page-data/en/work-at-imec/job-opportunities/r-d-team-leader/page-data.json": [
		"PVaU",
		1749
	],
	"./page-data/en/work-at-imec/job-opportunities/rapid-prototyping-platform-to-enable-scalable-single-cell-multi-omics-technologies/page-data.json": [
		"Wbqq",
		1750
	],
	"./page-data/en/work-at-imec/job-opportunities/recruitment-assistant-interim/page-data.json": [
		"IJpH",
		1751
	],
	"./page-data/en/work-at-imec/job-opportunities/reliability-characterization-and-modelling-of-gan-rf-devices/page-data.json": [
		"MU55",
		1752
	],
	"./page-data/en/work-at-imec/job-opportunities/reliability-physics-based-hardware-primitives-for-tamper-free-cryptographic-applications/page-data.json": [
		"/zxg",
		1753
	],
	"./page-data/en/work-at-imec/job-opportunities/research-engineer-micro-fluidic-system-design/page-data.json": [
		"e8m7",
		1754
	],
	"./page-data/en/work-at-imec/job-opportunities/researcher-analog-ic-design-engineer-for-next-generation-ingestible-electronics/page-data.json": [
		"/0KY",
		1755
	],
	"./page-data/en/work-at-imec/job-opportunities/researcher-broadband-analog-integrated-circuits-for-next-generation-optical-transceivers/page-data.json": [
		"Q/JR",
		1756
	],
	"./page-data/en/work-at-imec/job-opportunities/researcher-cmos-based-analog-and-mixed-signal-integrated-circuits-for-gt-100gbaud-optical-transce/page-data.json": [
		"94iQ",
		1757
	],
	"./page-data/en/work-at-imec/job-opportunities/researcher-computational-imaging/page-data.json": [
		"aDH5",
		1758
	],
	"./page-data/en/work-at-imec/job-opportunities/researcher-exploratory-patterning-materials/page-data.json": [
		"yw3N",
		1759
	],
	"./page-data/en/work-at-imec/job-opportunities/researcher-for-artificial-intelligence-with-a-focus-on-recommender-systems/page-data.json": [
		"VMeg",
		1760
	],
	"./page-data/en/work-at-imec/job-opportunities/researcher-for-electromagnetic-entomology/page-data.json": [
		"Mls1",
		1761
	],
	"./page-data/en/work-at-imec/job-opportunities/researcher-for-indoor-location-tracking-using-wireless-iot-technology-and-visible-light-positioning/page-data.json": [
		"hSFe",
		1762
	],
	"./page-data/en/work-at-imec/job-opportunities/researcher-for-virtual-system-platform-development/page-data.json": [
		"SlC6",
		1763
	],
	"./page-data/en/work-at-imec/job-opportunities/researcher-for-wireless-body-area-networks-wban-human-exposure-for-smart-lenses/page-data.json": [
		"4qrm",
		1764
	],
	"./page-data/en/work-at-imec/job-opportunities/researcher-in-pv-and-solar-to-molecule-device-modelling/page-data.json": [
		"Oexi",
		1765
	],
	"./page-data/en/work-at-imec/job-opportunities/researcher-materials-characterization/page-data.json": [
		"BTDL",
		1766
	],
	"./page-data/en/work-at-imec/job-opportunities/researcher-quantum-magnetometry/page-data.json": [
		"0YdB",
		1767
	],
	"./page-data/en/work-at-imec/job-opportunities/researcher-solid-state-batteries/page-data.json": [
		"hHOV",
		1768
	],
	"./page-data/en/work-at-imec/job-opportunities/researcher-terabit-capable-coherent-optical-links-and-transceivers/page-data.json": [
		"qs5i",
		1769
	],
	"./page-data/en/work-at-imec/job-opportunities/sap-solution-architect/page-data.json": [
		"JW/U",
		1770
	],
	"./page-data/en/work-at-imec/job-opportunities/sar-radar-and-slam-for-robotics/page-data.json": [
		"k3t7",
		1771
	],
	"./page-data/en/work-at-imec/job-opportunities/scientific-director-ai/page-data.json": [
		"jIMm",
		1772
	],
	"./page-data/en/work-at-imec/job-opportunities/seaters-account-coordinator/page-data.json": [
		"vsW5",
		1773
	],
	"./page-data/en/work-at-imec/job-opportunities/sem-tem-engineer_2/page-data.json": [
		"juYY",
		1774
	],
	"./page-data/en/work-at-imec/job-opportunities/senior-analog-design-engineer-image-sensor_2/page-data.json": [
		"O/0C",
		1775
	],
	"./page-data/en/work-at-imec/job-opportunities/senior-analog-design-engineer/page-data.json": [
		"sl95",
		1776
	],
	"./page-data/en/work-at-imec/job-opportunities/senior-electronic-system-engineer-oneplanet-research-center/page-data.json": [
		"U1ef",
		1777
	],
	"./page-data/en/work-at-imec/job-opportunities/senior-general-ledger-accountant-80-of-fulltime/page-data.json": [
		"q55P",
		1778
	],
	"./page-data/en/work-at-imec/job-opportunities/senior-integration-engineer-wafer-services/page-data.json": [
		"DqUg",
		1779
	],
	"./page-data/en/work-at-imec/job-opportunities/senior-manager-fab-process-engineering/page-data.json": [
		"XcRM",
		1780
	],
	"./page-data/en/work-at-imec/job-opportunities/senior-pixel-device-engineer/page-data.json": [
		"JCAS",
		1781
	],
	"./page-data/en/work-at-imec/job-opportunities/senior-process-engineer-metrology/page-data.json": [
		"xfEB",
		1782
	],
	"./page-data/en/work-at-imec/job-opportunities/senior-process-integration-engineer_2/page-data.json": [
		"ZmT4",
		1783
	],
	"./page-data/en/work-at-imec/job-opportunities/senior-process-integration-engineer_3/page-data.json": [
		"cmql",
		1784
	],
	"./page-data/en/work-at-imec/job-opportunities/senior-research-engineer-radio-systems/page-data.json": [
		"4wBW",
		1785
	],
	"./page-data/en/work-at-imec/job-opportunities/senior-researcher-imaging-systems_2/page-data.json": [
		"9lEB",
		1786
	],
	"./page-data/en/work-at-imec/job-opportunities/sensor-application-engineer_2/page-data.json": [
		"uCId",
		1787
	],
	"./page-data/en/work-at-imec/job-opportunities/sensor-researcher/page-data.json": [
		"eK1N",
		1788
	],
	"./page-data/en/work-at-imec/job-opportunities/serial-interface-optimized-for-neural-probes/page-data.json": [
		"seFG",
		1789
	],
	"./page-data/en/work-at-imec/job-opportunities/shayp-financial-management-intern/page-data.json": [
		"rIkr",
		1790
	],
	"./page-data/en/work-at-imec/job-opportunities/shayp-internship-business-sales-marketing/page-data.json": [
		"fp8U",
		1791
	],
	"./page-data/en/work-at-imec/job-opportunities/shayp-senior-software-developer/page-data.json": [
		"TSnU",
		1792
	],
	"./page-data/en/work-at-imec/job-opportunities/signal-processing-and-machine-learning-for-millimeter-wave-3d-radar-imaging/page-data.json": [
		"gJ0k",
		1793
	],
	"./page-data/en/work-at-imec/job-opportunities/smooved-customer-success-associate-operations-dutch-native-m-f-x/page-data.json": [
		"V3nX",
		1794
	],
	"./page-data/en/work-at-imec/job-opportunities/solar-to-chemicals-integrated-system-modelling/page-data.json": [
		"uVb8",
		1795
	],
	"./page-data/en/work-at-imec/job-opportunities/spacepal-sewermapper-commercial-business-developer/page-data.json": [
		"j20d",
		1796
	],
	"./page-data/en/work-at-imec/job-opportunities/spacepal-sewermapper-fullstack-developer/page-data.json": [
		"HLtb",
		1797
	],
	"./page-data/en/work-at-imec/job-opportunities/spacepal-sewermapper-internships-commercial-marketing-hr-management/page-data.json": [
		"3Dog",
		1798
	],
	"./page-data/en/work-at-imec/job-opportunities/spacepal-sewermapper-software-engineer-fullstack/page-data.json": [
		"6VvK",
		1799
	],
	"./page-data/en/work-at-imec/job-opportunities/specialist-automatisatie-gbs/page-data.json": [
		"Sx5x",
		1800
	],
	"./page-data/en/work-at-imec/job-opportunities/student-project-a-first-step-towards-a-replaceable-kidney-fluid-balance-using-wearable-sensor-tech/page-data.json": [
		"av3c",
		1801
	],
	"./page-data/en/work-at-imec/job-opportunities/student-project-asynchronous-adc-design-for-neuromorphic-systems/page-data.json": [
		"Mrvl",
		1802
	],
	"./page-data/en/work-at-imec/job-opportunities/student-project-body-temperature-sensor-validation/page-data.json": [
		"uA2U",
		1803
	],
	"./page-data/en/work-at-imec/job-opportunities/student-project-brain-inspired-compressed-inference-for-event-driven-neuromorphic-processors/page-data.json": [
		"5z8M",
		1804
	],
	"./page-data/en/work-at-imec/job-opportunities/student-project-design-and-layout-of-an-integrated-control-for-multi-coil-inductive-power-transmitt/page-data.json": [
		"vIz1",
		1805
	],
	"./page-data/en/work-at-imec/job-opportunities/student-project-full-duplex-front-end-for-fmcw-radar/page-data.json": [
		"/P72",
		1806
	],
	"./page-data/en/work-at-imec/job-opportunities/student-project-miniaturized-mm-scale-rf-transceiver-system-for-implantable-applications/page-data.json": [
		"iNyn",
		1807
	],
	"./page-data/en/work-at-imec/job-opportunities/student-project-network-on-chip-for-scalable-neuromorphic-processor-in-fpga/page-data.json": [
		"aTlz",
		1808
	],
	"./page-data/en/work-at-imec/job-opportunities/student-project-neuromorphic-compressed-sensing-and-even-based-transmission/page-data.json": [
		"CjAA",
		1809
	],
	"./page-data/en/work-at-imec/job-opportunities/student-project-towards-real-time-monitoring-of-blood-dialysis-in-chronic-kidney-disease/page-data.json": [
		"C9aL",
		1810
	],
	"./page-data/en/work-at-imec/job-opportunities/student-project-ulp-transceiver-design-for-ultra-wideband-ranging-and-radar-applications/page-data.json": [
		"uH6b",
		1811
	],
	"./page-data/en/work-at-imec/job-opportunities/student-project-uwb-signal-processing-for-combined-ranging-and-radar/page-data.json": [
		"fXha",
		1812
	],
	"./page-data/en/work-at-imec/job-opportunities/study-of-high-aspect-ratio-gate-etching-profile-for-finfet-variants/page-data.json": [
		"Cuh2",
		1813
	],
	"./page-data/en/work-at-imec/job-opportunities/surface-passivation-of-cigs-solar-cell-devices/page-data.json": [
		"vt9z",
		1814
	],
	"./page-data/en/work-at-imec/job-opportunities/system-architecture-exploration-for-ai-accelerator-platforms/page-data.json": [
		"jI81",
		1815
	],
	"./page-data/en/work-at-imec/job-opportunities/system-on-chip-soc-design-researcher/page-data.json": [
		"oNlm",
		1816
	],
	"./page-data/en/work-at-imec/job-opportunities/system-technology-co-optimization-for-imec-technology-solutions/page-data.json": [
		"OwZW",
		1817
	],
	"./page-data/en/work-at-imec/job-opportunities/system-technology-co-optimization-techniques-for-high-performance-computing/page-data.json": [
		"GoC+",
		1818
	],
	"./page-data/en/work-at-imec/job-opportunities/systems-architect/page-data.json": [
		"DBQw",
		1819
	],
	"./page-data/en/work-at-imec/job-opportunities/t-mining-business-analyst-presales-engineer/page-data.json": [
		"MPF7",
		1820
	],
	"./page-data/en/work-at-imec/job-opportunities/t-mining-junior-software-core-developer-blockchain/page-data.json": [
		"2IAr",
		1821
	],
	"./page-data/en/work-at-imec/job-opportunities/t-mining-junior-software-developer-blockchain/page-data.json": [
		"WuUE",
		1822
	],
	"./page-data/en/work-at-imec/job-opportunities/t-mining-junior-software-developer-frontend/page-data.json": [
		"jmDm",
		1823
	],
	"./page-data/en/work-at-imec/job-opportunities/t-mining-master-thesis-internships-or-traineeship/page-data.json": [
		"49x8",
		1824
	],
	"./page-data/en/work-at-imec/job-opportunities/t-mining-product-manager/page-data.json": [
		"fNzc",
		1825
	],
	"./page-data/en/work-at-imec/job-opportunities/team-leader-litho-process-development/page-data.json": [
		"S9h6",
		1826
	],
	"./page-data/en/work-at-imec/job-opportunities/technical-assistant-for-wet-clean-processing/page-data.json": [
		"U+RE",
		1827
	],
	"./page-data/en/work-at-imec/job-opportunities/technology-development-of-pv-modules-towards-vehicle-integration/page-data.json": [
		"HLYj",
		1828
	],
	"./page-data/en/work-at-imec/job-opportunities/technology-platforms-r-d-project-manager/page-data.json": [
		"uqlV",
		1829
	],
	"./page-data/en/work-at-imec/job-opportunities/tem-engineer_2/page-data.json": [
		"10cF",
		1830
	],
	"./page-data/en/work-at-imec/job-opportunities/thermo-mechanical-simulation-of-integrated-pv-modules/page-data.json": [
		"kAoI",
		1831
	],
	"./page-data/en/work-at-imec/job-opportunities/thin-perfect-absorbers-on-top-of-cmos/page-data.json": [
		"G4jh",
		1832
	],
	"./page-data/en/work-at-imec/job-opportunities/time-resolved-ir-and-photoemission-studies-of-euv-matter-interactions/page-data.json": [
		"Gyjr",
		1833
	],
	"./page-data/en/work-at-imec/job-opportunities/towards-two-dimensional-transition-metal-dichalcogenides-with-manufacturing-compatible-quality/page-data.json": [
		"wLPR",
		1834
	],
	"./page-data/en/work-at-imec/job-opportunities/transparent-conductive-oxide-tco-and-nc-si-thin-film-development-for-use-in-2-terminal-si-heterojunction-perovskite-tandem-solar-cells/page-data.json": [
		"dexh",
		1835
	],
	"./page-data/en/work-at-imec/job-opportunities/treespoke-commercial-interior-architect/page-data.json": [
		"X7A6",
		1836
	],
	"./page-data/en/work-at-imec/job-opportunities/treespoke-cto-full-stack-developer/page-data.json": [
		"XV4W",
		1837
	],
	"./page-data/en/work-at-imec/job-opportunities/treespoke-digital-marketeer-growth-hacker/page-data.json": [
		"GF73",
		1838
	],
	"./page-data/en/work-at-imec/job-opportunities/treespoke-marketeer-internship/page-data.json": [
		"G4lI",
		1839
	],
	"./page-data/en/work-at-imec/job-opportunities/ultra-high-band-gap-transparent-solar-cells/page-data.json": [
		"E08H",
		1840
	],
	"./page-data/en/work-at-imec/job-opportunities/ultra-low-power-always-on-body-sounds-acoustic-machine-learning-processor-chips-for-respiratory-disease-detection/page-data.json": [
		"OT0q",
		1841
	],
	"./page-data/en/work-at-imec/job-opportunities/ultrasound-design-and-characterization-engineer/page-data.json": [
		"TFU/",
		1842
	],
	"./page-data/en/work-at-imec/job-opportunities/ultrathin-ferroelectric-complex-oxides/page-data.json": [
		"V9LP",
		1843
	],
	"./page-data/en/work-at-imec/job-opportunities/uman-ai-it-internship/page-data.json": [
		"2llD",
		1844
	],
	"./page-data/en/work-at-imec/job-opportunities/uman-ai-ux-ui-design-internship/page-data.json": [
		"dRNH",
		1845
	],
	"./page-data/en/work-at-imec/job-opportunities/understanding-sliding-contacts-at-the-nanoscale-using-scalpel-spm/page-data.json": [
		"UEPx",
		1846
	],
	"./page-data/en/work-at-imec/job-opportunities/understanding-the-effect-of-defects-on-the-performance-of-2d-materials/page-data.json": [
		"Y/78",
		1847
	],
	"./page-data/en/work-at-imec/job-opportunities/venture-acceleration-manager/page-data.json": [
		"IAWk",
		1848
	],
	"./page-data/en/work-at-imec/job-opportunities/viloc-developer/page-data.json": [
		"C7Ij",
		1849
	],
	"./page-data/en/work-at-imec/job-opportunities/voltage-controlled-magnetic-anisotropy-mram-above-ghz-operation-with-ultra-low-power-consumption/page-data.json": [
		"/Jjv",
		1850
	],
	"./page-data/en/work-at-imec/job-opportunities/wegroup-deal-sealer/page-data.json": [
		"JePl",
		1851
	],
	"./page-data/en/work-at-imec/job-opportunities/wegroup-front-end-developer/page-data.json": [
		"hg4I",
		1852
	],
	"./page-data/en/work-at-imec/job-opportunities/wet-chemical-atomic-layer-etching-of-metals-for-advanced-chip-interconnects/page-data.json": [
		"KpsW",
		1853
	],
	"./page-data/en/work-at-imec/job-opportunities/wireless-brain-monitoring-stimulation-tools-to-investigate-neurodegenerative-diseases/page-data.json": [
		"r108",
		1854
	],
	"./page-data/en/work-at-imec/job-opportunities/wireless-data-transmission-for-neural-probes/page-data.json": [
		"JIzp",
		1855
	],
	"./page-data/en/work-at-imec/master-thesis-internship/page-data.json": [
		"T1Rq",
		1856
	],
	"./page-data/en/work-at-imec/testimonials/page-data.json": [
		"RTd5",
		1857
	],
	"./page-data/en/xpand/page-data.json": [
		"E9+3",
		1858
	],
	"./page-data/previewpage/page-data.json": [
		"PviK",
		1859
	],
	"./static/d/1015369515.json": [
		"cnYb",
		1860
	],
	"./static/d/1188402735.json": [
		"LuOg"
	],
	"./static/d/1305784165.json": [
		"T9EI",
		1861
	],
	"./static/d/1344994804.json": [
		"S8KG",
		1862
	],
	"./static/d/1544383661.json": [
		"rs8Q",
		1863
	],
	"./static/d/1801597966.json": [
		"9l9l"
	],
	"./static/d/1812709129.json": [
		"gjQo",
		1864
	],
	"./static/d/1846438550.json": [
		"On+g",
		1865
	],
	"./static/d/1927255683.json": [
		"4bIO",
		1866
	],
	"./static/d/199417016.json": [
		"M+0r",
		1867
	],
	"./static/d/2028780156.json": [
		"Px77",
		1868
	],
	"./static/d/2129849414.json": [
		"yo7g",
		1869
	],
	"./static/d/2322768674.json": [
		"vRMi"
	],
	"./static/d/233789868.json": [
		"SuT7",
		1870
	],
	"./static/d/2405956670.json": [
		"ThtX"
	],
	"./static/d/2440462871.json": [
		"OWqv"
	],
	"./static/d/2595976701.json": [
		"T9/j"
	],
	"./static/d/266756410.json": [
		"KesG"
	],
	"./static/d/2770407855.json": [
		"C/MS"
	],
	"./static/d/2796779649.json": [
		"k5OF",
		1871
	],
	"./static/d/2837987153.json": [
		"aKUG",
		1872
	],
	"./static/d/2902953316.json": [
		"Xl13",
		1873
	],
	"./static/d/3026200106.json": [
		"yDYG"
	],
	"./static/d/3341980786.json": [
		"7eNi"
	],
	"./static/d/3403240549.json": [
		"Vvjp",
		1874
	],
	"./static/d/3520507834.json": [
		"KceN",
		1875
	],
	"./static/d/3566978172.json": [
		"hLes",
		1876
	],
	"./static/d/3759982702.json": [
		"Q8+q"
	],
	"./static/d/3812001880.json": [
		"6eum",
		1877
	],
	"./static/d/384136038.json": [
		"Oam6",
		1878
	],
	"./static/d/3870274999.json": [
		"rivA",
		1879
	],
	"./static/d/403627237.json": [
		"kja1",
		1880
	],
	"./static/d/407681813.json": [
		"wsV5",
		1881
	],
	"./static/d/41558043.json": [
		"sZ0p",
		1882
	],
	"./static/d/4282603048.json": [
		"+LRB"
	],
	"./static/d/547706224.json": [
		"7Rzb",
		1883
	],
	"./static/d/602939526.json": [
		"dP18"
	],
	"./static/d/715448751.json": [
		"AJ4Y",
		1884
	],
	"./static/d/729110846.json": [
		"JWKo",
		1885
	],
	"./static/d/742902628.json": [
		"GFCA",
		1886
	],
	"./static/d/759472323.json": [
		"LRty",
		1887
	],
	"./static/d/76447584.json": [
		"HInF",
		1888
	],
	"./static/d/975617089.json": [
		"LKGY"
	],
	"./webpack.stats.json": [
		"Y32t",
		1889
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "HNtP";
module.exports = webpackAsyncContext;